import React, { Component } from 'react';
import {
    Layout, Page, Button, Modal, BlockStack, Card, Collapsible, Icon, Text, TextField, Tooltip, Link,
} from '@shopify/polaris';
import { withRouter } from 'react-router-dom';
import 'react-circular-progressbar/dist/styles.css';
import { ChevronDownIcon, ChevronUpIcon } from "@shopify/polaris-icons";
import './index.css';
import './index.scss';
import SkeltonLoading from "../../../../components/SkeltonLoading";
import {
    reqGetNewUserPricingPlanList,
    reqGetSubscription,
    reqGetSubscriptionCancel,
    reqUpdateUserPricingPlan,
    reqPlanConversion,
    reqGetPricingCouponData,
    reqGetSiteSpeedUp,
    reqSaveSwitchState,
    reqReviewTipsClick,
    reqGetCouponOffer,
} from '../../../../api';
import { connect } from 'react-redux'
import { setPlanPageViews, setPublicData, setSaveSwitchData } from '../../../../redux/actions/getAppPublicData';
import { setPageData } from '../../../../redux/actions/getAppPageData';
import utils from '../../../../utils/utils';
import Language from '../../../../i18n/Language';
import cloneDeep from 'lodash-es/cloneDeep';
import FaqCardBox from '../../../../components/FaqCardBox';
import SpeedBasicIcon from '../../../../assets/SpeedUp/SpeedBasicIcon';
import SpeedFastIcon from '../../../../assets/SpeedUp/SpeedFastIcon';
import SpeedRocketIcon from '../../../../assets/SpeedUp/SpeedRocketIcon';
import { store } from '../../../../redux/store';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import { withWindowWidth } from '../../../../components/UseWindowWidth/withWindowWidth';
import DowngradeRetain from '../components/downgradeRetain';
import { cwreport } from '../../../../cw_center/cw-report';
import { transportReport } from '../../../../cw_center/global';
const t = Language;

let premArr = [], promArr = [], preyArr = [], proyArr = [], discountTimeArr = [];
class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingPage: true,
            paidLoading: false,

            //优惠价格方案
            expired_time: '00:00:00',
            milli_second: '00',

            //useType为1 默认显示年费
            userType: 0,

            //价格方案列表
            pricingPlanList: [],

            //按钮点击触发
            onButtonType: 0,

            //点击改变背景颜色状态
            selectId: 0,

            //选中等级
            selectLevel: 0,

            //升降级弹窗
            modalData: {},
            openModalChange: false,
            openModalLoading: false,

            //freePlanDegrade降级弹窗
            openFreePlanDegrade: false,

            //切换套餐提示弹窗（年费扣费后使用时长 < 30 天）
            openSwitchReviewModal: false,
            switchReviewData: {},

            // tab滑块移动动画
            moveAnimation: 1,

            // 价格详细信息按钮状态
            pricingDetailBtnStatus: false,

            // 克隆价格详情对比
            cloneDetailCompare: {},
            clonePricingPlanList: {},

            // 是否开启sticky粘性布局
            isSticky: false,

            // 监听页面宽度
            wInnerWidth: window.innerWidth,

            // 对应套餐版本
            prePlanTitle: 'Pre Plan',
            proPlanTitle: 'Pro Plan',
            freePlanTitle: 'Free',

            // pro pre套餐id
            prePlanId: '-',
            proPlanId: '-',
            freePlanId: '-',

            // pre pro free 套餐价格
            prePlanPrice: 0,
            prePlanDiscountPrice: 0,
            proPlanPrice: 0,
            proPlanDiscountPrice: 0,
            freePlanPrice: 0,

            // pre 按钮状态 + 文字
            prePlanBtnStatus: 0, // 0不可见 1UPGREADE 2RENEWAL 3DEGRADE
            // pro 按钮状态 + 文字
            proPlanBtnStatus: 0, // 0不可见 1UPGREADE 2RENEWAL 3DEGRADE
            // free 按钮状态 + 文字
            freePlanBtnStatus: 0, // 0不可见 1UPGREADE 2RENEWAL 3DEGRADE
            language: 'en',
            pricingData: {}, // 价格页套餐总数据
            userInfo: {},
            old_button: 0, // 是否旧版付费用户
            services: {},  // 等级特性
            // Instant Page
            // Instant Page

            // JSON-LD
            // Google Structured Data - Snippets

            // Local Business
            // Local Business
            pricingStateArr: [
                "", "Pre plan", "Pro plan", "Free plan"
            ],
            isShowPricingState: false,
            oldPayModalStatus: false,
            paidDisabled: false, // 按钮置灰
            paidBtnLoading: '',
            preVersionLevel: '',
            proVersionLevel: '',
            isPreJump: false, // 是否提示pre版本

            isMonthOrYear: 1, // 默认选择月
            preDiscountPrice: 0, // pre优惠活动价
            proDiscountPrice: 0, // pro优惠活动价
            preMonthCountDown: 0, // pre 优惠活动倒计时
            proMonthCountDown: 0, // pro 优惠活动倒计时
            preMonthCountDown_mills: 0, // pre 优惠活动倒计时
            proMonthCountDown_mills: 0, // pro 优惠活动倒计时
            preYearCountDown: 0, // pre 优惠活动倒计时
            proYearCountDown: 0, // pro 优惠活动倒计时
            preYearCountDown_mills: 0, // pre 优惠活动倒计时
            proYearCountDown_mills: 0, // pro 优惠活动倒计时
            preMonthPeriod: 0, // pre折扣周期
            proMonthPeriod: 0, // pro折扣周期
            preYearPeriod: 0, // pre折扣周期
            proYearPeriod: 0, // pro折扣周期

            userAvator: ['user1', 'user2', 'user3', 'user4', 'user5'], // 用户头像
            logoIcon: ['shein', 'dj', 'banggood', 'medifyair', 'luxskin', 'relx'], // logo
            FreeTrialStatus: true,
            BillingCycleStatus: true,
            discountVal: '',
            discountValError: '',
            disBtnLoading: false, // 折扣码按钮loading
            isShowDisTicket: false,
            discountRate: 1,
            discountPlan: '',
            preMRecode: '', // 折扣码
            proMRecode: '',
            preYRecode: '',
            proYRecode: '',

            isShowExtraGift: false,
            appGiftList: {
                "Trustoo": {
                    title: "Trustoo Product & Ali Reviews",
                    desc: "Import products reviews from Ali and Amazon",
                    price: 20,
                    img: '/imgs/extra_app/Trustoo.png',
                    tip: "Contact Trustoo's 24/7 customer service to get it for free.",
                    url: 'https://share.channelwill.com/app/21657ab1f4e2d70ixV'
                },
                "Loyalty": {
                    title: "LL: Loyalty Rewards Referrals",
                    desc: "Boost sales with loyalty rewards & referral programs.",
                    price: 69,
                    img: '/imgs/extra_app/Loyalty.png',
                    tip: "Contact Loyalty's 24/7 customer service to get it for free.",
                    url: 'https://share.channelwill.com/app/3365704d41c93515ho'
                },
                "Parcel": {
                    title: "Parcel Panel Insurance",
                    desc: "Boost revenue with your shipping protection solution",
                    price: 11,
                    img: '/imgs/extra_app/Parcel.png',
                    tip: "After install Parcel Panel Insurance you will get it for free.",
                    url: 'https://insurance.parcelpanel.com/recommend/Seo-ant'
                },
                "Willdesk": {
                    title: "Willdesk‑Live Chat, Helpdesk, Chatbot",
                    desc: "Turn customer service into a profit center.",
                    price: 30,
                    img: '/imgs/extra_app/Willdesk.png',
                    tip: "Contact Willdesk's 24/7 customer service to get it for free.",
                    url: 'https://share.channelwill.com/app/12657ab5047de8dM29'
                },
                "RecomSale": {
                    title: "RecomSale: Referral & Affiliate Marketing",
                    desc: "Boost your sales with affiliate, referral & ambassador program",
                    price: 29,
                    img: '/imgs/extra_app/RecomSale.png',
                    tip: "After install Recomsale you will get it for free.",
                    url: 'https://app.recomsale.com/affiliate-share?rs_source=seoant'
                },
            },
            isShowGiftBlock: false,
            onlineGiftTiem: 1703174400, // 上线时间
            googleState: false, // 是否开启加速
            loadingSpeed: true,
            cDays: '00',
            cHours: '00',
            cMins: '00',
            cSecs: '00',
            aHours: '00',
            diyBannerState: -1, // banner自定义状态
            planName: '', // 活动名称
            isHaveDiscount: false,   // 是否存在折扣
            isShowFiveModal: false,
            isShowFeedback: false, // 反馈弹窗
            isShowReasonSet: false,
            isShowUpdateSet: false,
            updateFeedback: '',     // 反馈输入框
            notExpectVal: false,
            poorVal: false,
            lackVal: false,
            performVal: false,
            securityVal: false,
            expensiveVal: false,
            softwareVal: false,
            othersVal: false,
            notExpectInfoVal: '',
            poorInfoVal: '',
            lackInfoVal: '',
            performInfoVal: '',
            securityInfoVal: '',
            expensiveInfoVal: '',
            softwareInfoVal: '',
            othersInfoVal: '',
            isShowWarnFeedback: "",
            codeFocus: false, // 折扣码聚焦
            iscacheLoading: true, // 缓存状态
            asFreeLoading: false, // 免费按钮loading
            preDiscount: 1,
            proDiscount: 1,
            questionList: {
                w_charged_mistake: {
                    title: "💰 What if I was charged by mistake?",
                    tag: [
                        "If you were charged after a free trial because you forgot to cancel, or if you were charged after uninstalling the app due to Shopify's billing cycle, or if you notice any unexpected charges, please contact us via the live chat.",
                        "Once we confirm the situation, we'll be happy to help with a refund when applicable.",
                    ]
                },
                h_does_trial: {
                    title: "🎁 How does the 7-day free trial work? When will I be charged?",
                    tag: [
                        "We offer a 7-day free trial for all all first-time users. If you don't cancel before the trial ends, your paid subscription will start automatically.",
                        "Billing is handled by Shopify and charged on your regular Shopify billing date. Learn more in Shopify's billing policy.",
                        "If you have any question about the charge, please contact us anytime."
                    ]
                },
                w_run_quota: {
                    title: "🧾 What if I run out of credits or image quota?",
                    tag: [
                        "Paid Users: If overage is enabled, additional usage will be billed automatically at $4.9 per 1,000 images or $9.9 per 100 AI credits. You can set a spending limit to control extra charges.",
                        "Free Users: Quotas are one-time only. Upgrade to a paid plan to unlock more credits and image quota."
                    ]
                },
                w_hp_plan: {
                    title: "🔄 What happens if I change my subscription plan?",
                    tag: [
                        "For Monthly Subscribers:",
                        "Switching between paid plans (e.g. Pre ↔ Pro): The new plan takes effect immediately. Shopify automatically prorates the fee based on the remaining days.",
                        "Downgrade to Free: The plan will switch to Free immediately, but previous charges won't be automatically refunded. Please contact us if you need assistance.",
                        "For Annual Subscribers:",
                        "Whether upgrading or downgrading, the new plan takes effect immediately. However, annual payments are non-refundable once charged. Please contact us if you require assistance.",
                    ]
                }
            },
            isComboUser: false,     // 是否组合套餐用户
            isShowCwComboModal: false,
            isActLoading: true,
            isShowCouponDis: false,   // 是否展示优惠券的布局

            newPlanService: {
                "SEO Audit": {
                    title: "SEO Audit",
                    subText: {
                        "Full Site SEO Audit": {
                            desc: "Scan your entire website for SEO issues and opportunities.",
                            image: "/imgs/pricing/desc/FullSiteSEOAudit.png",
                            isNew: false,
                            priority: [true, true, true],
                        },
                        "On-page SEO Audit": {
                            desc: "Analyze product, collection, or blog pages for on-page SEO issues and improvement tips.",
                            image: "/imgs/pricing/desc/On-pageSEOAudit.png",
                            isNew: false,
                            priority: [20, 1000, -1],
                        }
                    }
                },
                "Page Speed Optimization": {
                    title: "Page Speed Optimization",
                    subText: {
                        "Page Speed Optimization": {
                            desc: null,
                            image: null,
                            isNew: false,
                            priority: ["Basic Boost", "Rocket Boost", "Turbo Boost"],
                            extra: {
                                "Basic Boost": "Instant Page Load",
                                "Rocket Boost": "Instant Page Load · Defer External Script · Lazy Load Images",
                                "Turbo Boost": "All in Pro Level, Plus: Lazy Load Video & Iframe · Critical CSS Loading · Asset File Compression · Code Optimization",
                            }
                        },
                        // "AMP Page Support": {
                        //     desc: "Enable lightning-fast, Google-indexed AMP pages for mobile",
                        //     image: "/imgs/pricing/desc/AMPPageSupport.png",
                        //     isNew: false,
                        //     priority: ["--", "--", true],
                        // },
                    }
                },
                "Image Optimization": {
                    title: "Image Optimization",
                    subText: {
                        "Auto-compress Images": {
                            desc: "Automatically compress, watermark, and rename images for SEO",
                            image: "/imgs/pricing/desc/Auto-compressImages.png",
                            isNew: false,
                            priority: [50, 2000, 6000],
                        },
                        "Add-on Image Quota": {
                            desc: null,
                            image: null,
                            isNew: false,
                            priority: ['--', '$4.99/1000 images', '$4.99/1000 images'],
                        },
                        "Auto & Bulk Edit Image Alt Text": {
                            desc: "Automatically generate alt text for product, collection, and blog images based on custom rules.",
                            image: "/imgs/pricing/desc/Auto&BulkEditImageAltText.png",
                            isNew: false,
                            priority: [true, true, true],
                        }
                    }
                },
                "Content Optimization": {
                    title: "Content Optimization",
                    subText: {
                        "On-Page SEO Optimization": {
                            desc: "Instantly fix SEO issues on product, collection, and blog pages to meet SEO best practices.",
                            image: "/imgs/pricing/desc/On-PageSEOOptimization.png",
                            isNew: false,
                            priority: [true, true, true],
                        },
                        "AI Blog Generator": {
                            desc: "Create SEO-optimized blog posts from keywords in minutes to boost traffic.",
                            image: "/imgs/pricing/desc/AIBlogGenerator.png",
                            isNew: true,
                            priority: [true, true, true],
                        },
                        "AI Credits": {
                            desc: "Use for AI blog generation, keyword content planner, and on-page SEO optimization.",
                            image: null,
                            isNew: false,
                            priority: [30, 200, 500],
                        },
                        "Add-on AI Credits": {
                            desc: null,
                            image: null,
                            isNew: false,
                            priority: ['--', '$9.90/100 credits', '$9.90/100 credits'],
                        },
                        "AI Internal Linking": {
                            desc: "Automatically add relevant internal links to your content to strengthen your site's structure.",
                            image: null,
                            isNew: false,
                            priority: ['--', '--', true],
                        }
                    }
                },
                "Search Appearance": {
                    title: "Search Appearance",
                    subText: {
                        "Auto & Bulk Edit Meta Tags": {
                            desc: "Automatically generate and bulk edit titles & descriptions for products, collections, and blogs based on custom rules.",
                            image: "/imgs/pricing/desc/Auto&BulkEditMetaTags.png",
                            isNew: false,
                            priority: ['--', true, true],
                        },
                        "Structured Data Markup": {
                            desc: "Add JSON-LD schema to enhance search results with breadcrumbs, a site search box, product details, and more.",
                            image: "/imgs/pricing/desc/StructuredDataMarkup.png",
                            isNew: false,
                            priority: ['--', true, true],
                        },
                        "Local Business SEO": {
                            desc: "Show your business in Google local search results and Google Maps to attract nearby customers.",
                            image: "/imgs/pricing/desc/LocalBusinessSEO.png",
                            isNew: false,
                            priority: ['--', true, true],
                        },
                        "llms.txt Generator": {
                            desc: "Generate an AI-readable site summary to help AI Chats understand your store and recommend your products in their answers.",
                            image: null,
                            isNew: false,
                            priority: ['--', true, true],
                        }
                    }
                },
                "Keyword Research": {
                    title: "Keyword Research",
                    subText: {
                        "Keyword Suggestions": {
                            desc: "Find related keywords with ranking and search volume to guide your SEO strategy.",
                            image: null,
                            isNew: false,
                            priority: [true, true, true],
                        },
                        "Keyword Content Planner": {
                            desc: "Turn one keyword into a complete content strategy with AI-generated topic clusters and page structure.",
                            image: "/imgs/pricing/desc/KeywordContentPlanner.png",
                            isNew: true,
                            priority: [true, true, true],
                        },
                        "Keywords Rank Tracker": {
                            desc: "Sync all indexed keywords, track their rankings, and add new keywords for ongoing management.",
                            image: null,
                            isNew: false,
                            priority: ['--', '--', true],
                        },
                        "Competitor Analysis": {
                            desc: "Track and compare competitors' keywords to identify untapped SEO opportunities.",
                            image: null,
                            isNew: false,
                            priority: ['--', '--', 10],
                        }
                    }
                },
                "Link Management": {
                    title: "Link Management",
                    subText: {
                        "HTML Sitemap Generator": {
                            desc: "Build an HTML sitemap page to display your site's structure, helping visitors and search engines navigate your website.",
                            image: null,
                            isNew: false,
                            priority: [true, true, true],
                        },
                        "Auto-Scan Broken Links": {
                            desc: null,
                            image: null,
                            isNew: false,
                            priority: [true, true, true],
                        },
                        "Auto-Redirect Broken Links": {
                            desc: "Automatically scan 404 links and instantly redirect them to a specific page.",
                            image: null,
                            isNew: false,
                            priority: ['--', true, true],
                        },
                        "Instant Index": {
                            desc: "Submit your pages to get indexed by Google instantly for faster search visibility.",
                            image: null,
                            isNew: false,
                            priority: ['--', true, true],
                        },
                        "Backlink Exchange": {
                            desc: "Trade backlinks with other sites to boost authority and drive more traffic.",
                            image: null,
                            isNew: false,
                            priority: [40, 300, 1000],
                        },
                        "Backlink Audit": {
                            desc: "Monitor your website's backlinks and evaluate their quality and relevance to boost authority and search rankings.",
                            image: null,
                            isNew: false,
                            priority: ['--', '--', true],
                        }
                    }
                },
                "Integration": {
                    title: "Integration",
                    subText: {
                        "Google Search Console": {
                            desc: "Connect SEOWILL to Google Search Console to sync your site data and optimize content with actionable insights.",
                            image: null,
                            isNew: false,
                            priority: ['--', true, true],
                        }
                    }
                },
                "Support": {
                    title: "Support",
                    subText: {
                        "Email & Live chat": {
                            desc: null,
                            image: null,
                            isNew: false,
                            priority: ['Daily', '24/7', 'VIP Priority'],
                        }
                    }
                },
            },
            infoImg: {
                "Full Site SEO Audit": {
                    image: "/imgs/pricing/desc/FullSiteSEOAudit.png",
                    desc: "Scan your entire website for SEO issues and opportunities.",
                },
                "On-page SEO Audit": {
                    image: "/imgs/pricing/desc/On-pageSEOAudit.png",
                    desc: "Analyze product, collection, or blog pages for on-page SEO issues and improvement tips.",
                },
                // "AMP Page Support": {
                //     image: "/imgs/pricing/desc/AMPPageSupport.png",
                //     desc: "Enable lightning-fast, Google-indexed AMP pages for mobile",
                // },
                "Auto-compress Images": {
                    image: "/imgs/pricing/desc/Auto-compressImages.png",
                    desc: "Automatically compress, watermark, and rename images for SEO",
                },
                "Auto & Bulk Edit Image Alt Text": {
                    image: "/imgs/pricing/desc/Auto&BulkEditImageAltText.png",
                    desc: "Automatically generate alt text for product, collection, and blog images based on custom rules.",
                },
                "On-Page SEO Optimization": {
                    image: "/imgs/pricing/desc/On-PageSEOOptimization.png",
                    desc: "Instantly fix SEO issues on product, collection, and blog pages to meet SEO best practices.",
                },
                "AI Blog Generator": {
                    image: "/imgs/pricing/desc/AIBlogGenerator.png",
                    desc: "Create SEO-optimized blog posts from keywords in minutes to boost traffic.",
                },
                "Auto & Bulk Edit Meta Tags": {
                    image: "/imgs/pricing/desc/Auto&BulkEditMetaTags.png",
                    desc: "Automatically generate and bulk edit titles & descriptions for products, collections, and blogs based on custom rules.",
                },
                "Structured Data Markup (JSON-LD)": {
                    image: "/imgs/pricing/desc/StructuredDataMarkup.png",
                    desc: "Add JSON-LD schema to enhance search results with breadcrumbs, a site search box, product details, and more.",
                },
                "Local Business SEO": {
                    image: "/imgs/pricing/desc/LocalBusinessSEO.png",
                    desc: "Show your business in Google local search results and Google Maps to attract nearby customers.",
                },
                "Keyword Content Planner": {
                    image: "/imgs/pricing/desc/KeywordContentPlanner.png",
                    desc: "Turn one keyword into a complete content strategy with AI-generated topic clusters and page structure.",
                },
                "Keywords Rank Tracker": {
                    image: null,
                    desc: "Sync all indexed keywords, track their rankings, and add new keywords for ongoing management.",
                },
                "Backlink Audit": {
                    image: null,
                    desc: "Monitor your website's backlinks and evaluate their quality and relevance to boost authority and search rankings.",
                },
                "AI Internal Linking": {
                    image: null,
                    desc: "Automatically add relevant internal links to your content to strengthen your site's structure.",
                },
                "llms.txt Generator": {
                    image: null,
                    desc: "Generate an AI-readable site summary to help AI Chats understand your store and recommend your products in their answers.",
                },
            },
            expertPlanBtnStatus: 0,     // 专家服务 按钮状态
            mTabBtnWidth: 0,
            yTabBtnWidth: 0,

            annualDisText: "",              // 默认20折扣
            defalutDis: 0.8,        // 默认折扣
            isShowVerifyModal: false,
            trial_discount: -1,
            discountExpIn: 0,
            timeType: [],
            isShowMonth: false,
            isShowYear: false,
            isShowTrialBanner: true,
            planInfo: {
                pro_month: {},
                pre_month: {},
                pro_year: {},
                pre_year: {},
            },
            isShowEOfferModal: false,
            pageViews: 0,
            language: '',
            discountArr: [],
            retainOpenState: false,
            downgradeType: '',
            downgradeLevel: 0,
            downDataCompare: {},
            coupon_claimed: 0,
            isShowSADModal: false,
            level: 0,
        }
    }

    UNSAFE_componentWillMount() {
        // 等待活动数据 判断是否展示黑五
        store.subscribe(() => {
            let _store = store.getState().public;
            let actInfo = _store.ActMealData;
            if (Object.keys(actInfo).length > 0) {
                this.setState({
                    isActLoading: false,
                    planName: actInfo?.plan_name || '',
                })
            }

            // 更新页面浏览量和优惠券弹窗状态
            let _t = _store.publicInit.head_data;
            let isShowEOfferModal = _store.level === 1 && !Boolean(_t?.is_pay) && !Boolean(_t?.switch_data?.exclusive_offer_modal) && Boolean(_t?.switch_data?.get_new_user_coupon_50) && !Boolean(_t?.switch_data?.get_new_user_coupon_50?.st === 1);
            this.setState({
                isShowEOfferModal,
                pageViews: _store.planPageViews,
                language: _store.Language || 'en',
            })
        })
        // 重置活动gif块状态
        if (window.giftEvent) {
            window.giftEvent.changeActMealModal();
        }
    }

    //进入页面调用接口
    componentDidMount() {
        setTimeout(() => {
            if (window.location.pathname === '/plan') {
                this.changeViewsNum();
            }
        }, 5000)

        // 通过 history.block 手动拦截
        this.unblock = this.props.history.block((location, action) => {
            let { pageViews, isShowEOfferModal, planInfo } = this.state;
            // 判断折扣是否满足
            let isSmallDiscount = !Boolean(planInfo.pro_month?.rate) || !Boolean(planInfo.pre_month?.rate) || (Boolean(planInfo.pro_month?.rate) && planInfo.pro_month?.rate < 1 && planInfo.pro_month?.rate > 0.5) || (Boolean(planInfo.pre_month?.rate) && planInfo.pre_month?.rate < 1 && planInfo.pre_month?.rate > 0.5);
            if (pageViews === 2 && isSmallDiscount && isShowEOfferModal) {
                this.setState({
                    iscacheLoading: true,
                }, () => {
                    this.getCouponOffer(); // 获取优惠券
                })
                return false;
            }
            return true;
        });


        // 查看自定义状态
        let headData = this.props.public.publicInit.head_data;
        let stateS = headData?.switch_data;
        this.setState({
            diyBannerState: typeof stateS === 'boolean' ? true : !Boolean(stateS?.pricingTimeBanner),
            isComboUser: Boolean(headData?.is_combo_plan),
        }, () => {
            // 获取套餐版本
            let _page = this.props.page;
            this.getUserPricingPlanList(false, _page.pageInit?.pricingPlan, false);

            // pre跳转高亮
            if (Boolean(this.props.location.query) && this.props.location.query === 'Pre Plan') {
                this.setState({
                    isPreJump: true,
                }, () => {
                    // this.hightLightPlan();
                })
            }
        })

        // 监听更新
        store.subscribe(() => {
            let _headData = store.getState().public.publicInit.head_data;
            let _stateS = _headData?.switch_data;
            this.setState({
                diyBannerState: typeof _stateS === 'boolean' ? true : !Boolean(_stateS?.pricingTimeBanner),
                isComboUser: Boolean(_headData?.is_combo_plan),
            })
        })
    }

    // 获取优惠卷
    getCouponOffer = async () => {
        const res = await reqGetCouponOffer({ coupon_code: "NewUser50" });
        if (res.ack === 1) {
            this.getUserPricingPlanList(false, null, true);
        } else {
            this.setState({
                iscacheLoading: false,
            })
        }
    }

    // 增加页面浏览量
    changeViewsNum = () => {
        this.setState({
            pageViews: this.state.pageViews + 1,
        }, () => {
            store.dispatch(setPlanPageViews());
        })
    }

    // 获取pagespeed状态
    getPageSpeedStatus = async () => {
        const res = await reqGetSiteSpeedUp();
        if (res) {
            let { SerSort } = this.state;
            let newSort = cloneDeep(SerSort);
            if (!Boolean(res?.status)) {
                delete newSort.serTitle["Site Speed Up"]
            }
            this.setState({
                googleState: !Boolean(res?.status),
                loadingSpeed: false,
                SerSort: newSort
            })
        }
    }

    // 增加pre版本高亮
    hightLightPlan = () => {
        if (Boolean(document.getElementById('pricingMealContent')) && Boolean(document.getElementById('pricingMealContent').childNodes[0].childNodes[0])) {
            document.getElementById('pricingMealContent').childNodes[0].childNodes[0].style.boxShadow = '0 -3px 20px #999999';
            setTimeout(() => {
                if (Boolean(document.getElementById('pricingMealContent')) && Boolean(document.getElementById('pricingMealContent').childNodes[0].childNodes[0])) {
                    document.getElementById('pricingMealContent').childNodes[0].childNodes[0].style.boxShadow = 'unset';
                }
            }, 2000)
        } else {
            setTimeout(() => {
                this.hightLightPlan();
            }, 100)
        }
    }

    // 格式折扣文案
    formatDiscountText = (discount) => {
        return !Boolean(discount) ? "" : discount >= 1 ? `-$${discount}` : `${((1 - Number(discount)) * 100).toFixed(0)}% OFF`;
    }

    // 获取价格套餐版本
    getUserPricingPlanList = async (showFeedback = false, cache = null, isDiscount = false) => {
        let params = {};
        if (Object.keys(this.props.public.ActMealData).length > 0) {
            params['activity_id'] = this.props.public.ActMealData.activity_id;
        }
        let response = cache || (await reqGetNewUserPricingPlanList(params));
        this.props.getPageDataRedux(response);
        if (response.ack === 1) {
            let res = response.data;
            //如果用户是免费套餐则默认选中pro半年费
            let selectId = res.level <= 1 ? 6 : res.ppid;
            let originSer = cloneDeep(res.services);
            Object.keys(originSer).forEach(item => {
                originSer[item] = { ...originSer[item], ...originSer[item].services }
            })
            // this.verifyGift(res.activated_on); // 验证是否有福利app

            // 计算年费折扣
            let annualDisText = this.computeAnnualDiscount(res.meal_list.year);
            this.setState({
                iscacheLoading: cache || false,
                pricingPlanList: res.meal_list,
                selectId: selectId,
                selectLevel: res.level + "",
                loading: false,
                loadingPage: false,
                level: res.level,
                pricingData: res,
                userInfo: {
                    ppid: res.ppid,
                    level: res.level,
                    trial_days: res.trial_days,
                    // 年费扣费后使用时长 < 30 天：true 表示切换套餐需先弹窗提示
                    year_charge_within_30_days: res.year_charge_within_30_days || false,
                    // 年费套餐下次扣费日期（unix 秒级时间戳）
                    year_charge_next_time: res.year_charge_next_time || 0,
                },
                old_button: res.old_button,
                services: res.services,
                SerSort: { ...this.state.SerSort, ...originSer },
                planName: this.props.public.ActMealData.plan_name || '',
                isHaveDiscount: res.coupon_fifty_discount,   // 是否存在折扣
                defalutDis: res.meal_list.year[0]?.default_discount || 0.8,     // 默认折扣
                annualDisText,
                // 各版本的折扣
                planInfo: {
                    pro_month: this.computeBestDiscount(res, res.meal_list.month[0], 'prom', 2),
                    pre_month: this.computeBestDiscount(res, res.meal_list.month[1], 'prem', 4),
                    pro_year: this.computeBestDiscount(res, res.meal_list.year[0], 'proy', 8),
                    pre_year: this.computeBestDiscount(res, res.meal_list.year[1], 'prey', 9),
                }, // 计算每个版本的最优力度 - 优惠券优先
                coupon_claimed: res.coupon_claimed,
                downDataCompare: {
                    pages_audited: res?.pages_audited || 0,
                    un_opt_num: res?.un_opt_num || 0,
                },
            }, () => {
                // 获取时间类型
                let typeArr = Object.values(this.state.planInfo).map(item => item.type);
                this.setState({
                    timeType: typeArr,
                })

                // 是否显示优惠券弹窗
                if (isDiscount) {
                    this.changeViewsNum();
                    this.props.handleToggleEOfferModal(true);
                }

                // 获取按钮宽度
                this.setTabPlanBtnWidth();

                // 判断当前用户等级 移动滑块
                let userInfo = this.state.userInfo
                if (userInfo.ppid === 2 || userInfo.ppid === 4 || userInfo.ppid === 10) {
                    this.move(1)
                    this.setState({
                        prePlanId: 4,
                        proPlanId: 2
                    })
                } else if (userInfo.ppid === 8 || userInfo.ppid === 9 || userInfo.ppid === 10) {
                    this.move(2)
                    this.setState({
                        prePlanId: 9,
                        proPlanId: 8
                    })
                } else {
                    this.move(1)
                }

                // 判断是否过来购买积分
                const _params = this.props.location;
                if (Boolean(_params.query)) {
                    if (_params.query === 'pay_credits') {
                        // 定义滚动区
                        const scrollItem = document.getElementById('credits-collapsible');
                        if (scrollItem) {
                            setTimeout(() => {
                                window.scrollTo({
                                    top: scrollItem.offsetTop - 100,
                                    behavior: "smooth"
                                });
                                document.getElementById('credits-collapsible').style.boxShadow = '0 0 20px #999999';
                                document.getElementById('credits-collapsible').style.borderRadius = '12px';
                                setTimeout(() => {
                                    if (document.getElementById('credits-collapsible')) {
                                        document.getElementById('credits-collapsible').style.boxShadow = 'unset';
                                        document.getElementById('credits-collapsible').style.borderRadius = 'unset';
                                    }
                                }, 2000)
                            }, 100)
                        }
                    } else if (_params.query === 'year') {
                        this.move(2)
                    } else { }
                }

                // 判断是否弹窗反馈
                if (showFeedback) {
                    setTimeout(() => {
                        this.setState({
                            isShowFeedback: true
                        })
                    }, 500)
                }

                // 重新获取价格方案
                if (cache) {
                    this.getUserPricingPlanList();
                }

                // 判断活动id是否年付
                if (this.props.public.ActMealData.activity_id === 9) {
                    this.move(2);
                }
            })
        } else {
            this.props.toggleToast(response.msg, true);
        }
    }

    // 计算每个版本的最优力度 - 优惠券优先
    computeBestDiscount = (res, data, plan, id) => {
        let obj_data = {};
        // 有试用天数的优惠券优先
        if (Object.keys(data.coupon_info).length > 0 && data.coupon_info.trial_days > 0) {
            // 优惠券
            obj_data = {
                id,
                price: multiplyPrice(Number(data.price), Number(data.coupon_info.rate)),
                o_price: Number(data.price),
                trial_days: data.coupon_info.trial_days,
                period: Number(data.coupon_info.discount_period),
                expires_in: data.coupon_info.expires_in,
                rate: Number(data.coupon_info.rate),
                code: data.coupon_info.code,
                rateText: this.formatDiscountText(Number(data.coupon_info.rate)),
                type: `${plan}Code`
            };
        } else if (Object.keys(data.coupon_info).length > 0 || Boolean(data?.discount_rate)) {
            // 无试用 需计算活动和优惠券的力度
            let c_price = Number(data.coupon_info?.discount_price) || -1;
            let d_price = Number(data?.discount_price) || -1;
            let price = data.price;
            let rate = "";
            let period = 0;
            let expires_in = 0;
            let code = null;
            let rateText = "";
            let type = "";
            if (c_price !== -1 && d_price !== -1) {
                price = c_price > d_price ? d_price : c_price;
                rate = c_price > d_price ? data.discount_rate : data.coupon_info.rate;
                period = c_price > d_price ? data.discount_period : data.coupon_info.discount_period;
                expires_in = c_price > d_price ? data.discount_exp : data.coupon_info.expires_in;
                code = c_price > d_price ? null : data.coupon_info.code;
                rateText = c_price > d_price ? this.formatDiscountText(Number(data.discount_rate)) : this.formatDiscountText(Number(data.coupon_info.rate));
                type = `${plan}${d_price > c_price ? 'Dis' : 'Code'}`;
            } else if (c_price !== -1 && d_price === -1) {
                price = c_price;
                rate = data.coupon_info.rate;
                period = data.coupon_info.discount_period;
                expires_in = data.coupon_info.expires_in;
                code = data.coupon_info.code;
                rateText = this.formatDiscountText(Number(data.coupon_info.rate));
                type = `${plan}Code`;
            } else if (c_price === -1 && d_price !== -1) {
                price = d_price;
                rate = data.discount_rate;
                period = data.discount_period;
                expires_in = data.discount_exp;
                code = null;
                rateText = this.formatDiscountText(Number(data.discount_rate));
                type = `${plan}Dis`;
            } else {
                price = data.price;
                rate = "";
                period = 0;
                expires_in = 0;
                code = null;
                rateText = "";
                type = "";
            }
            obj_data = {
                id,
                price: Number(price),
                o_price: Number(data.price),
                trial_days: res.trial_days || 0,
                rate: Number(rate),
                period: Number(period),
                expires_in,
                code,
                rateText,
                type
            }
        } else {
            // 无优惠
            obj_data = {
                id,
                price: Number(data.price),
                o_price: Number(data.price),
                trial_days: res.trial_days || 0,
                rate: "",
                period: 0,
                expires_in: 0,
                code: null,
                rateText: "",
                type: ""
            }
        }

        return obj_data;
    }

    // 计算年费折扣
    computeAnnualDiscount = (data) => {
        // 计算优惠力度
        let discountText = '';  // 折扣文案
        let o_pre = Number(data[1].price), o_pro = Number(data[0].price);   // 原价 
        let cp_pre = Number(data[1].coupon_info?.discount_price) || o_pre, cp_pro = Number(data[0].coupon_info?.discount_price) || o_pro;   // 优惠券   优惠价格  
        let ap_pre = Number(data[1]?.discount_price) || o_pre, ap_pro = Number(data[0]?.discount_price) || o_pro;                           // 活动     优惠价格  
        let c_pre_trial = Number(data[1].coupon_info?.trial_days) || 0, c_pro_trial = Number(data[0].coupon_info?.trial_days) || 0;
        let c_preRate = Number(data[1].coupon_info?.rate) || -1,
            c_proRate = Number(data[0].coupon_info?.rate) || -1,
            d_preRate = Number(data[1]?.discount_rate) || -1,
            d_proRate = Number(data[0]?.discount_rate) || -1;
        // 存在试用天数 默认
        if (c_pre_trial > 0 || c_pro_trial > 0) {
            if ((c_preRate >= 0 && c_preRate < 1) && (c_proRate >= 0 && c_proRate < 1)) {
                discountText = t("{{v1}} OFF", c_preRate > c_proRate ? `${Number(((1 - c_proRate) * 100).toFixed(0))}%` : `${Number(((1 - c_preRate) * 100).toFixed(0))}%`);
            } else if ((c_preRate >= 0 && c_preRate < 1) && c_proRate >= 1) {
                discountText = (o_pre - cp_pre) > c_proRate ? t("{{v1}} OFF", `${Number(((1 - c_preRate) * 100).toFixed(0))}%`) : `-$${c_proRate}`;
            } else if ((c_proRate >= 0 && c_proRate < 1) && c_preRate >= 1) {
                discountText = (o_pro - cp_pro) > c_preRate ? t("{{v1}} OFF", `${Number(((1 - c_proRate) * 100).toFixed(0))}%`) : `-$${c_preRate}`;
            } else if (c_preRate >= 0 && c_proRate === -1) {
                discountText = c_preRate >= 1 ? `-$${c_preRate}` : t("{{v1}} OFF", `${Number(((1 - c_preRate) * 100).toFixed(0))}%`);
            } else if (c_proRate >= 0 && c_preRate === -1) {
                discountText = c_proRate >= 1 ? `-$${c_proRate}` : t("{{v1}} OFF", `${Number(((1 - c_proRate) * 100).toFixed(0))}%`);
            } else {
                discountText = `-$${c_preRate > c_proRate ? c_preRate : c_proRate}`;
            }
        } else {
            // 不存在试用天数，需要根据 优惠券和活动
            let preRate = 0, proRate = 0;
            let preType = '', proType = 0;
            // 判断 Pre
            if ((c_preRate >= 0 && c_preRate < 1) && (d_preRate >= 0 && d_preRate < 1)) {
                preRate = c_preRate > d_preRate ? Number(((1 - d_preRate)).toFixed(2)) : Number(((1 - c_preRate)).toFixed(2));
                preType = c_preRate > d_preRate ? 'discout' : 'coupon';
            } else if ((c_preRate >= 0 && c_preRate < 1) && d_preRate >= 1) {
                preRate = (o_pre - cp_pre) > d_preRate ? Number(((1 - c_preRate)).toFixed(2)) : d_preRate;
                preType = (o_pre - cp_pre) > d_preRate ? 'coupon' : 'discout';
            } else if ((d_preRate >= 0 && d_preRate < 1) && c_preRate >= 1) {
                preRate = (o_pre - ap_pre) > c_preRate ? Number(((1 - d_preRate)).toFixed(2)) : c_preRate;
                preType = (o_pre - ap_pre) > c_preRate ? 'discout' : 'coupon';
            } else if (c_preRate >= 0 && d_preRate === -1) {
                preRate = c_preRate >= 1 ? c_preRate : Number(((1 - c_preRate)).toFixed(2));
                preType = c_preRate >= 1 ? 'coupon' : 'discout';
            } else if (d_preRate >= 0 && c_preRate === -1) {
                preRate = d_preRate >= 1 ? d_preRate : Number(((1 - d_preRate)).toFixed(2));
                preType = d_preRate >= 1 ? 'discout' : 'coupon';
            } else {
                preRate = c_preRate > d_preRate ? c_preRate : d_preRate;
                preType = c_preRate > d_preRate ? 'coupon' : 'discout';
            }

            // 判断 Pro
            if ((c_proRate >= 0 && c_proRate < 1) && (d_proRate >= 0 && d_proRate < 1)) {
                proRate = c_proRate > d_proRate ? Number(((1 - d_proRate)).toFixed(2)) : Number(((1 - c_proRate)).toFixed(2));
                proType = c_proRate > d_proRate ? 'discout' : 'coupon';
            } else if ((c_proRate >= 0 && c_proRate < 1) && d_proRate >= 1) {
                proRate = (o_pro - cp_pro) > d_proRate ? Number(((1 - c_proRate)).toFixed(2)) : d_proRate;
                proType = (o_pro - cp_pro) > d_proRate ? 'coupon' : 'discout';
            } else if ((d_proRate >= 0 && d_proRate < 1) && c_proRate >= 1) {
                proRate = (o_pro - ap_pro) > c_proRate ? Number(((1 - d_proRate)).toFixed(2)) : c_proRate;
                proType = (o_pro - ap_pro) > c_proRate ? 'discout' : 'coupon';
            } else if (c_proRate >= 0 && d_proRate === -1) {
                proRate = c_proRate >= 1 ? c_proRate : Number(((1 - c_proRate)).toFixed(2));
                proType = c_proRate >= 1 ? 'coupon' : 'discout';
            } else if (d_proRate >= 0 && c_proRate === -1) {
                proRate = d_proRate >= 1 ? d_proRate : Number(((1 - d_proRate)).toFixed(2));
                proType = d_proRate >= 1 ? 'discout' : 'coupon';
            } else {
                proRate = c_proRate > d_proRate ? c_proRate : d_proRate;
                proType = c_proRate > d_proRate ? 'coupon' : 'discout';
            }

            // 比对
            if ((proRate >= 0 && proRate < 1) && (preRate >= 0 && preRate < 1)) {
                discountText = t("{{v1}} OFF", proRate > preRate ? `${(proRate * 100).toFixed(0)}%` : `${(preRate * 100).toFixed(0)}%`);
            } else if ((proRate >= 0 && proRate < 1) && preRate >= 1) {
                let p_origin = proType === 'discount' ? ap_pro : cp_pro;
                discountText = (o_pro - p_origin) > preRate ? t("{{v1}} OFF", `${(proRate * 100).toFixed(0)}%`) : `-$${preRate}`;
            } else if ((preRate >= 0 && preRate < 1) && proRate >= 1) {
                let p_origin = preType === 'discount' ? ap_pre : cp_pre;
                discountText = (o_pre - p_origin) > proRate ? t("{{v1}} OFF", `${(preRate * 100).toFixed(0)}%`) : `-$${proRate}`;
            } else if (proRate >= 0 && preRate === -1) {
                discountText = proRate >= 1 ? `-$${proRate}` : t("{{v1}} OFF", `${(proRate * 100).toFixed(0)}%`);
            } else if (preRate >= 0 && proRate === -1) {
                discountText = preRate >= 1 ? `-$${preRate}` : t("{{v1}} OFF", `${(preRate * 100).toFixed(0)}%`);
            } else {
                discountText = `-$${proRate > preRate ? proRate : preRate}`;
            }
        }

        return discountText.indexOf('-1') > -1 ? t("{{v1}} OFF", "20%") : discountText;
    }

    // 设置按钮宽度
    setTabPlanBtnWidth = () => {
        let mTabBtn = document.getElementById("monthly");
        let yTabBtn = document.getElementById("annual");
        if (mTabBtn && yTabBtn) {
            // Only update if width changes
            const mTabWidth = mTabBtn.clientWidth;
            const yTabWidth = yTabBtn.clientWidth;
            if (mTabWidth !== this.state.mTabBtnWidth || yTabWidth !== this.state.yTabBtnWidth) {
                this.setState({
                    mTabBtnWidth: mTabWidth,
                    yTabBtnWidth: yTabWidth,
                });
            }
        } else {
            requestAnimationFrame(this.setTabPlanBtnWidth);
        }
    }

    // 验证活动上线前用户
    verifyGift = (acTime) => {
        let { onlineGiftTiem } = this.state;
        let _store = this.props.public.publicInit;
        let users = _store?.shop_data;
        if (users) {
            if (users.created_at < onlineGiftTiem) {
                // 活动上线前用户
                if (users.level === 1 || (users.level === 3 && acTime >= onlineGiftTiem)) {
                    this.setState({ isShowGiftBlock: true });
                }
            } else {
                this.setState({ isShowGiftBlock: true });
            }
        }
    }

    //升级请求
    updateUserPricingPlan = async (id, discount_id = 0, isMonthModal = 0, level = 0) => {
        this.setState({
            paidLoading: true
        });
        const params = {
            ppid: id,
            discount_id: discount_id,
            is_month_change: isMonthModal,
            checked_level: level
        };
        const response = await reqUpdateUserPricingPlan(params);
        //这里弹窗升降级
        if (response.code === 20001) {
            this.setState({
                modalData: response.data,
                openModalChange: true,
                paidLoading: false,
                //关闭月费降免费弹窗
                openFreePlanDegrade: false,
            });
            return null;
        }
        if (response.code === 200) {
            this.props.toggleToast(response.msg, false);
            //跳转支付页面
            let j_url = response.data.confirmation_url;
            if (j_url) {
                if (window.top) {
                    window.top.location.href = j_url;
                } else {
                    this.handleJumpSubUrl(j_url);
                }
            }
            return null;
        }

        this.setState({
            paidLoading: false,
            openModalChange: false,
            openModalLoading: false,
            //关闭月费降免费弹窗
            openFreePlanDegrade: false,
        });
        this.props.toggleToast(response.msg, true);
        return null;
    }

    //确认转换升级
    updatePlanConversion = async (id, pay_type) => {
        this.setState({
            paidLoading: true,
            openModalLoading: true,
        });
        // 一次性付费
        if (pay_type === 1) {
            const response = await reqPlanConversion({ ppid: id });
            if (response.code === 200) {
                this.setState({
                    paidLoading: false,
                    openModalChange: false,
                });
                this.props.toggleToast(response.msg, false);
                //重新加载数据
                this.getUserPricingPlanList();
            } else {
                this.setState({
                    paidLoading: false,
                    openModalLoading: false
                });
                this.props.toggleToast(response.msg, true);
            }
        }
        // 订阅付费
        if (pay_type === 2) {
            this.updateUserPricingPlan(id, 0, 1);
        }

        return null;
    }

    // 时分秒倒计时
    actCountdown = async (end_time, field = '', type = '') => {
        let cacheTimer = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            if (date3 < 1000) {
                clearInterval(cacheTimer);
                this.setState({
                    [field]: 0,
                    preDiscountPrice: -1,
                    proDiscountPrice: -1,
                    diyBannerState: false,
                    isShowTrialBanner: false,
                }, () => {
                    // this.getUserPricingPlanList();
                    this.delDiscountTimeArr();
                })
            } else {
                //计算出小时数
                let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";
                let cdays = '', chours = '', cmins = '', csecs = '', ahours = '';

                if (hours < 10) {
                    exp_time += "0" + hours + ":";
                    cdays = `00`;
                    chours = `0${hours}`;
                    ahours = `0${hours}`;
                } else {
                    exp_time += hours + ":";
                    cdays = `${Math.floor(hours / 24) < 10 ? '0' + Math.floor(hours / 24) : Math.floor(hours / 24)}`;
                    chours = `${(hours % 24) < 10 ? '0' + (hours % 24) : hours % 24}`;
                    ahours = `${hours}`;
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":";
                    cmins = `0${minutes}`;
                } else {
                    exp_time += minutes + ":";
                    cmins = `${minutes}`;
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds;
                    csecs = `0${seconds}`;
                } else if (seconds === 60) {
                    exp_time += "00";
                    csecs = `00`;
                } else {
                    exp_time += seconds;
                    csecs = `${seconds}`;
                }
                let { diyBannerState } = this.state;
                this.setState({
                    [field]: exp_time,
                    diyBannerState: diyBannerState === -1 ? true : diyBannerState,
                    cDays: cdays,
                    cHours: chours,
                    cMins: cmins,
                    cSecs: csecs,
                    aHours: ahours,
                })
            }
        }, 1000)
        if (Boolean(type)) {
            // 月费
            if (type === 'premDis' || type === 'premCode') {
                premArr.push(cacheTimer)
            }
            if (type === 'promDis' || type === 'promCode') {
                promArr.push(cacheTimer)
            }
            // 年费
            if (type === 'preyDis' || type === 'preyCode') {
                preyArr.push(cacheTimer)
            }
            if (type === 'proyDis' || type === 'proyCode') {
                proyArr.push(cacheTimer)
            }
        }
        // 毫秒倒计时
        // setTimeout(() => {
        //     if (discountTimeArr.length === 0) {
        //         let discountTimer = setInterval(() => {
        //             let date1 = new Date(); //开始时间
        //             let date2 = end_time * 1000; //开始时间
        //             let date3 = date2 - date1 //时间差的毫秒数
        //             if (date3 < 0) {
        //                 this.setState({
        //                     [`${field}_mills`]: '00'
        //                 })
        //             } else {
        //                 //计算相差毫秒数
        //                 let milli = date3 % (100)

        //                 let exp_time = "";

        //                 if (milli < 10) {
        //                     exp_time += "0" + milli
        //                 } else {
        //                     exp_time += milli
        //                 }
        //                 this.setState({ [`${field}_mills`]: exp_time })
        //             }
        //         }, 80)
        //         discountTimeArr.push(discountTimer)
        //     }
        // }, 1000)
    }

    // 清空所有
    clearAllTimer = () => {
        this.delDiscountTimeArr();
        this.delTimeArrPreData();
        this.delTimeArrProData();
        this.delTimeArrPreYData();
        this.delTimeArrProYData();
    }

    // 移动动画
    move = (val) => {
        this.clearAllTimer();
        let type = ['month', 'year'];
        const pricing = this.state.pricingData;
        let plans = pricing.meal_list;
        let monthProPrice = plans['month'][0].price;
        let monthPrePrice = plans['month'][1].price;
        let proPlanPrice = plans[type[val - 1]][0].price;
        let prePlanPrice = plans[type[val - 1]][1].price;
        let freePlanPrice = plans['free'][0].price;
        let _planInfo = this.state.planInfo;
        // 切换tab 需要根据当前版本判断按钮状态
        this.setState({
            freePlanBtnStatus: pricing.level !== 1 ? 1 : 0,
            isMonthOrYear: val
        })
        if (val === 1) {
            // 月
            // 判断优惠力度 计算使用哪个折扣周期
            let prodisType = '', predisType = '';
            let proPeriod = 0, prePeriod = 0;
            let mPro = plans['month'][0], mPre = plans['month'][1];
            let isShowCouponDis = this.state.isShowCouponDis; // 活动
            let mProTrialDays = mPro.coupon_info?.trial_days || 0;
            let mPreTrialDays = mPre.coupon_info?.trial_days || 0;
            let newUserinfo = cloneDeep(this.state.userInfo);
            // pro plan
            if (Boolean(mPro?.discount_period >= 0) && Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(mPro['coupon_info']['rate'])) && Number(mPro['coupon_info']['rate']) < 0 && mProTrialDays === 0) {
                    if (Number(mPro['discount_price']) >= 0) {
                        proPeriod = mPro.discount_period;
                        prodisType = 'discount';
                    }
                } else if (Number(mPro['coupon_info']['rate']) >= 0 && Number(mPro['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(mPro['coupon_info']['rate'])) * monthProPrice).toFixed(2)) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0) && mProTrialDays === 0) {
                        // if(mPro.discount_period < mPro.coupon_info.discount_period) {
                        //     proPeriod = mPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = mPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = mPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(mPro['coupon_info']['rate']) >= 1) {
                    if (Number(monthProPrice - Number(mPro['coupon_info']['rate'])) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0) && mProTrialDays === 0) {
                        // if(mPro.discount_period < mPro.coupon_info.discount_period) {
                        //     proPeriod = mPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = mPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = mPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    proPeriod = 0;
                    prodisType = '';
                }
            } else {
                if (Boolean(mPro?.discount_period >= 0)) {
                    proPeriod = mPro.discount_period;
                    prodisType = 'discount';
                }
                if (Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                    proPeriod = mPro.coupon_info.discount_period;
                    prodisType = 'code';
                    isShowCouponDis = true;
                }
            }
            // pre plan
            if (Boolean(mPre?.discount_period >= 0) && Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(mPre['coupon_info']['rate'])) && Number(mPre['coupon_info']['rate']) < 0 && mPreTrialDays === 0) {
                    if (Number(mPre['discount_price']) >= 0) {
                        prePeriod = mPre.discount_period;
                        predisType = 'discount';
                    }
                } else if (Number(mPre['coupon_info']['rate']) >= 0 && Number(mPre['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(mPre['coupon_info']['rate'])) * monthPrePrice).toFixed(2)) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0) && mPreTrialDays === 0) {
                        // if (mPre.discount_period < mPre.coupon_info.discount_period) {
                        //     prePeriod = mPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = mPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = mPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(mPre['coupon_info']['rate']) >= 1) {
                    if (Number(monthPrePrice - Number(mPre['coupon_info']['rate'])) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0) && mPreTrialDays === 0) {
                        // if (mPre.discount_period < mPre.coupon_info.discount_period) {
                        //     prePeriod = mPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = mPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = mPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    prePeriod = 0;
                    predisType = '';
                }
            } else {
                if (Boolean(mPre?.discount_period >= 0)) {
                    prePeriod = mPre.discount_period;
                    predisType = 'discount';
                }
                if (Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                    prePeriod = mPre.coupon_info.discount_period;
                    predisType = 'code';
                    isShowCouponDis = true;
                }
            }
            newUserinfo.pro_trial_days = mProTrialDays;
            newUserinfo.pre_trial_days = mPreTrialDays;
            // 活动折扣文案
            let max_rateText = _planInfo.pro_month.rate < _planInfo.pre_month.rate ? _planInfo.pro_month.rateText : _planInfo.pre_month.rateText;
            this.setState({
                trial_discount: max_rateText || -1,
                moveAnimation: 1,
                prePlanPrice,
                proPlanPrice,
                prePlanDiscountPrice: 0,
                proPlanDiscountPrice: 0,
                freePlanPrice,
                prePlanId: 4,
                proPlanId: 2,
                preDiscount: Number(plans['month'][1]?.coupon_info?.rate) === 0 ? '' : Number(plans['month'][1]?.coupon_info?.rate),
                proDiscount: Number(plans['month'][0]?.coupon_info?.rate) === 0 ? '' : Number(plans['month'][0]?.coupon_info?.rate),
                isShowMonth: true,
                isShowYear: false,
                preVersionLevel: '1_pre',
                proVersionLevel: '1_pro',
                preDiscountPrice: (plans['month'][1].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['month'][1].discount_price) ? (Number(plans['month'][1].discount_price) === 0 ? 0 : Number(plans['month'][1].discount_price)) : -1) : -1,
                proDiscountPrice: (plans['month'][0].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['month'][0].discount_price) ? (Number(plans['month'][0].discount_price) === 0 ? 0 : Number(plans['month'][0].discount_price)) : -1) : -1,
                preMonthPeriod: Boolean(prePeriod) ? Number(prePeriod) : 0,
                proMonthPeriod: Boolean(proPeriod) ? Number(proPeriod) : 0,
                isShowCouponDis,
                userInfo: newUserinfo,
            }, () => {
                // 当不是免费用户 且 套餐等级不是月费时 
                // 当用户是月费
                let isHasTrialmPre = pricing.trial_days !== 0 ? true : newUserinfo?.pre_trial_days ? true : false;  // Pre
                let isHasTrialmPro = pricing.trial_days !== 0 ? true : newUserinfo?.pro_trial_days ? true : false;  // Pro

                switch (Number(pricing.level)) {
                    case 1:
                        if (Number(pricing.ppid) === 1) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 2:
                        if (Number(pricing.ppid) === 2) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: 0,
                                expertPlanBtnStatus: 2,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 3:
                        if (Number(pricing.ppid) === 4) {
                            this.setState({
                                prePlanBtnStatus: 0,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        } else if (Number(pricing.ppid) === 10) {
                            this.setState({
                                prePlanBtnStatus: 2,
                                proPlanBtnStatus: 2,
                                expertPlanBtnStatus: 0,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    default:
                        return;
                }
                // 计算倒计时  discount_period
                if (Boolean(plans['month'][1].discount_exp) && predisType === 'discount') {
                    let timePoint = plans['month'][1].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(timePoint, 'preMonthCountDown', 'premDis')
                        }, 0)
                    }
                }
                if (Boolean(plans['month'][0].discount_exp) && prodisType === 'discount') {
                    let timePoint = plans['month'][0].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(plans['month'][0].discount_exp, 'proMonthCountDown', 'promDis')
                        }, 0)
                    }
                }
                if (Boolean(plans['month'][1]?.coupon_info?.expires_in) && predisType === 'code') {
                    this.setState({
                        preMRecode: plans['month'][1].coupon_info.code
                    }, () => {
                        let timePoint = plans['month'][1].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['month'][1].coupon_info.expires_in, 'preMonthCountDown', 'premCode')
                            }, 0)
                        }
                    })
                }
                if (Boolean(plans['month'][0]?.coupon_info?.expires_in) && prodisType === 'code') {
                    this.setState({
                        proMRecode: plans['month'][0].coupon_info.code
                    }, () => {
                        let timePoint = plans['month'][0].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['month'][0].coupon_info.expires_in, 'proMonthCountDown', 'promCode')
                            }, 0)
                        }
                    })
                }
            })
        } else if (val === 2) {
            // 年
            // 判断优惠力度 计算使用哪个折扣周期
            let prodisType = '', predisType = '';
            let proPeriod = 0, prePeriod = 0;
            let yPro = plans['year'][0], yPre = plans['year'][1];
            let isShowCouponDis = this.state.isShowCouponDis; // 活动
            let yProTrialDays = yPro.coupon_info?.trial_days || 0;
            let yPreTrialDays = yPre.coupon_info?.trial_days || 0;
            let newUserinfo = cloneDeep(this.state.userInfo);
            // pro plan
            if (Boolean(yPro?.discount_period >= 0) && Boolean(yPro?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(yPro['coupon_info']['rate'])) && Number(yPro['coupon_info']['rate']) < 0 && yProTrialDays === 0) {
                    if (Number(yPro['discount_price']) >= 0) {
                        proPeriod = yPro.discount_period;
                        prodisType = 'discount';
                    }
                } else if (Number(yPro['coupon_info']['rate']) >= 0 && Number(yPro['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(yPro['coupon_info']['rate'])) * monthProPrice).toFixed(2)) >= Number(yPro['discount_price']) && Boolean(yPro['discount_price'] >= 0) && yProTrialDays === 0) {
                        // if(yPro.discount_period < yPro.coupon_info.discount_period) {
                        //     proPeriod = yPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = yPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = yPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(yPro['coupon_info']['rate']) >= 1) {
                    if (Number(monthProPrice - Number(yPro['coupon_info']['rate'])) >= Number(yPro['discount_price']) && Boolean(yPro['discount_price'] >= 0) && yProTrialDays === 0) {
                        // if(yPro.discount_period < yPro.coupon_info.discount_period) {
                        //     proPeriod = yPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = yPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = yPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    proPeriod = 0;
                    prodisType = '';
                }
            } else {
                if (Boolean(yPro?.discount_period >= 0)) {
                    proPeriod = yPro.discount_period;
                    prodisType = 'discount';
                }
                if (Boolean(yPro?.coupon_info?.discount_period >= 0)) {
                    proPeriod = yPro.coupon_info.discount_period;
                    prodisType = 'code';
                    isShowCouponDis = true;
                }
            }
            // pre plan
            if (Boolean(yPre?.discount_period >= 0) && Boolean(yPre?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(yPre['coupon_info']['rate'])) && Number(yPre['coupon_info']['rate']) < 0 && yPreTrialDays === 0) {
                    if (Number(yPre['discount_price']) >= 0) {
                        prePeriod = yPre.discount_period;
                        predisType = 'discount';
                    }
                } else if (Number(yPre['coupon_info']['rate']) >= 0 && Number(yPre['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(yPre['coupon_info']['rate'])) * monthPrePrice).toFixed(2)) >= Number(yPre['discount_price']) && Boolean(yPre['discount_price'] >= 0) && yPreTrialDays === 0) {
                        // if(yPre.discount_period < yPre.coupon_info.discount_period) {
                        //     prePeriod = yPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = yPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = yPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(yPre['coupon_info']['rate']) >= 1) {
                    if (Number(monthPrePrice - Number(yPre['coupon_info']['rate'])) >= Number(yPre['discount_price']) && Boolean(yPre['discount_price'] >= 0) && yPreTrialDays === 0) {
                        // if(yPre.discount_period < yPre.coupon_info.discount_period) {
                        //     prePeriod = yPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = yPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = yPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    prePeriod = 0;
                    predisType = '';
                }
            } else {
                if (Boolean(yPre?.discount_period >= 0)) {
                    prePeriod = yPre.discount_period;
                    predisType = 'discount';
                }
                if (Boolean(yPre?.coupon_info?.discount_period >= 0)) {
                    prePeriod = yPre.coupon_info.discount_period;
                    predisType = 'code';
                    isShowCouponDis = true;
                }
            }
            newUserinfo.pro_trial_days = yProTrialDays;
            newUserinfo.pre_trial_days = yPreTrialDays;
            // 活动折扣文案
            let max_rateText = _planInfo.pro_year.rate < _planInfo.pre_year.rate ? _planInfo.pro_year.rateText : _planInfo.pre_year.rateText;
            this.setState({
                trial_discount: max_rateText || -1,
                moveAnimation: 2,
                prePlanPrice,
                proPlanPrice,
                proPlanDiscountPrice: (monthProPrice * 12).toFixed(2),
                prePlanDiscountPrice: (monthPrePrice * 12).toFixed(2),
                freePlanPrice,
                prePlanId: 9,
                proPlanId: 8,
                preDiscount: Number(plans['year'][1]?.coupon_info?.rate) === 0 ? 0 : Number(plans['year'][1]?.coupon_info?.rate),
                proDiscount: Number(plans['year'][0]?.coupon_info?.rate) === 0 ? 0 : Number(plans['year'][0]?.coupon_info?.rate),
                isShowMonth: false,
                isShowYear: true,
                preVersionLevel: '2_pre',
                proVersionLevel: '2_pro',
                preDiscountPrice: (plans['year'][1].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['year'][1].discount_price) ? (Number(plans['year'][1].discount_price) === 0 ? 0 : Number(plans['year'][1].discount_price)) : -1) : -1,
                proDiscountPrice: (plans['year'][0].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['year'][0].discount_price) ? (Number(plans['year'][0].discount_price) === 0 ? 0 : Number(plans['year'][0].discount_price)) : -1) : -1,
                preYearPeriod: Boolean(prePeriod) ? Number(prePeriod) : 0,
                proYearPeriod: Boolean(proPeriod) ? Number(proPeriod) : 0,
                // preYearPeriod: Boolean(plans['year'][1].discount_period && plans['year'][1].discount_period !== 0) ? Number(plans['year'][1].discount_period) : 0,
                // proYearPeriod: Boolean(plans['year'][0].discount_period && plans['year'][0].discount_period !== 0) ? Number(plans['year'][0].discount_period) : 0,
                isShowCouponDis,
                userInfo: newUserinfo,
            }, () => {
                // 当不是免费用户 且 套餐等级不是月费时 
                // 当用户是月费
                let isHasTrialyPre = pricing.trial_days !== 0 ? true : newUserinfo?.pre_trial_days ? true : false;  // Prem..
                let isHasTrialyPro = pricing.trial_days !== 0 ? true : newUserinfo?.pro_trial_days ? true : false;  // Pro
                switch (Number(pricing.level)) {
                    case 1:
                        if (Number(pricing.ppid) === 1) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 2:
                        if (Number(pricing.ppid) === 8) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: 0,
                                expertPlanBtnStatus: 2,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 3:
                        if (Number(pricing.ppid) === 9) {
                            this.setState({
                                prePlanBtnStatus: 0,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        } else if (Number(pricing.ppid) === 10) {
                            this.setState({
                                prePlanBtnStatus: 2,
                                proPlanBtnStatus: 2,
                                expertPlanBtnStatus: 0,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    default:
                        return;
                }
                // 计算倒计时
                if (Boolean(plans['year'][1].discount_exp) && predisType === 'discount') {
                    let timePoint = plans['year'][1].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(plans['year'][1].discount_exp, 'preYearCountDown', 'preyDis')
                        }, 0)
                    }
                }
                if (Boolean(plans['year'][0].discount_exp) && prodisType === 'discount') {
                    let timePoint = plans['year'][0].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(plans['year'][0].discount_exp, 'proYearCountDown', 'proyDis')
                        }, 0)
                    }
                }

                if (Boolean(plans['year'][1]?.coupon_info?.expires_in) && predisType === 'code') {
                    this.setState({
                        preYRecode: plans['year'][1].coupon_info.code
                    }, () => {
                        let timePoint = plans['year'][1].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['year'][1].coupon_info.expires_in, 'preYearCountDown', 'preyCode')
                            }, 0)
                        }
                    })
                }
                if (Boolean(plans['year'][0]?.coupon_info?.expires_in) && prodisType === 'code') {
                    this.setState({
                        proYRecode: plans['year'][0].coupon_info.code
                    }, () => {
                        let timePoint = plans['year'][0].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['year'][0].coupon_info.expires_in, 'proYearCountDown', 'proyCode')
                            }, 0)
                        }
                    })
                }
            })
        } else { }
    }

    // 删除Pre订阅器
    delTimeArrPreData = () => {
        premArr.map(timer => {
            clearInterval(timer);
            premArr.pop();
            return false;
        })
        premArr = [];
    }
    // 删除Pro订阅器
    delTimeArrProData = () => {
        promArr.map(timer => {
            clearInterval(timer);
            promArr.pop();
            return false;
        })
        promArr = [];
    }
    // 删除Pre订阅器
    delTimeArrPreYData = () => {
        preyArr.map(timer => {
            clearInterval(timer);
            preyArr.pop();
            return false;
        })
        preyArr = [];
    }
    // 删除Pro订阅器
    delTimeArrProYData = () => {
        proyArr.map(timer => {
            clearInterval(timer);
            proyArr.pop();
            return false;
        })
        proyArr = [];
    }

    // 价格详情展开方法
    setExpanded = (val) => {
        this.setState({
            pricingDetailBtnStatus: val,
            isShowPricingState: !this.state.isShowPricingState
        })
    }

    // 升级/切换套餐
    handleUpdatePricingMeal = async (id, price, ver_level, disObject, skipReview = false) => {
        // 年费扣费后使用时长 < 30 天的商家，切换套餐时先弹出提示
        if (!skipReview && this.maybeShowSwitchReviewModal(id, () => this.handleUpdatePricingMeal(id, price, ver_level, disObject, true))) {
            return;
        }
        let { isComboUser, defalutDis } = this.state;
        if (isComboUser) {
            // cw组合付费用户
            this.setState({
                isShowCwComboModal: true
            }, () => {
                let yPrice = !Boolean(disObject?.discount) ? ((price * defalutDis) / 12).toFixed(2) : (price / 12).toFixed(2);
                this.cioDataSet(([2, 4].includes(id) ? 'monthly' : [8, 9].includes(id) ? 'annually' : ''), ([2, 8].includes(id) ? 'Pro Plan' : [4, 9].includes(id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(id) ? yPrice : price));
            })
        } else {
            // 计算最后的提交价格
            let endPrice = 0;
            let isGetDiscount = false;
            let isGetCodeDiscount = false;
            // 判断优惠力度
            if (!Boolean(disObject.discount) && (Number(disObject.discount) < 0 || isNaN(disObject.discount))) {
                // 优惠折扣
                if (disObject.actMealDiscount > 0) {
                    endPrice = disObject.actMealDiscount;
                    isGetDiscount = true;
                } else {
                    endPrice = price;
                }
            } else if (Number(disObject.discount) >= 0 && Number(disObject.discount) < 1) {
                if (Number((Number(Number(disObject.discount)) * price).toFixed(2)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                    endPrice = disObject.actMealDiscount;
                    isGetDiscount = true;
                } else {
                    endPrice = Number((Number(Number(disObject.discount)) * price).toFixed(2));
                    isGetCodeDiscount = true;
                    // endPrice = price;
                }
            } else if (Number(disObject.discount) >= 1) {
                if (Number(price - Number(disObject.discount)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                    endPrice = disObject.actMealDiscount;
                    isGetDiscount = true;
                } else {
                    endPrice = Number(price - Number(disObject.discount));
                    isGetCodeDiscount = true;
                    // endPrice = price;
                }
            } else {
                endPrice = price;
            }
            this.setState({
                paidLoading: true,
                paidDisabled: true,
                paidBtnLoading: ver_level
            })

            // 获取套餐来源
            let { planInfo } = this.state;
            const _params = {
                source_type: "upgrade",
                planRes: this.state.pricingData,
                planInfo,
                selData: id === 2 ? planInfo.pro_month : id === 4 ? planInfo.pre_month : id === 8 ? planInfo.pro_year : id === 9 ? planInfo.pre_year : planInfo.pro_month,
            }
            let _t = this.props.handleGetPlanSource('enter_checkout', _params);
            
            // 参数
            let params = {
                ppid: id,
                price: Number(endPrice),
                is_verify: 0,

                source_type: _t.source_type,
                source_position: _t.source_position,
                plan_type: _t.plan_type,
                plan_version: _t.plan_version,
                discount: _t.discount,
                paid_type: _t.paid_type,
            }
            if (isGetDiscount) {
                // 活动折扣
                let ppList = this.state.pricingPlanList;
                let list_plan = [...ppList['free'], ...ppList['month'], ...ppList['year']];
                params['activity_id'] = list_plan.filter(item => item.id === id)[0].activity_id;
            }
            if (isGetCodeDiscount) {
                // 优惠券折扣
                let { proMRecode, preMRecode, proYRecode, preYRecode } = this.state;
                params['coupon_code'] = id === 2 ? proMRecode : id === 4 ? preMRecode : id === 8 ? proYRecode : id === 9 ? preYRecode : proMRecode;
            }

            // cio埋点
            let yPrice = !Boolean(disObject?.discount) ? ((endPrice * defalutDis) / 12).toFixed(2) : (endPrice / 12).toFixed(2);
            this.cioDataSet(([2, 4].includes(id) ? 'monthly' : [8, 9].includes(id) ? 'annually' : ''), ([2, 8].includes(id) ? 'Pro Plan' : [4, 9].includes(id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(id) ? yPrice : endPrice));

            // posthog 弹窗埋点
            this.props.cwreportCustomBehavior('enter_checkout', _params);

            // 请求
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                // this.props.toggleToast(res.msg, false);
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        this.handleJumpSubUrl(j_url);
                    }
                }
            } else {
                // 老用户一次性付费
                if (res.code === 202) {
                    this.setState({
                        oldPayModalStatus: true,
                        paidLoading: false
                    })
                } else {
                    this.setState({
                        paidLoading: false,
                        paidBtnLoading: '',
                        paidDisabled: false,
                    }, () => {
                        this.props.toggleToast(res.msg, true);
                    })
                }
            }
        }
    }

    // 增加服务升级
    handleUpdatePricingMealExpert = () => {
        // this.cioDataSet('monthly', 'Enterprise', 0, 399);
        this.setState({
            paidLoading: true,
            paidDisabled: true,
            paidBtnLoading: 10,
        }, async () => {
            let params = {
                ppid: 10,
            }
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        this.handleJumpSubUrl(j_url);
                    }
                }
            } else {
                // 老用户一次性付费
                if (res.code === 202) {
                    this.setState({
                        oldPayModalStatus: true,
                        paidLoading: false
                    })
                } else {
                    this.setState({
                        paidLoading: false,
                        paidDisabled: false,
                        paidBtnLoading: '',
                    }, () => {
                        this.props.toggleToast(res.msg, true);
                    })
                }
            }
        })
    }

    // 降级免费
    handleDowngrade = (isTrue = false, isSkip = false, skipReview = false) => {
        // 年费扣费后使用时长 < 30 天的商家，首次点击"Switch to Free"降级时先弹出提示
        if (!isTrue && !skipReview && this.maybeShowSwitchReviewModal(1, () => this.handleDowngrade(isTrue, isSkip, true))) {
            return;
        }
        let { isHaveDiscount, isComboUser } = this.state;
        if (isComboUser) {
            // cw组合付费用户
            this.setState({
                isShowCwComboModal: true
            })
        } else {
            if (!isTrue) {
                // 弹窗确认是否降级
                this.setState({
                    retainOpenState: true,
                    // openFreePlanDegrade: true,
                })
            } else if (isHaveDiscount && !isSkip) {
                // 降级优惠折扣
                this.setState({
                    openFreePlanDegrade: false,
                    isShowFiveModal: true
                })
            } else {
                this.setState({
                    paidLoading: true
                }, async () => {
                    // 确认降级
                    const res = await reqGetSubscriptionCancel({ ppid: this.state.userInfo.ppid });
                    if (res.ack === 1) {
                        this.props.toggleToast(t("Cancel successfully"), false)
                        setTimeout(() => {
                            this.setState({
                                openFreePlanDegrade: false,
                                isShowFiveModal: false,
                                paidLoading: false,
                                loadingPage: true,
                                retainOpenState: false,
                            }, () => {
                                // 获取套餐版本
                                let { downgradeType } = this.state;
                                this.props.callbackGetHome();
                                this.getUserPricingPlanList(isSkip && (downgradeType && downgradeType !== 'longer'));
                            })
                        }, 1000)
                    } else {
                        this.setState({
                            paidLoading: false
                        }, () => {
                            this.props.toggleToast(t(res.msg), true)
                        })
                    }
                })
            }
        }
    }

    // 关闭就用户再支付提示弹窗
    closePayTipModal = () => {
        this.setState({
            oldPayModalStatus: !this.state.oldPayModalStatus,
            paidDisabled: false,
            paidBtnLoading: '',
        })
    }

    // 监听支付跳转
    handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                this.handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 输入折扣码
    handleDiscountChange = (val) => {
        this.setState({
            discountVal: val,
            discountValError: ''
        })
    }

    // 验证折扣码
    verifyDisCode = async (isSAD = false) => {
        let { discountVal, retainOpenState } = this.state;
        if (!Boolean(discountVal)) {
            this.setState({
                discountValError: 'The input field cannot be empty'
            })
            return false;
        }
        this.setState({ disBtnLoading: true })
        const params = {
            ref_code: discountVal.trim()
        }
        const res = await reqGetPricingCouponData(params);
        if (res.ack === 1) {
            this.props.toggleToast(t("Apply successfully"), false);
            // 清除定时器
            this.delDiscountTimeArr();
            this.delTimeArrPreData();
            this.delTimeArrPreYData();
            this.delTimeArrProYData();
            this.delTimeArrProData();
            const planList = {
                0: "All plan",
                2: "Pro plan",
                4: "Premium plan",
                8: "Pro plan year", // 已隐藏的版本
                9: "Premium plan year", // 已隐藏的版本
            }
            let discountArr = [];
            res.data.forEach(item => {
                let rate = Number(item.rate);
                discountArr.push({
                    discountRate: rate === 0 ? 0 : (rate < 1 ? (1 - rate) : rate),
                    discountPlan: this.getPlanText(planList, JSON.stringify(item.meal_plan)),
                    discountExpIn: getRemainingHours(item.expires_in * 1000),
                });
            })
            this.setState({
                // discountRate: rate === 0 ? 0 : (rate < 1 ? (1 - rate) : rate),
                // discountPlan: this.getPlanText(planList, res.data.meal_plan),
                // discountExpIn: getRemainingHours(res.data.expires_in * 1000),
                discountArr,
                isShowDisTicket: true,
                discountValError: '',
                retainOpenState: false,
                // isShowVerifyModal: false,
                // discountVal: '',
                // isShowSADModal: isSAD,

            }, () => {
                this.getUserPricingPlanList();
            })
        } else {
            if (retainOpenState) {
                this.props.toggleToast(t(res.msg), true);
            } else {
                this.setState({
                    discountValError: res.msg
                })
            }
        }

        if (res) {
            this.setState({
                disBtnLoading: false,
            })
        }
    }

    // 获取套餐版本文案
    getPlanText = (planList, rawIds) => {
        if (!rawIds) return "";

        // 去掉 [ ] 和空格，转换为数字数组并排序
        const ids = rawIds
            .replace(/[\[\]\s]/g, "")
            .split(",")
            .filter(Boolean)
            .map(Number)
            .sort((a, b) => a - b);

        // 除去 0 后的完整列表
        const allIds = Object.keys(planList)
            .map(Number)
            .filter((id) => id !== 0);

        // 是否包含全部 plan
        const hasAll = ids.includes(0) || allIds.every((id) => ids.includes(id));
        if (hasAll) return `For ${planList[0]}`;

        // 拼接多个 plan 名称，用 " & " 分隔
        const plans = ids.map((id) => planList[id]).filter(Boolean);
        return `For ${plans.join(" & ")}`;
    };

    // 关闭优惠券验证弹窗
    handleToggleVerifyModal = () => {
        this.setState({
            isShowVerifyModal: !this.state.isShowVerifyModal,
            discountVal: '',
            discountValError: '',
            codeFocus: true,
            isShowDisTicket: false,
        })
    }

    // 打开额外福利弹窗
    showExtraGiftModal = () => {
        this.setState({
            isShowExtraGift: true
        })
    }

    // 关闭倒计时banner
    closeTimeBanner = () => {
        this.setState({
            diyBannerState: false,
        }, () => {
            this.requestStateSet('pricingTimeBanner');
        })
    }

    // 打开反馈弹窗
    openFeedbackModal = (showFeedback = false) => {
        this.setState({
            isShowFiveModal: false,
            isShowFeedback: showFeedback,
        })
    }

    // 发送反馈
    sendFeedbackInfo = () => {
        let { updateFeedback, notExpectVal, poorVal, lackVal, performVal, securityVal, expensiveVal, softwareVal, othersVal, notExpectInfoVal, poorInfoVal, lackInfoVal, performInfoVal, securityInfoVal, expensiveInfoVal, softwareInfoVal, othersInfoVal } = this.state;
        let dataObj = {
            notExpect: { state: notExpectVal, value: notExpectInfoVal, field: 'Function not as expected' },
            poor: { state: poorVal, value: poorInfoVal, field: 'Poor user interface experience' },
            lack: { state: lackVal, value: lackInfoVal, field: 'Lack of required features or content' },
            perform: { state: performVal, value: performInfoVal, field: 'Performance issues (such as lags, crashes, etc.)' },
            security: { state: securityVal, value: securityInfoVal, field: 'security concerns' },
            expensive: { state: expensiveVal, value: expensiveInfoVal, field: 'Too expensive' },
            software: { state: softwareVal, value: softwareInfoVal, field: 'There is more suitable software to use' },
            others: { state: othersVal, value: othersInfoVal, field: 'Others' },
            update: { state: true, value: updateFeedback, field: 'update' },
        }
        let reasonField = Object.keys(dataObj).filter(r => r !== 'update' && r !== 'others' && dataObj[r].state);
        let otherState = dataObj.others.state && dataObj.others.value.replace(/\s/g, "") === "";
        let updateState = dataObj.update.state && dataObj.update.value.replace(/\s/g, "") === "";
        this.setState({
            sendLoading: true,
        }, async () => {
            if ((reasonField.length > 0 || (!otherState && dataObj.others.state)) && !updateState) {
                const params = {
                    flag: 3,
                    title: "SEOWILL-降级反馈",
                    description: JSON.stringify(dataObj)
                }
                const res = await reqReviewTipsClick(params);
                if (res.ack === 1) {
                    this.props.toggleToast(t("Success"));
                    this.setState({
                        sendLoading: false,
                        isShowFeedback: false,
                    }, () => {
                        this.closeNeedFeedback();
                        setTimeout(() => {
                            this.setState({
                                discountVal: 'STAY50',
                                codeFocus: true
                            })
                        }, 500)
                    })
                } else {
                    this.setState({
                        sendLoading: false,
                        isShowWarnFeedback: res.msg,
                    })
                }
            } else {
                this.setState({
                    isShowReasonSet: (reasonField.length === 0 && (otherState || !dataObj.others.state)) ? true : this.state.isShowReasonSet,
                    isShowUpdateSet: updateState ? true : this.state.isShowUpdateSet,
                    sendLoading: false,
                    isShowWarnFeedback: "The selected options must be filled in",
                })
            }
        })
    }

    // 发送【see you】反馈
    sendSeeYouFeedback = async (type, operation, info) => {
        let dataObj = {
            type,
            operation,
            info: info,
        };
        const params = {
            flag: 6,
            title: "SEOWILL-挽留&降级反馈",
            description: JSON.stringify(dataObj)
        }
        await reqReviewTipsClick(params);
    }


    // 下拉反馈填写
    openFeedbackSet = (type = 1) => {
        let { isShowReasonSet, isShowUpdateSet } = this.state;
        if (type === 1) {
            this.setState({
                isShowReasonSet: !isShowReasonSet
            })
        } else {
            this.setState({
                isShowUpdateSet: !isShowUpdateSet
            })
        }
    }

    // 输入
    handleInputVal = (val, type) => {
        this.setState({
            [type]: val
        })
    }

    // 多选
    handleCheckVal = (val, type) => {
        this.setState({
            [type]: val
        })
    }

    // 关闭反馈
    closeNeedFeedback = () => {
        this.setState({
            isShowFeedback: false,
            isShowReasonSet: false,
            isShowUpdateSet: false,
            notExpectVal: false,
            poorVal: false,
            lackVal: false,
            performVal: false,
            securityVal: false,
            expensiveVal: false,
            softwareVal: false,
            othersVal: false,
            notExpectInfoVal: '',
            poorInfoVal: '',
            lackInfoVal: '',
            performInfoVal: '',
            securityInfoVal: '',
            expensiveInfoVal: '',
            softwareInfoVal: '',
            othersInfoVal: '',
            updateFeedback: '',
            isShowWarnFeedback: '',
        })
    }

    // 跳转cw集合页
    goSolutionExpert = () => {
        utils.routeJump(this, "/settings", null, { selected: "Solutionexpert", tabkey: 5 });
    }

    // 跳转设置页超额
    goSettingsOvercharge = () => {
        utils.routeJump(this, "/settings", null, 'overage');
    }

    // 调起客服
    handleContactService = () => {
        try {
            showNewMessage('');
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // ====== 切换套餐提示弹窗（年费扣费后使用时长 < 30 天）======
    // 套餐展示名称
    getPlanDisplayName = (ppid) => {
        const nameMap = {
            1: t("Free"),
            2: `${t("Pro")} ${t("Monthly")}`,
            4: `${t("Premium")} ${t("Monthly")}`,
            8: `${t("Pro")} ${t("Annual")}`,
            9: `${t("Premium")} ${t("Annual")}`,
            10: t("Enterprise"),
        };
        return nameMap[ppid] || t("Free");
    }

    // 是否展示"切换套餐提示"弹窗，并返回展示所需数据
    getSwitchReviewInfo = (selectedPpid) => {
        const ppid = this.state.userInfo?.ppid;
        // 后端字段：年费扣费后使用时长 < 30 天时为 true，此时切换套餐需先弹窗提示
        const shouldShow = Boolean(this.state.userInfo?.year_charge_within_30_days);

        return {
            shouldShow,
            currentPlan: this.getPlanDisplayName(ppid),
            selectedPlan: this.getPlanDisplayName(selectedPpid),
            // 下次扣费日期（unix 秒级时间戳）
            nextChargeTime: this.state.userInfo?.year_charge_next_time || 0,
        };
    }

    // 拦截切换/降级操作，满足条件时展示弹窗；返回 true 表示已拦截
    maybeShowSwitchReviewModal = (selectedPpid, proceedFn) => {
        const info = this.getSwitchReviewInfo(selectedPpid);
        if (info.shouldShow) {
            this.setState({
                openSwitchReviewModal: true,
                switchReviewData: {
                    currentPlan: info.currentPlan,
                    selectedPlan: info.selectedPlan,
                    nextChargeTime: info.nextChargeTime,
                    proceedFn,
                },
            });
            return true;
        }
        return false;
    }

    // 关闭切换套餐提示弹窗
    closeSwitchReviewModal = () => {
        this.setState({ openSwitchReviewModal: false });
    }

    // 点击 Switch Plan：继续原来的切换/降级操作
    confirmSwitchReview = () => {
        const { switchReviewData } = this.state;
        this.setState({ openSwitchReviewModal: false }, () => {
            if (typeof switchReviewData?.proceedFn === "function") {
                switchReviewData.proceedFn();
            }
        });
    }

    // 点击 Contact support：调起客服并预填文案
    handleSwitchReviewContact = () => {
        const { switchReviewData } = this.state;
        const selectedPlan = switchReviewData?.selectedPlan || "";
        const msg = t("Hi, I'd like to switch my Annual plan to {{v1}}. Please help me review any eligible refund.", selectedPlan);
        try {
            showNewMessage(msg);
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 跳转页面
    jumpUrl = (url) => {
        utils.routeJump(this, url);
    }

    // 年月费切换
    handlePlansToggle = (type) => {
        this.move(type)
    };

    // 关闭降级保留提示弹窗
    closeSeeyouModal = (type, info) => {
        this.setState({
            retainOpenState: false,
        }, () => {
            let { downgradeType } = this.state;
            if ((['other', 'longer'].includes(type) || downgradeType) && info) {
                this.sendSeeYouFeedback(type || downgradeType, 'Keep plan', info);
            }
        })
    }

    // 应用折扣码
    applyDiscountCode = (type, info) => {
        this.setState({
            discountVal: 'STAY503',
        }, () => {
            this.verifyDisCode(true);
            this.sendSeeYouFeedback(type, 'Apply discount code', info);
        })
    }

    // 取消订阅
    downgradeAnyway = (type, info) => {
        this.setState({
            downgradeType: type,
            downgradeLevel: this.state.level,
        }, () => {
            this.handleDowngrade(true, true);
            this.sendSeeYouFeedback(type, 'Cancel anyway', info);
        })
    }

    // 关闭 信息查看 弹窗
    closeInfoViewModal = () => {
        this.setState({
            isShowFeedback: false,
        })
    }

    // 发送反馈
    sendSuggestionAction = (type, feedbackVal) => {
        this.sendSeeYouFeedback(type, 'Can improve feedback', feedbackVal);
    }

    // 关闭成功应用挽留折扣弹窗
    handleCloseSADModal = () => {
        this.setState({
            isShowSADModal: false,
        })
    }

    // cw埋点
    cioDataSet = (type, version, quota, price) => {
        try {
            if (window.shopify && window.cio?.initialized) {
                window.cio?.trigger({
                    event: 'change_plan',
                    payload: {
                        plan_type: type, // 'monthly' | 'annually'
                        plan_version: version,
                        // plan_quota: quota,
                        plan_monthly_price: price
                    }
                })
            }

            // posthog埋点
            this.cwreportPlanDataSet(type, version, quota, price);
        } catch { }
    }

    // cw埋点 套餐
    cwreportPlanDataSet = (type, version, quota, price) => {
        try {
            if (window.shopify && cwreport) {
                transportReport('change_plan', {
                    plan_type: type, // 'monthly' | 'annually'
                    plan_version: version,
                    // plan_quota: quota,
                    plan_monthly_price: `${price}`
                })
            }
        } catch { }
    }

    // 清除定时器
    delDiscountTimeArr = () => {
        discountTimeArr.map(timer => {
            clearInterval(timer);
            discountTimeArr.pop();
            return false;
        })
        discountTimeArr = [];
    }

    // 发送请求
    requestStateSet = async (type, st = 0) => {
        const params = {
            name: `${type}`,
            st,
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": st, "exp": 0 };
            this.props.setSwitchData(data);
            if (st === 1) {
                this.props.toggleToast(t("Success"));
                setTimeout(() => {
                    utils.routeJump(this, "/dashboard");
                }, 1000)
            }
        } else {
            // this.props.toggleToast(t("Try again later"), true)
        }
    }

    componentWillUnmount() {
        // 清理拦截器
        if (this.unblock) {
            this.unblock();
        }
        // 清除定时器
        this.clearAllTimer();
    }

    render() {
        const {
            state: {
                userInfo,
                selectId,
                openFreePlanDegrade,
                openSwitchReviewModal,
                openModalChange,
                openModalLoading,
                modalData,
                moveAnimation,
                prePlanId,
                proPlanId,
                freePlanId,
                prePlanPrice,
                proPlanPrice,
                freePlanPrice,
                prePlanBtnStatus,
                proPlanBtnStatus,
                freePlanBtnStatus,
                preDiscount,
                proDiscount,
                isShowMonth,
                isShowYear,
                old_button,
                isShowPricingState,
                oldPayModalStatus,
                preVersionLevel,
                proVersionLevel,
                preDiscountPrice,
                proDiscountPrice,
                preMonthCountDown,
                proMonthCountDown,
                preMonthCountDown_mills,
                proMonthCountDown_mills,
                preYearCountDown,
                proYearCountDown,
                preYearCountDown_mills,
                proYearCountDown_mills,
                // isMonthOrYear,
                preMonthPeriod,
                proMonthPeriod,
                preYearPeriod,
                proYearPeriod,
                discountVal,
                disBtnLoading,
                discountValError,
                // discountRate,
                // discountPlan,
                // discountExpIn,
                isShowDisTicket,
                isShowExtraGift,
                appGiftList,
                paidBtnLoading,
                // cDays,
                // cHours,
                cMins,
                cSecs,
                aHours,
                // planName,
                diyBannerState,
                isShowFiveModal,
                isShowFeedback,
                // isShowReasonSet,
                // isShowUpdateSet,
                // updateFeedback,
                // notExpectVal,
                // poorVal,
                // lackVal,
                // performVal,
                // securityVal,
                // expensiveVal,
                // softwareVal,
                // othersVal,
                // notExpectInfoVal,
                // othersInfoVal,
                // isShowWarnFeedback,
                // sendLoading,
                codeFocus,
                iscacheLoading,
                questionList,
                isShowCwComboModal,
                isActLoading,
                // isShowCouponDis,
                newPlanService,
                mTabBtnWidth,
                yTabBtnWidth,
                annualDisText,
                defalutDis,
                isShowVerifyModal,
                infoImg,
                trial_discount,
                timeType,
                isShowTrialBanner,
                planInfo,
                language,
                discountArr,
                retainOpenState,
                paidLoading,
                downgradeType,
                downgradeLevel,
                downDataCompare,
                coupon_claimed,
                isShowSADModal,
            },
            setExpanded,
            handleUpdatePricingMeal,
            handleDowngrade,
        } = this;

        // 获取窗口宽度
        const { windowWidth } = this.props;

        // 完成icon
        const FinishIcon = <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 5.00002L4.5 8.00002L10.5 2.00002" stroke="var(--color-primary)" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        // 折扣横幅banner
        const DiscountBanner = Boolean(((moveAnimation === 1 && !Boolean(planInfo.pre_month?.code) && !Boolean(planInfo.pro_month?.code)) || (moveAnimation === 2 && !Boolean(planInfo.pre_year?.code) && !Boolean(planInfo.pro_year?.code))) && Boolean(trial_discount !== -1) && isShowTrialBanner) ? (windowWidth <= 800 ? <div className='discount-banner discount-mb'>
            <img src='/imgs/pricing/imgs/coupon/LimitedTimeMb.png' alt='' />
            <div className='discount-banner-content'>
                <div>
                    <div className='discount-banner-content-main'>
                        <span className='discount-number'>{t(trial_discount)}</span>
                        {
                            moveAnimation === 1 ? <span>{(planInfo.pre_month?.period > 1 || planInfo.pro_month?.period > 1) ? t("For {{v1}} Month", (planInfo.pre_month?.period || planInfo.pro_month?.period)) : t("For The First Month")}</span> : <span>{(planInfo.pre_year?.period > 1 || planInfo.pro_year?.period > 1) ? t("For {{v1}} Year", (planInfo.pre_year?.period || planInfo.pro_year?.period)) : t("For The First Year")}</span>
                        }
                    </div>
                    <div className='discount-banner-content-desc'>
                        <span>{t("Start your trial today")} — {(moveAnimation === 1 && (planInfo.pre_month?.trial_days || planInfo.pro_month?.trial_days) || moveAnimation === 2 && (planInfo.pre_year?.trial_days || planInfo.pro_year?.trial_days)) ? t("{{v1}} days free", moveAnimation === 1 ? (planInfo.pre_month?.trial_days || planInfo.pro_month?.trial_days) : moveAnimation === 2 ? (planInfo.pre_year?.trial_days || planInfo.pro_year?.trial_days) : 0) + ", " + t("then") : ""} {(moveAnimation === 1 ? (t(planInfo.pre_month?.rateText) || t(planInfo.pro_month?.rateText)) : moveAnimation === 2 ? (t(planInfo.pre_year?.rateText) || t(planInfo.pro_year?.rateText)) : "")} {(moveAnimation === 1 ? (planInfo.pre_month?.period > 1 || planInfo.pro_month?.period > 1) ? t("for {{v1}} month!", (planInfo.pre_month?.period || planInfo.pro_month?.period)) : t("for the first month!") : moveAnimation === 2 ? (planInfo.pre_year?.period > 1 || planInfo.pro_year?.period > 1) ? t("for {{v1}} year!", (planInfo.pre_year?.period || planInfo.pro_year?.period)) : t("for the first year!") : "")}</span>
                    </div>
                </div>
                <div className='discount-banner-content-time'>
                    <span>{aHours} {t("Hours")}</span>
                    <span>{cMins} {t("Mins")}</span>
                    <span>{cSecs} {t("Secs")}</span>
                </div>
            </div>
        </div> : <div className='discount-banner discount-pc'>
            <img src={`${language === 'en' ? '/imgs/pricing/imgs/coupon/LimitedTime-en-time.png' : '/imgs/pricing/imgs/coupon/LimitedTime.png'}`} alt='' />
            <div className={`discount-banner-content ${language === 'en' ? 'en-banner' : ''}`}>
                <div className='discount-banner-content-info'>
                    <div className='discount-banner-content-main'>
                        <span>{t("Today Only")}:</span>
                        <span className='discount-number'>{t(trial_discount)}</span>
                        {
                            moveAnimation === 1 ? <span>{(planInfo.pre_month?.period > 1 || planInfo.pro_month?.period > 1) ? t("For {{v1}} Month", (planInfo.pre_month?.period || planInfo.pro_month?.period)) : t("For The First Month")}</span> : <span>{(planInfo.pre_year?.period > 1 || planInfo.pro_year?.period > 1) ? t("For {{v1}} Year", (planInfo.pre_year?.period || planInfo.pro_year?.period)) : t("For The First Year")}</span>
                        }
                    </div>
                    <div className='discount-banner-content-desc'>
                        <span>{t("Start your trial today")} — {(moveAnimation === 1 && (planInfo.pre_month?.trial_days || planInfo.pro_month?.trial_days) || moveAnimation === 2 && (planInfo.pre_year?.trial_days || planInfo.pro_year?.trial_days)) ? t("{{v1}} days free", moveAnimation === 1 ? (planInfo.pre_month?.trial_days || planInfo.pro_month?.trial_days) : moveAnimation === 2 ? (planInfo.pre_year?.trial_days || planInfo.pro_year?.trial_days) : 0) + ", " + t("then") : ""} {(moveAnimation === 1 ? (t(planInfo.pre_month?.rateText) || t(planInfo.pro_month?.rateText)) : moveAnimation === 2 ? (t(planInfo.pre_year?.rateText) || t(planInfo.pro_year?.rateText)) : "")} {(moveAnimation === 1 ? (planInfo.pre_month?.period > 1 || planInfo.pro_month?.period > 1) ? t("for {{v1}} month!", (planInfo.pre_month?.period || planInfo.pro_month?.period)) : t("for the first month!") : moveAnimation === 2 ? (planInfo.pre_year?.period > 1 || planInfo.pro_year?.period > 1) ? t("for {{v1}} year!", (planInfo.pre_year?.period || planInfo.pro_year?.period)) : t("for the first year!") : "")}</span>
                    </div>
                </div>
                {
                    language === 'en' ? <div className='discount-banner-content-time-en'>
                        <span>{aHours} {t("Hours")} : {cMins} {t("Mins")} : {cSecs} {t("Secs")}</span>
                    </div> : <div className='discount-banner-content-time'>
                        <span>{aHours} {t("Hours")}</span>
                        <span>{cMins} {t("Mins")}</span>
                        <span>{cSecs} {t("Secs")}</span>
                    </div>
                }
            </div>
        </div>) : null

        // 年月费Tab
        const TabPlansBlock = <div className={`pricing-toggle`}>
            <div className="Silder-block" style={{ width: moveAnimation === 1 ? mTabBtnWidth : yTabBtnWidth, left: moveAnimation === 1 ? "6px" : mTabBtnWidth + 11 }}></div>
            <div
                id="monthly"
                className={`toggle-option ${moveAnimation === 1 ? 'monthly-active' : ''}`}
                onClick={() => this.handlePlansToggle(1)}
            >
                {t("Monthly")}
            </div>
            <div
                id="annual"
                className={`toggle-option ${moveAnimation === 2 ? 'annual-active' : ''}`}
                onClick={() => this.handlePlansToggle(2)}
            >
                <span>{t("Annual")}</span>
                <span id="discount" className="discount">{t(annualDisText)}</span>
            </div>
        </div>

        // 优惠券验证
        const CouponVerification = <div className='coupon-verification'>
            <Button variant="plain" onClick={this.handleToggleVerifyModal}>🎁 {t("Have a promo code?")}</Button>
        </div>
        const CouponView = (discount = "", plan = "", desc = "") => {
            return (
                <div className="coupon">
                    <div className="coupon-left">
                        {/* <div className="coupon-discount">
                            {`${discount === 0 ? '100% OFF' : (discount > 0 && discount < 1) ? (discount * 100).toFixed(0) + '% OFF' : '$ ' + discount}`}
                        </div> */}
                        <div className="coupon-discount">
                            {
                                discount === 0 ? <div className="coupon-discount-item perc_item">
                                    <h2>100%</h2>
                                    <p>OFF</p>
                                </div> :
                                    discount > 0 && discount < 1 ? <div className="coupon-discount-item perc_item">
                                        <h2>{Math.round(discount * 100)}%</h2>
                                        <p>OFF</p>
                                    </div> : <div className="coupon-discount-item">
                                        <h2>${discount}</h2>
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="coupon-center-line"></div>
                    <div className="coupon-right">
                        <div className='coupon-right-info'>
                            <Tooltip
                                content={t(plan)}
                            >
                                <div className="coupon-plan ellipsis_1">{t(plan)}</div>
                            </Tooltip>
                            <div className="coupon-desc">{t("Discount valid for {{v1}} hours", desc)}</div>
                        </div>
                        <div className='used_sign'>
                            <span>{t("Apply sucessfully")}</span>
                        </div>
                    </div>
                </div>
            );
        };
        const CouponVerificationModal = <Modal
            open={isShowVerifyModal}
            title={t("Apply Promo Code")}
            onClose={this.handleToggleVerifyModal}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    <TextField
                        placeholder={t("Enter your promo code")}
                        value={discountVal}
                        onChange={this.handleDiscountChange}
                        autoComplete="off"
                        disabled={iscacheLoading}
                        focused={codeFocus}
                        error={t(discountValError)}
                        prefix={<span className='flex_layout' style={{ margin: '0 5px 0 0' }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.4999 7.5C12.0522 7.5 12.4999 7.05228 12.4999 6.5C12.4999 5.94772 12.0522 5.5 11.4999 5.5C10.9477 5.5 10.4999 5.94772 10.4999 6.5C10.4999 7.05228 10.9477 7.5 11.4999 7.5Z" fill="var(--color-primary)" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.51686 4.09835C8.22012 3.39509 9.17395 3 10.1685 3H12.2499C13.7687 3 14.9999 4.23122 14.9999 5.75V8.03854C14.9999 8.9005 14.6575 9.72714 14.048 10.3366L9.84178 14.5429C8.86547 15.5192 7.28256 15.5192 6.30625 14.5429L3.63383 11.8705C2.55988 10.7965 2.55988 9.05532 3.63383 7.98138L7.51686 4.09835ZM10.1685 4.5C9.57177 4.5 8.99947 4.73705 8.57752 5.15901L4.69449 9.04204C4.20633 9.5302 4.20633 10.3217 4.69449 10.8098L7.36691 13.4822C7.75743 13.8728 8.3906 13.8728 8.78112 13.4822L12.9874 9.27598C13.3156 8.94779 13.4999 8.50267 13.4999 8.03854V5.75C13.4999 5.05965 12.9403 4.5 12.2499 4.5H10.1685Z" fill="var(--color-primary)" />
                                <path d="M16.7499 5.5C17.1641 5.5 17.4999 5.83579 17.4999 6.25V9.2786C17.4999 10.1482 17.1514 10.9815 16.5324 11.5922L11.7767 16.2839C11.4818 16.5748 11.0069 16.5716 10.716 16.2767C10.4251 15.9819 10.4283 15.507 10.7232 15.2161L15.479 10.5244C15.8123 10.1956 15.9999 9.74684 15.9999 9.2786V6.25C15.9999 5.83579 16.3357 5.5 16.7499 5.5Z" fill="var(--color-primary)" />
                            </svg>
                        </span>}
                        // connectedLeft={<span>
                        //     <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        //         <path d="M13.2481 4.60568C13.8133 4.03884 14.8536 3.31526 15.7371 3.40551L21.8234 4.03884C22.7069 4.13068 23.4986 4.92234 23.4986 5.71718L23.9071 11.5597C23.9973 12.4432 23.4321 13.485 22.7987 14.1199L13.3621 23.5677C12.7952 24.133 12.0036 24.133 11.3686 23.4759L3.85729 15.955C3.22396 15.3217 3.13054 14.5949 3.76546 13.96L13.2021 4.51384L13.2481 4.60568ZM27.7435 9.19577C28.2929 9.77844 28.6666 11.0119 28.6666 11.8273L28.513 25.4946C28.513 26.3085 27.8084 27.0542 27.0405 27.0542L19.0336 27.1476H17.4724C16.7029 27.1476 15.9983 26.4019 15.9983 25.588L16.0854 23.7007L23.8722 15.4594C25.2798 13.9695 25.587 12.3403 25.4999 11.4299L25.2592 6.56426L27.7435 9.19577ZM18.0915 9.22743C18.6995 9.83702 19.6986 9.9241 20.3272 9.31452C20.9352 8.70335 20.8702 7.69951 20.2417 7.06776C19.6336 6.45818 18.6346 6.3711 18.006 6.98068C17.398 7.61401 17.4629 8.61627 18.0915 9.22743Z" fill="var(--color-primary)" />
                        //     </svg>
                        // </span>}
                        connectedRight={<Button variant='primary' loading={disBtnLoading || iscacheLoading} onClick={() => this.verifyDisCode(false)}>{t("Apply")}</Button>}
                    />
                    {
                        Boolean(isShowDisTicket) && <BlockStack gap={200}>
                            {
                                discountArr.map(item => {
                                    return CouponView(item.discountRate, item.discountPlan, item.discountExpIn)
                                })
                            }
                            {/* {CouponView(discountRate, discountPlan, discountExpIn)} */}
                            <p style={{ textAlign: 'center', maxWidth: '90%', margin: '8px auto' }}>{t("Go back to the pricing page and select a plan to subscribe at the discounted price.")}</p>
                        </BlockStack>
                    }
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 成功应用挽留折扣弹窗
        const SuccessApplyDiscountModal = <Modal
            open={isShowSADModal}
            title={t("🎉 Your discount has been applied!")}
            onClose={this.handleCloseSADModal}
            primaryAction={{
                content: t("Back to Pricing"),
                onAction: this.handleCloseSADModal,
            }}
        >
            <Modal.Section>
                <BlockStack gap={400}>
                    {
                        Boolean(isShowDisTicket) ? <BlockStack gap={400}>
                            <Text as="p" tone="subdued">{t("Go back to the pricing page and select a plan to subscribe at the discounted price.")}</Text>
                            {
                                discountArr.map(item => {
                                    return CouponView(item.discountRate, item.discountPlan, item.discountExpIn)
                                })
                            }
                        </BlockStack> : null
                    }
                </BlockStack>
            </Modal.Section>
        </Modal>

        // 选择钩子
        const SelectHook = <div className='select_hook'>
            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 9L7.5 12L13.5 6" stroke="var(--color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>

        // 价格套餐子项
        const pricingContentItem = (version, price, btnStatus, current, title = "", info, isShowMonth = false, isShowYear = false, discount = '', ver_level, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills, forText, infoEnd, pData) => {
            const typeGroups = {
                month: {
                    Pro: ['promCode', 'promDis'],
                    Pre: ['premCode', 'premDis'],
                },
                year: {
                    Pro: ['proyCode', 'proyDis'],
                    Pre: ['preyCode', 'preyDis'],
                },
            };
            const planType = version.includes('Pro') ? 'Pro' : version.includes('Pre') ? 'Pre' : null;
            const period = isShowMonth ? 'month' : isShowYear ? 'year' : null;
            const shouldShow = planType && period && timeType.some((t) => typeGroups[period][planType].includes(t));
            const isTrial = Boolean(trial_discount !== -1) && ((isShowMonth && timeType.includes('promDis') && timeType.includes('premDis')) || (isShowYear && timeType.includes('proyDis') && timeType.includes('preyDis')));
            return <section className='pricingContentItem'>
                <div className='coupon_discount_time' style={{ opacity: (version !== 'Free' && shouldShow && !isTrial) ? 1 : 0 }}>
                    {
                        isShowMonth ? <>
                            <p>{cdMonth ? cdMonth.split(':')[0] : "00"}</p>
                            <span>:</span>
                            <p>{cdMonth ? cdMonth.split(':')[1] : "00"}</p>
                            <span>:</span>
                            <p>{cdMonth ? cdMonth.split(':')[2] : "00"}</p>
                        </> : isShowYear ? <>
                            <p>{cdYear ? cdYear.split(':')[0] : "00"}</p>
                            <span>:</span>
                            <p>{cdYear ? cdYear.split(':')[1] : "00"}</p>
                            <span>:</span>
                            <p>{cdYear ? cdYear.split(':')[2] : "00"}</p>
                        </> : <>
                            <p>-</p>
                            <span>:</span>
                            <p>-</p>
                            <span>:</span>
                            <p>-</p>
                        </>
                    }
                </div>
                <div className='pricingContentTop'>
                    <div className='pricingContentIcon'>
                        <Icon source={version.includes("Free") ? SpeedBasicIcon : version.includes("Pro") ? SpeedFastIcon : SpeedRocketIcon} />
                    </div>
                    <div>
                        <div className="mealVersion">
                            <span>{t(version)}</span>
                            {
                                version !== 'Free' && <span className='plan_discount'>
                                    {isShowMonth ? (
                                        version.includes('Pro') ? t(pData.pro_month?.rateText) : t(pData.pre_month?.rateText)
                                    ) : (
                                        version.includes('Pro') ? t(pData.pro_year?.rateText) : t(pData.pre_year?.rateText)
                                    )}
                                </span>
                            }
                        </div>
                        <div className={`mealPrice ${version.includes("Pre") ? 'pre_mealPrice' : ''}`}>
                            {/* 优惠券和优惠活动折扣力度判断 */}
                            {version === 'Free' ? `$0` : ((userInfo.pro_trial_days > 0 && version.includes("Pro")) || (userInfo.pre_trial_days > 0 && version.includes("Pre"))) ? <span className={`color_tip`}>
                                {/* 优惠券力度大 */}
                                ${isShowYear ? multiplyPrice(Number(price) / 12, Number(discount)) : multiplyPrice(Number(price), Number(discount))}
                                {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                {isShowYear ? <>
                                    <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                    <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price * discount)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                                </> : null}
                            </span> :
                                discount >= 0 && discount < 1 ? ((Number((price * discount).toFixed(2)) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span className={`${isShowMonth ? 'color_tip' : ''}`}>
                                    {/* 优惠活动力度大 */}
                                    ${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : Number(actMealDiscount.toFixed(2))}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - actMealDiscount).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                                    </> : null}
                                </span> : <span className={`color_tip`}>
                                    {/* 优惠券力度大 */}
                                    ${isShowYear ? multiplyPrice(Number(price) / 12, Number(discount)) : multiplyPrice(Number(price), Number(discount))}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price * discount)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                                    </> : null}
                                </span>) : discount !== 0 && discount >= 1 ? ((Number(price - discount) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span>
                                    {/* 优惠活动力度大 */}
                                    ${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : actMealDiscount}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number(actMealDiscount === 0 ? 0 : (price - actMealDiscount).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                                    </> : null}
                                </span> : <span className={`color_tip`}>
                                    {/* 优惠券力度大 */}
                                    ${isShowYear ? Number(((price - discount) / 12).toFixed(2)) : Number((price - discount).toFixed(2))}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price - discount)).toFixed(2)) === 0 ? 0 : Number((price - (price - discount)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                                    </> : null}
                                </span>) : actMealDiscount === -1 ? <span>
                                    ${isShowYear ? ((price * defalutDis) / 12).toFixed(2) : price}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<s>{version.includes("Pro") ? '$39.99' : '$79.99'}</s>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price * defalutDis)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                                    </> : null}
                                </span> : <span className={`color_tip`}>
                                    ${isShowYear ? (actMealDiscount / 12).toFixed(2) : actMealDiscount}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + (price - actMealDiscount).toFixed(2))}${t("/year · Billed annually")}`}</span>
                                    </> : null}
                                </span>
                            }
                        </div>
                    </div>
                </div>
                {
                    version === 'Free' && isShowYear ? <div style={{ height: '8px' }}></div> : null
                }
                {
                    iscacheLoading ? <div className='mealBtn'>
                        <Button size='large' loading={true}>{t("Upgrade")}</Button>
                    </div> :
                        <div className={`mealBtn btn_${ver_level}_${btnStatus} ${!Boolean(btnStatus) && !this.state.paidLoading && 'mealBtnDisable'}  ${btnStatus === 1 && 'mealDowngrade'}`}>
                            {btnStatus === 3 ? <Button size='large' loading={paidBtnLoading && paidBtnLoading === ver_level} disabled={Boolean(this.state.paidDisabled)} variant='primary' onClick={() => handleUpdatePricingMeal(current, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>
                                {t("Try Free For {{v1}} Days", (version.includes('Pro') && userInfo.pro_trial_days) ? userInfo.pro_trial_days : (version.includes('Pre') && userInfo.pre_trial_days) ? userInfo.pre_trial_days : userInfo.trial_days)}
                            </Button> : null}
                            {btnStatus === 2 ? <Button size='large' loading={paidBtnLoading && paidBtnLoading === ver_level} disabled={Boolean(this.state.paidDisabled)} variant='primary' onClick={() => handleUpdatePricingMeal(current, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>{t("Choose this plan")}</Button> : null}
                            {btnStatus === 1 ? <Button size='large' loading={0} disabled={Boolean(this.state.paidDisabled || paidBtnLoading)} onClick={() => handleDowngrade(false)}>{t("Switch to Free")}</Button> : null}
                            {btnStatus === 0 ? (
                                (ver_level && (discount > 0 || actMealDiscount > 0)) ? <Button size='large' loading={paidBtnLoading && paidBtnLoading === ver_level} disabled={Boolean(this.state.paidDisabled)} variant='primary' onClick={() => handleUpdatePricingMeal(current, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>{t("Update plan")}</Button> : <Button size='large' disabled={true} variant='primary'>{t("Current plan")}</Button>
                            ) : null}
                        </div>
                }
                <div className={`act_dis_desc ${isShowYear ? ((preYearPeriod !== 0 || proYearPeriod !== 0) ? 'dis_period' : '') : ((preMonthPeriod !== 0 || proMonthPeriod !== 0) ? 'dis_period' : '')}`}>
                    {
                        isShowYear ? (
                            version.includes('Pro') ? (
                                // pData.pro_year?.trial_days > 0 && pData.pro_year?.period <= 0 ? `${pData.pro_year?.trial_days > 0 ? t("{{v1}} days free", pData.pro_year?.trial_days) : ""}` : 
                                pData.pro_year?.period > 0 ? `${pData.pro_year?.trial_days > 0 ? t("{{v1}} days free, ", pData.pro_year?.trial_days) : ""}${pData.pro_year?.period <= 1 ? t("${{v1}} for the first year", pData.pro_year?.price) : t("${{v1}} for {{v2}} year", pData.pro_year?.price, pData.pro_year?.period)}` : ""
                            ) : version.includes('Pre') ? (
                                // pData.pre_year?.trial_days > 0 && pData.pre_year?.period <= 0 ? `${pData.pre_year?.trial_days > 0 ? t("{{v1}} days free", pData.pre_year?.trial_days) : ""}` : 
                                pData.pre_year?.period > 0 ? `${pData.pre_year?.trial_days > 0 ? t("{{v1}} days free, ", pData.pre_year?.trial_days) : ""}${pData.pre_year?.period <= 1 ? t("${{v1}} for the first year", pData.pre_year?.price) : t("${{v1}} for {{v2}} year", pData.pre_year?.price, pData.pre_year?.period)}` : ""
                            ) : null
                        ) : (
                            version.includes('Pro') ? (
                                // pData.pro_month?.trial_days > 0 && pData.pro_month?.period <= 0 ? `${pData.pro_month?.trial_days > 0 ? t("{{v1}} days free", pData.pro_month?.trial_days) : ""}` : 
                                pData.pro_month?.period > 0 ? `${pData.pro_month?.trial_days > 0 ? t("{{v1}} days free, ", pData.pro_month?.trial_days) : ""}${pData.pro_month?.period <= 1 ? t("${{v1}} for the first month", pData.pro_month?.price) : t("${{v1}} for {{v2}} month", pData.pro_month?.price, pData.pro_month?.period)}` : ""
                            ) : version.includes('Pre') ? (
                                // pData.pre_month?.trial_days > 0 && pData.pre_month?.period <= 0 ? `${pData.pre_month?.trial_days > 0 ? t("{{v1}} days free", pData.pre_month?.trial_days) : ""}` : 
                                pData.pre_month?.period > 0 ? `${pData.pre_month?.trial_days > 0 ? t("{{v1}} days free, ", pData.pre_month?.trial_days) : ""}${pData.pre_month?.period <= 1 ? t("${{v1}} for the first month", pData.pre_month?.price) : t("${{v1}} for {{v2}} month", pData.pre_month?.price, pData.pre_month?.period)}` : ""
                            ) : null
                        )
                    }
                    {
                        version === 'Free' ? <span style={{ opacity: 0 }}>
                            {(isShowYear && (preYearPeriod !== 0 || proYearPeriod !== 0)) || (isShowMonth && (preMonthPeriod !== 0 || proMonthPeriod !== 0)) ? "none" : ""}
                        </span> : null
                    }
                </div>
                <div className={`${((preYearPeriod !== 0 || proYearPeriod !== 0) || (preMonthPeriod !== 0 || proMonthPeriod !== 0)) ? 'dis_period_info' : ''} mealInfo`}>
                    <div className="Every_Card_Desc meal_desc_title">{title}</div>
                    {info.map((item, key) => {
                        return <div className="mealInfoItem" key={key}>
                            {SelectHook}
                            <div>
                                {
                                    item.includes(' - ') ? <span>
                                        {
                                            item.includes("Unlimited") ? <>
                                                {t(item.split(' - ')[0])} - <span style={{ fontWeight: 550 }}>
                                                    <span style={{ color: "var(--color-primary)" }}>{t("Unlimited")}</span> {t("pages")}
                                                </span>
                                            </> : <>
                                                {
                                                    version !== 'Free' && [1].includes(key) ? <Tooltip content={
                                                        <span>
                                                            {t("If monthly AI credit run out, you can enable")} <Link onClick={this.goSettingsOvercharge}>{t("Auto-charge")}</Link> {t("feature to continue using.")}
                                                        </span>
                                                    }>
                                                        <span style={{ borderBottom: '1px dashed #eee' }}>
                                                            {t(item.split(' - ')[0])} - <span style={{ fontWeight: 550 }}>
                                                                {t(item.split(' - ')[1].split(" ")[0])} {t(item.split(' - ')[1].split(" ")[1])}
                                                            </span>
                                                        </span>
                                                    </Tooltip> : <>
                                                        {t(item.split(' - ')[0])} - <span style={{ fontWeight: 550 }}>
                                                            {t(item.split(' - ')[1].split(" ")[0])} {t(item.split(' - ')[1].split(" ")[1])}
                                                        </span>
                                                    </>
                                                }
                                            </>
                                        }
                                    </span> : <span>
                                        {
                                            version !== 'Free' && [0].includes(key) ? <Tooltip content={
                                                <span>
                                                    {t("If monthly image quota run out, you can enable")} <Link onClick={this.goSettingsOvercharge}>{t("Auto-charge")}</Link> {t("feature to continue using.")}
                                                </span>
                                            }>
                                                <span style={{ borderBottom: '1px dashed #eee' }}>
                                                    <span style={{ fontWeight: 550 }}>{item.split(' ')[0]}</span> {t(item.split(item.split(' ')[0] + " ")[1])}
                                                </span>
                                            </Tooltip> : <>
                                                <span style={{ fontWeight: 550 }}>{item.split(' ')[0]}</span> {t(item.split(item.split(' ')[0] + " ")[1])}
                                            </>
                                        }
                                    </span>
                                }
                            </div>
                        </div>
                    })}
                </div>
                <div className="mealInfoEnd">
                    <div className="Every_Card_Desc meal_desc_title">{forText}</div>
                    {infoEnd.map((item, key) => {
                        return <div className="mealInfoItem" key={key}>
                            {SelectHook}
                            {
                                ((version === 'Free' && [1, 2, 4].includes(key)) || (version === 'Pro' && [1, 2, 4].includes(key)) || (version === 'Premium' && [1, 3, 4].includes(key))) && Boolean(infoImg[item]) ? <Tooltip
                                    width={'wide'}
                                    content={
                                        infoImg[item]?.image ? <div className="pricing_desc_img">
                                            <img src={infoImg[item]?.image} alt='' />
                                            <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                            <span>{t(infoImg[item]?.desc)}</span>
                                        </div> : <span>{t(infoImg[item]?.desc)}</span>
                                    }
                                >
                                    <span style={{ textDecorationLine: "underline", textDecorationStyle: "dashed", textDecorationColor: "#ccc", cursor: 'pointer', color: (version === 'Free' && (key === 1 || key === 2)) ? 'var(--color-primary)' : '#303030' }}>{t(item)}</span>
                                    {
                                        (version === 'Free' && (key === 1 || key === 2)) ? <span className='new_sign'>{t("NEW")}</span> : null
                                    }
                                </Tooltip> : <div>{t(item)}</div>
                            }
                        </div>
                    })}
                </div>
            </section>
        }

        // 价格套餐内容
        const extraIcon = <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4507_23550)">
                <path d="M6.60938 12.0317C6.60938 14.8255 11.3847 17.0894 17.276 17.0894C23.1673 17.0894 27.9427 14.8255 27.9427 12.0317C27.9427 9.23784 23.1673 6.974 17.276 6.974C11.3847 6.974 6.60938 9.23784 6.60938 12.0317ZM17.276 18.6101C12.9188 18.6101 9.17151 17.3717 7.51757 15.5952C6.9343 16.2211 6.60938 16.9136 6.60938 17.6407C6.60938 20.4345 11.3847 22.6983 17.276 22.6983C23.1673 22.6983 27.9427 20.4345 27.9427 17.6407C27.9427 16.9136 27.6178 16.2211 27.0345 15.5979C25.3806 17.3717 21.6333 18.6101 17.276 18.6101ZM17.276 24.3603C12.8629 24.3603 9.07563 23.0899 7.45365 21.2761C6.91033 21.8834 6.60938 22.5492 6.60938 23.2497C6.60938 26.0435 11.3847 28.3073 17.276 28.3073C23.1673 28.3073 27.9427 26.0435 27.9427 23.2497C27.9427 22.5492 27.6418 21.8834 27.0984 21.2761C25.4765 23.0872 21.6892 24.3603 17.276 24.3603Z" fill="white" />
                <path d="M27.7079 1.68967C27.9227 1.10926 28.7436 1.10926 28.9584 1.68967L29.4872 3.11875C29.5547 3.30123 29.6986 3.4451 29.8811 3.51263L31.3102 4.04143C31.8906 4.2562 31.8906 5.07713 31.3102 5.2919L29.8811 5.82071C29.6986 5.88823 29.5547 6.0321 29.4872 6.21458L28.9584 7.64366C28.7436 8.22408 27.9227 8.22407 27.7079 7.64366L27.1791 6.21458C27.1116 6.0321 26.9677 5.88823 26.7853 5.82071L25.3562 5.2919C24.7758 5.07713 24.7758 4.2562 25.3562 4.04143L26.7853 3.51263C26.9677 3.4451 27.1116 3.30123 27.1791 3.11875L27.7079 1.68967Z" fill="white" />
                <path d="M1.7081 17.6897C1.92287 17.1093 2.7438 17.1093 2.95857 17.6897L3.12725 18.1455C3.19478 18.328 3.33865 18.4719 3.52113 18.5394L3.977 18.7081C4.55741 18.9229 4.55741 19.7438 3.977 19.9586L3.52113 20.1273C3.33865 20.1948 3.19478 20.3387 3.12725 20.5211L2.95857 20.977C2.7438 21.5574 1.92287 21.5574 1.7081 20.977L1.53941 20.5211C1.47189 20.3387 1.32802 20.1948 1.14554 20.1273L0.689669 19.9586C0.109257 19.7438 0.109258 18.9229 0.68967 18.7081L1.14554 18.5394C1.32802 18.4719 1.47189 18.328 1.53941 18.1455L1.7081 17.6897Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_4507_23550">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>

        const pricingMealContent = <div className='pricingMealContent' id='pricingMealContent'>
            <Layout>
                <Layout.Section variant="oneThird">
                    <div className='mealRecommended pre_card_box'>
                        <div className='Most_popular'>{t("Most popular")}</div>
                        {/* 渐变背景 */}
                        <div className='mealRecommendedBg'></div>
                        <Card>
                            <div className="top-right-bg">
                                <div className="bg_shape top-right-bg__shape--1" />
                                <div className="bg_shape top-right-bg__shape--2" />
                                <div className="bg_shape top-right-bg__shape--3" />
                                <div className="bg_shape top-right-bg__shape--4" />
                                <div className="bg_shape top-right-bg__shape--5" />
                                <div className="bg_shape top-right-bg__shape--6" />
                                <div className="bg_shape top-right-bg__shape--7" />
                                <div className="bg_shape top-right-bg__shape--8" />
                            </div>
                            <div className="bottom-left-bg">
                                <div className="bg_shape bottom-left-bg__shape--1" />
                                <div className="bg_shape bottom-left-bg__shape--2" />
                                <div className="bg_shape bottom-left-bg__shape--3" />
                                <div className="bg_shape bottom-left-bg__shape--4" />
                                <div className="bg_shape bottom-left-bg__shape--5" />
                                <div className="bg_shape bottom-left-bg__shape--6" />
                                <div className="bg_shape bottom-left-bg__shape--7" />
                            </div>
                            {pricingContentItem(
                                'Premium',
                                prePlanPrice,
                                prePlanBtnStatus,
                                prePlanId,
                                t("Includes"),
                                [
                                    "6000 image compressions/mo",
                                    "Content Optimization - 500 credits/mo",
                                    "On-page SEO Audit - Unlimited pages",
                                    "Backlink Exchange - 1000 links"
                                ],
                                isShowMonth,
                                isShowYear,
                                preDiscount,
                                preVersionLevel,
                                preDiscountPrice,
                                preMonthCountDown,
                                preMonthCountDown_mills,
                                preYearCountDown,
                                preYearCountDown_mills,
                                t("Everything in Pro, plus"),
                                [
                                    "Turbo Speed Optimization",
                                    "AI Internal Linking",
                                    "Competitor Analysis",
                                    // "AMP Page Support",
                                    "Keywords Rank Tracker",
                                    "Backlink Audit",
                                ],
                                planInfo,
                            )}
                        </Card>
                    </div>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <div className='mealRecommended'>
                        <Card>{pricingContentItem(
                            'Pro',
                            proPlanPrice,
                            proPlanBtnStatus,
                            proPlanId,
                            t("Includes"),
                            [
                                "2000 image compressions/mo",
                                "Content Optimization - 200 credits/mo",
                                "On-page SEO Audit - 1000 pages",
                                "Backlink Exchange - 300 links",
                            ],
                            isShowMonth,
                            isShowYear,
                            proDiscount,
                            proVersionLevel,
                            proDiscountPrice,
                            proMonthCountDown,
                            proMonthCountDown_mills,
                            proYearCountDown,
                            proYearCountDown_mills,
                            t("Everything in Free, plus"),
                            [
                                "Rocket Speed Optimization",
                                "Auto & Bulk Edit Meta Tags",
                                "Structured Data Markup (JSON-LD)",
                                "Auto-Redirect Broken Links",
                                "llms.txt Generator",
                                // "Keywords Rank Tracker",
                            ],
                            planInfo,
                        )}</Card>
                    </div>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>{pricingContentItem(
                        'Free',
                        freePlanPrice,
                        freePlanBtnStatus,
                        freePlanId,
                        t("Includes"),
                        [
                            "50 image compressions",
                            "Content Optimization - 30 credits",
                            "On-page SEO Audit - 20 pages",
                            "Backlink Exchange - 40 links",
                        ],
                        isShowMonth,
                        isShowYear,
                        1,
                        '',
                        0,
                        0,
                        0,
                        0,
                        0,
                        t("Key Features"),
                        [
                            "Basic Speed Optimization",
                            "Keyword Content Planner",
                            "AI Blog Generator",
                            "Full Site SEO Audit",
                            "Auto & Bulk Edit Image Alt Text",
                            "On-Page SEO Optimization",
                            "Keyword Suggestions",
                        ],
                        planInfo,
                    )}</Card>
                </Layout.Section>
            </Layout>
        </div>

        // 特性价格标题块
        const pricingTopBlock = (version, price, btnStatus, selectId, isFree = false, discount = '', ver_level, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills) => {
            return <section className='pricingTopBlock'>
                <div className="mealVersion">
                    {t(version)}
                </div>
                <div className={`mealPrice`} style={{ minHeight: preDiscountPrice === 0 && proDiscountPrice === 0 ? '22px' : '30px' }}>
                    {isFree ? <span>{t("Free")}
                        {
                            isShowYear && <span className='year_subunit' style={{ opacity: 0, minHeight: '25px' }}>{t("occupied")}</span>
                        }
                    </span> : version === "Enterprise" ? <div>
                    </div> : ((version.indexOf('Pro') > -1 && userInfo.pro_trial_days > 0) || (version.indexOf('Pre') > -1 && userInfo.pre_trial_days > 0)) ? <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                        <span className='act_price_dis'>${isShowYear ? multiplyPrice(Number(price) / 12, Number(discount)) : multiplyPrice(Number(price), Number(discount))}</span>
                        {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                        {isShowYear ? <>
                            <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                            <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price * discount)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                        </> : null}
                    </span> :
                        discount >= 0 && discount < 1 ? ((Number((price * discount).toFixed(2)) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : Number(actMealDiscount.toFixed(2))}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - actMealDiscount).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                            </> : null}
                        </span> : <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? multiplyPrice(Number(price) / 12, Number(discount)) : multiplyPrice(Number(price), Number(discount))}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price * discount)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                            </> : null}
                        </span>) : discount !== 0 && discount >= 1 ? ((Number(price - discount) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            ${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : actMealDiscount}
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - actMealDiscount).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                            </> : null}
                        </span> : <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number(((price - discount) / 12).toFixed(2)) : Number((price - discount).toFixed(2))}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price - discount)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                            </> : null}
                        </span>) : actMealDiscount === -1 ? <span>
                            ${isShowYear ? Number(((price * defalutDis) / 12).toFixed(2)) : <span>{price}</span>}
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - (price * defalutDis)).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                            </> : null}
                        </span> : <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : actMealDiscount}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t(`Save {{v1}}`, "$" + Number((price - actMealDiscount).toFixed(2)))}${t("/year · Billed annually")}`}</span>
                            </> : null}
                        </span>
                    }
                </div>
                {
                    iscacheLoading ? <div className='mealBtn'>
                        <Button loading={true}>{t("Upgrade")}</Button>
                    </div> : <div className={`mealBtn btn_${ver_level}_${btnStatus} ${!Boolean(btnStatus) && !this.state.paidLoading && 'mealBtnDisable'}  ${btnStatus === 1 && 'mealDowngrade'}`}>
                        {btnStatus === 3 ? <Button disabled={this.state.paidDisabled} loading={paidBtnLoading === ver_level} variant='primary' onClick={() => handleUpdatePricingMeal(selectId, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>
                            {t("Try Free For {{v1}} Days", (version.indexOf('Pro') > -1 && userInfo.pro_trial_days) ? userInfo.pro_trial_days : (version.indexOf('Pre') > -1 && userInfo.pre_trial_days) ? userInfo.pre_trial_days : userInfo.trial_days)}
                        </Button> : null}
                        {btnStatus === 2 ? <Button disabled={this.state.paidDisabled} loading={paidBtnLoading === ver_level} variant='primary' onClick={() => handleUpdatePricingMeal(selectId, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>{t("Choose this plan")}</Button> : null}
                        {btnStatus === 1 ? <Button disabled={this.state.paidDisabled} loading={0} onClick={() => handleDowngrade(false)}>{t("Switch to Free")}</Button> : null}
                        {btnStatus === 0 ? (
                            (ver_level && (discount > 0 || actMealDiscount > 0)) ? <Button loading={paidBtnLoading && paidBtnLoading === ver_level} disabled={Boolean(this.state.paidDisabled)} variant='primary' onClick={() => handleUpdatePricingMeal(selectId, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>{t("Update plan")}</Button> : <Button disabled={true} variant='primary'>{t("Current plan")}</Button>
                        ) : null}
                    </div>
                }
            </section>
        }
        const pricingTitleBlock = <div className='pricing_title_block' style={{ position: 'sticky', top: (window.shopify) ? '0' : '3.5rem' }}>
            <div className='pt_item pt_first'></div>
            <div className='pt_item pt_free'>
                {
                    pricingTopBlock(
                        "Free",
                        freePlanPrice,
                        freePlanBtnStatus,
                        freePlanId,
                        true,
                        '',
                        '',
                        0,
                        0,
                        0,
                        0,
                        0,
                    )
                }
            </div>
            <div className='pt_item pt_pro'>
                {
                    pricingTopBlock(
                        "Pro",
                        proPlanPrice,
                        proPlanBtnStatus,
                        proPlanId,
                        false,
                        proDiscount,
                        proVersionLevel,
                        proDiscountPrice,
                        proMonthCountDown,
                        proMonthCountDown_mills,
                        proYearCountDown,
                        proYearCountDown_mills,
                    )
                }
            </div>
            <div className='pt_item pt_pre'>
                {
                    pricingTopBlock(
                        "Premium",
                        prePlanPrice,
                        prePlanBtnStatus,
                        prePlanId,
                        false,
                        preDiscount,
                        preVersionLevel,
                        preDiscountPrice,
                        preMonthCountDown,
                        preMonthCountDown_mills,
                        preYearCountDown,
                        preYearCountDown_mills,
                    )
                }
            </div>
        </div>
        // 价格等级特性列
        const pricingState = <Collapsible
            open={isShowPricingState}
            id="pricing-detail-collapsible"
        >
            {window.innerWidth > 900 && pricingTitleBlock}
            <div className='pricing_state_main'>
                {
                    Object.keys(newPlanService).map(title => {
                        return <div key={title} className="ps_block">
                            <div className='ps_title'>
                                <span>{t(title)}</span>
                            </div>
                            <div className='ps_submain'>
                                {
                                    Object.keys(newPlanService[title].subText).map(son => {
                                        return <div key={son} className="ps_subtitle">
                                            <div className={`ps_itemText ps_first ${Boolean(newPlanService[title].subText[son].desc) ? "ps_text_line" : ""} ${newPlanService[title].subText[son]?.isNew ? "ps_text_color_new" : ""}`}>
                                                {
                                                    Boolean(newPlanService[title].subText[son].desc) ? <Tooltip
                                                        width={'wide'}
                                                        content={
                                                            newPlanService[title].subText[son]?.image ? <div className="pricing_desc_img">
                                                                <img src={newPlanService[title].subText[son].image} alt={""} />
                                                                <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                <span>{t(newPlanService[title].subText[son].desc)}</span>
                                                            </div> : t(newPlanService[title].subText[son].desc)}
                                                    >
                                                        <span>{t(son)}</span>
                                                    </Tooltip> : <span>{t(son)}</span>
                                                }
                                                {
                                                    newPlanService[title].subText[son]?.isNew ? <span className="new_sign">{t("NEW")}</span> : null
                                                }
                                            </div>
                                            {
                                                (newPlanService[title].subText[son].priority).map((child, cinx) => {
                                                    return <div key={child + cinx} className="ps_itemText ps_item">
                                                        {
                                                            child === '--' ? t(child) : typeof child === "boolean" ? FinishIcon : (child === -1 && son !== "On-page SEO Audit") ? t("Unlimited") :
                                                                title === "SEO Audit" ? (
                                                                    son === "On-page SEO Audit" ? `${t(child === -1 ? "Unlimited" : child)} ${t("pages")}` : null
                                                                ) :
                                                                    title === "Page Speed Optimization" ? (
                                                                        son === "Page Speed Optimization" ? <Tooltip
                                                                            content={t(newPlanService[title].subText[son].extra[child])}
                                                                        >
                                                                            <span style={{ textDecorationLine: "underline", textDecorationStyle: "dashed", textDecorationColor: "#ccc", cursor: 'pointer' }}>{t(child)}</span>
                                                                        </Tooltip> : t(child)
                                                                    ) :
                                                                        title === "Image Optimization" ? (
                                                                            son === "Auto-compress Images" ? `${t("{{v1}} Images", child)}${cinx !== 0 ? "/" + t("month") : ""}` : t(child)
                                                                        ) :
                                                                            title === "Content Optimization" ? (
                                                                                child === -1 ? t("Unlimited") : t(child) + " " + `${son === "AI Credits" ? t("credits") : ""}${cinx !== 0 && son === "AI Credits" ? "/" + t("month") : ""}`
                                                                            ) :
                                                                                title === "Link Management" ? (
                                                                                    son === "Backlink Exchange" ? `${t("{{v1}} links", child)}` : null
                                                                                ) :
                                                                                    title === "Keyword Research" ? (
                                                                                        son === "Competitor Analysis" ? `${t("{{v1}} sites/month, {{v2}} in total", child, 50)}` : null
                                                                                    ) : t(child)
                                                        }
                                                    </div>
                                                })
                                            }
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div>
        </Collapsible>

        // 提示banner
        const chargeTipBanner = <div className='charge_tip_banner'>
            <Text variant="bodyMd" as="p" tone='subdued'>{t("Questions about a charge?")}&nbsp;<Button variant='plain' onClick={this.handleContactService}>{t("Contact us")}</Button>&nbsp; - {t("we're happy to help.")}</Text>
        </div>

        // 价格套餐详细按钮
        const pricingDetailBtn = <div className='pricingDetailMain'>
            <div className={`pricingDetailBtn ${isShowPricingState ? 'pdb_show' : ''}`} onClick={() => setExpanded(!isShowPricingState)}>
                {/* <div>{!isShowPricingState ? t("Show detail feature of pricing plans") : t("Hide detail feature of pricing plans")}</div> */}
                <div>{t("Compare plans & features")}</div>
                <Icon tone='base' source={isShowPricingState ? ChevronUpIcon : ChevronDownIcon} />
            </div>
            {pricingState}
        </div>

        // 信任品牌
        const trustBrand = <Card>
            <div className='trust_brand'>
                <BlockStack gap={600}>
                    <Text variant="headingMd" as="h2">{t("Helping 40,000+ brands Boost SEO Traffic")}</Text>
                    <span>
                        <svg viewBox="0 0 768 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_619_19123)">
                                <path d="M31.7902 5.54884C31.1083 8.05789 30.4348 10.5692 29.7697 13.0827C29.4385 14.3389 29.1121 15.5951 28.73 16.8383C28.3594 18.0473 27.9035 19.336 27.2376 20.4343C26.5456 21.5783 25.6485 22.4732 24.407 23.0444C23.9138 23.2678 23.4005 23.4337 22.867 23.5422C22.1115 23.6898 21.3495 23.7792 20.5808 23.8107C18.6735 23.9165 14.6309 23.9018 12.7252 23.9018L13.8946 19.6061C14.7786 19.6061 15.6624 19.6094 16.5464 19.5849C17.3993 19.5622 18.3373 19.5166 19.1786 19.3197C20.0971 19.1033 20.7924 18.7339 21.4008 17.9903C21.9535 17.3134 22.3258 16.4689 22.6309 15.6732C23.1885 14.2201 23.7592 12.1373 24.1626 10.6403C24.6169 8.9464 25.0548 7.24763 25.4943 5.54884H31.7902ZM39.6622 5.54884L36.2641 18.0457H29.9665L33.3663 5.54884H39.6622ZM18.8982 0.862549H25.1958C24.5365 3.30332 23.874 5.74193 23.2081 8.17837C22.744 9.8772 22.2815 11.5759 21.778 13.2617C21.5566 13.9971 21.3369 14.7311 21.0482 15.4454C20.817 16.0181 20.5562 16.529 20.079 16.9586C19.7322 17.2645 19.3209 17.4897 18.8753 17.6177C18.2914 17.7999 17.6994 17.8682 17.0958 17.9171C16.2266 17.9871 15.3574 18.0049 14.4866 18.0195C11.2208 18.0522 7.95503 18.0516 4.68924 18.018C4.16737 18.0113 3.64572 17.9928 3.12468 17.9626C2.77711 17.9465 2.43091 17.9085 2.08821 17.8488C1.85664 17.8084 1.63011 17.7434 1.41252 17.6551C0.690926 17.3426 0.323566 16.7195 0.302246 15.9579C0.302246 15.5283 0.353086 15.1053 0.454766 14.6887C0.579406 14.0916 0.735206 13.5042 0.889366 12.9151C1.18293 11.7908 1.71921 9.71602 2.13904 8.6226C2.46705 7.7667 2.90001 6.91405 3.72328 6.37382C4.18249 6.07117 4.66792 5.91008 5.20092 5.8043C5.59617 5.72294 5.99305 5.68227 6.39485 5.65298C7.06725 5.60416 7.73965 5.58789 8.41205 5.57651C9.36653 5.5624 10.3221 5.55426 11.2788 5.55209L13.665 5.54884H16.0495L15.2 8.67303C13.783 8.67303 12.3661 8.66978 10.9475 8.67792C10.5342 8.67954 10.1209 8.67792 9.70764 8.70396C9.5609 8.7074 9.41528 8.73039 9.27468 8.7723C9.08937 8.83738 8.99588 8.95128 8.91389 9.11889C8.79417 9.36297 8.72529 9.62328 8.64821 9.88037C8.36175 10.8845 8.08676 11.8918 7.82329 12.9021C7.76425 13.1299 7.70958 13.3577 7.65928 13.5855C7.62211 13.7461 7.59478 13.9077 7.57729 14.0704C7.56088 14.2494 7.55433 14.4642 7.66421 14.6318C7.77572 14.7994 7.96268 14.8385 8.1398 14.8645C8.3366 14.8938 8.53504 14.8987 8.73513 14.9052C9.06094 14.9138 9.3873 14.9182 9.7142 14.9182C10.6064 14.9225 11.4991 14.9225 12.3923 14.9182C12.8023 14.9149 13.214 14.9116 13.6256 14.8954C13.9093 14.884 14.1882 14.8742 14.467 14.8076C14.6802 14.7571 14.8441 14.6774 14.9884 14.5049C15.0803 14.3888 15.153 14.2613 15.2065 14.1225C15.3509 13.7824 15.4526 13.4309 15.5559 13.0795C15.9577 11.7288 16.3201 10.3702 16.6908 9.01311L17.7978 4.94028L18.8966 0.864175H25.1942L18.8982 0.862549Z" fill="black" fillOpacity="0.4" />
                            </g>
                            <mask id="mask0_619_19123" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="104" y="0" width="53" height="24">
                                <path d="M156.966 0.862549H104.166V23.9025H156.966V0.862549Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_619_19123)">
                                <path d="M108.192 21.131C110.519 21.131 111.985 19.3296 111.985 17.2296V16.654H107.959V18.0397H110.434C110.147 19.0631 109.372 19.7239 108.192 19.7239C106.684 19.7239 105.6 18.5727 105.6 17.1337C105.6 15.7265 106.694 14.5433 108.139 14.5433C109.149 14.5433 109.892 14.991 110.381 15.8971L111.656 15.1296C110.997 13.957 109.733 13.1362 108.129 13.1362C105.834 13.1362 104.166 14.9164 104.166 17.1337C104.166 19.2976 105.77 21.131 108.192 21.131Z" fill="black" fillOpacity="0.4" />
                                <path d="M115.734 21.1505C116.552 21.1505 117.295 20.7988 117.752 20.2125V21.0226H119.186V14.7867H117.752V15.5329C117.295 14.9892 116.573 14.6587 115.755 14.6587C114.182 14.6587 112.674 15.842 112.674 17.9099C112.674 19.9566 114.236 21.1505 115.734 21.1505ZM115.967 19.8287C114.905 19.8287 114.087 18.9759 114.087 17.8886C114.087 16.812 114.905 15.9699 115.967 15.9699C117.04 15.9699 117.826 16.8226 117.826 17.8886C117.826 18.9653 117.04 19.8287 115.967 19.8287Z" fill="black" fillOpacity="0.4" />
                                <path d="M120.175 21.0245H121.62V13.1362H120.175V21.0245Z" fill="black" fillOpacity="0.4" />
                                <path d="M125.416 21.1505C126.234 21.1505 126.978 20.7988 127.435 20.2125V21.0226H128.869V14.7867H127.435V15.5329C126.978 14.9892 126.255 14.6587 125.437 14.6587C123.865 14.6587 122.356 15.842 122.356 17.9099C122.356 19.9566 123.918 21.1505 125.416 21.1505ZM125.65 19.8287C124.587 19.8287 123.769 18.9759 123.769 17.8886C123.769 16.812 124.587 15.9699 125.65 15.9699C126.723 15.9699 127.509 16.8226 127.509 17.8886C127.509 18.9653 126.723 19.8287 125.65 19.8287Z" fill="black" fillOpacity="0.4" />
                                <path d="M129.294 21.026H131.047L132.524 18.9474L134.043 21.026H135.796L133.416 17.8708L135.647 14.79H133.947L132.545 16.7728L131.132 14.79H129.379L131.631 17.8495L129.294 21.026Z" fill="black" fillOpacity="0.4" />
                                <path d="M137.034 23.9042H138.489L142.197 14.79H140.689L139.053 18.99L137.321 14.79H135.791L138.341 20.7169L137.034 23.9042Z" fill="black" fillOpacity="0.4" />
                                <path d="M149.735 1.09875V8.48545H147.087L145.249 2.42333H145.209L145.311 8.48545H143.481V1.09875H146.244L147.954 6.95941H147.995L147.893 1.09875H149.735Z" fill="black" fillOpacity="0.4" />
                                <path d="M115.549 8.56318L114.558 1.79039H114.516L113.497 8.56318H111.488L112.868 1.09875H116.177L117.55 8.56318H115.549Z" fill="black" fillOpacity="0.4" />
                                <path d="M122.233 1.09875L123.152 6.80474H123.191L124.111 1.09875H127.144L127.306 8.56318H125.446L125.397 1.85226H125.359L124.115 8.56318H122.228L120.983 1.85226H120.943L120.896 8.56318H119.033L119.198 1.09875H122.233Z" fill="black" fillOpacity="0.4" />
                                <path d="M108.355 6.45829C108.428 6.63912 108.405 6.87152 108.371 7.01191C108.309 7.26016 108.141 7.51318 107.647 7.51318C107.18 7.51318 106.897 7.2451 106.897 6.83504V6.11246H104.902L104.9 6.69068C104.9 8.35473 106.206 8.8568 107.605 8.8568C108.951 8.8568 110.059 8.39518 110.235 7.1515C110.326 6.50667 110.258 6.0847 110.227 5.92528C109.914 4.36276 107.09 3.89638 106.88 3.02232C106.844 2.87242 106.854 2.71378 106.872 2.62891C106.923 2.39097 107.086 2.12843 107.552 2.12843C107.986 2.12843 108.243 2.3981 108.243 2.80578C108.243 2.94301 108.243 3.26661 108.243 3.26661H110.099V2.74234C110.099 1.11636 108.644 0.862549 107.59 0.862549C106.267 0.862549 105.186 1.30117 104.988 2.51629C104.934 2.8518 104.926 3.15081 105.005 3.52518C105.33 5.05043 107.972 5.49222 108.355 6.45829Z" fill="black" fillOpacity="0.4" />
                                <path d="M132.546 6.44482C132.62 6.62407 132.596 6.85012 132.563 6.99051C132.502 7.23798 132.336 7.48703 131.844 7.48703C131.384 7.48703 131.104 7.21894 131.104 6.81839L131.102 6.10217H129.127L129.125 6.67245C129.125 8.31984 130.419 8.81715 131.804 8.81715C133.135 8.81715 134.233 8.36188 134.406 7.12932C134.496 6.48924 134.432 6.07283 134.4 5.91658C134.088 4.36833 131.292 3.90671 131.085 3.04138C131.049 2.89226 131.059 2.73521 131.077 2.6551C131.13 2.41557 131.29 2.15938 131.751 2.15938C132.182 2.15938 132.433 2.42271 132.433 2.82722C132.433 2.96285 132.433 3.28329 132.433 3.28329H134.274V2.76456C134.274 1.15603 132.832 0.903809 131.788 0.903809C130.48 0.903809 129.407 1.33687 129.214 2.54327C129.16 2.87401 129.154 3.16748 129.231 3.54027C129.551 5.04965 132.168 5.48826 132.546 6.44482Z" fill="black" fillOpacity="0.4" />
                                <path d="M138.795 7.44579C139.311 7.44579 139.472 7.08729 139.508 6.90407C139.523 6.82317 139.527 6.7153 139.525 6.61853V1.09497H141.406V6.44959C141.41 6.5868 141.397 6.86917 141.391 6.93977C141.259 8.33334 140.161 8.78544 138.794 8.78544C137.425 8.78544 136.327 8.33334 136.196 6.93977C136.19 6.86917 136.176 6.5868 136.18 6.44959V1.09497H138.06V6.61853C138.06 6.7153 138.063 6.82396 138.078 6.90407C138.118 7.08729 138.274 7.44579 138.795 7.44579Z" fill="black" fillOpacity="0.4" />
                                <path d="M154.313 7.37C154.852 7.37 155.04 7.02815 155.075 6.82907C155.088 6.7434 155.092 6.6395 155.092 6.54512V5.46166H154.328V4.37186H156.966V6.37538C156.964 6.51497 156.961 6.61809 156.939 6.86714C156.815 8.22503 155.641 8.70965 154.323 8.70965C153.002 8.70965 151.829 8.22503 151.704 6.86714C151.682 6.61809 151.679 6.51497 151.677 6.37538L151.678 3.23209C151.678 3.09964 151.695 2.86486 151.709 2.74034C151.874 1.34517 153.002 0.89624 154.323 0.89624C155.642 0.89624 156.797 1.34279 156.934 2.74034C156.958 2.97828 156.95 3.23209 156.95 3.23209V3.48114H155.074V3.06315C155.074 3.06315 155.072 2.88548 155.05 2.7792C155.018 2.61422 154.875 2.23509 154.308 2.23509C153.766 2.23509 153.607 2.5936 153.568 2.7792C153.545 2.87755 153.536 3.0108 153.536 3.13136V6.54512C153.534 6.6395 153.54 6.7434 153.555 6.82907C153.587 7.02895 153.775 7.37 154.313 7.37Z" fill="black" fillOpacity="0.4" />
                            </g>
                            <g clipPath="url(#clip1_619_19123)">
                                <path fillRule="evenodd" clipRule="evenodd" d="M268.662 0.12188C268.984 0.236087 268.983 0.225604 268.983 3.30008V6.06836L269.137 6.14808C269.268 6.21539 269.606 6.22781 271.343 6.22808C274.187 6.22836 273.97 6.10808 273.97 7.68739C273.97 9.32491 274.176 9.20436 271.38 9.20436C269.198 9.20436 269.06 9.21788 269.006 9.43526C268.991 9.49484 268.986 11.5412 268.995 13.9826L269.009 18.4215L269.226 18.8653C269.345 19.1095 269.47 19.3798 269.502 19.4659C269.626 19.7914 269.978 20.0722 270.837 20.531C270.965 20.5994 271.24 20.6195 272.325 20.6408C274.106 20.6758 273.998 20.5903 273.993 21.963C273.988 23.459 273.986 23.4609 272.432 23.4609C271.513 23.4609 271.292 23.4449 270.946 23.3544C270.722 23.2957 270.295 23.2157 269.996 23.1765C269.474 23.1081 269.06 22.9495 268.954 22.777C268.935 22.7464 268.813 22.6755 268.682 22.6195C268.552 22.5638 268.307 22.3895 268.137 22.2322C267.967 22.075 267.808 21.9464 267.784 21.9464C267.76 21.9464 267.678 21.8405 267.602 21.7111C267.526 21.5815 267.409 21.4399 267.343 21.3966C267.221 21.3166 267.109 21.0995 266.995 20.7191C266.96 20.6044 266.855 20.4248 266.762 20.3205C266.578 20.1155 266.558 20.0482 266.479 19.4137C266.451 19.1839 266.392 18.7271 266.348 18.3986C266.281 17.9048 266.268 17.0904 266.268 13.689C266.268 11.259 266.247 9.52408 266.219 9.44794C266.119 9.18587 265.833 9.14753 264.196 9.17732C262.13 9.21457 261.865 9.24712 261.478 9.51139C261.309 9.6267 261.055 9.75029 260.912 9.78615C260.736 9.83029 260.579 9.9205 260.419 10.0706C260.289 10.1914 260.09 10.3379 259.975 10.3961C259.86 10.4546 259.684 10.6079 259.583 10.7373C259.482 10.8667 259.351 10.9999 259.29 11.0333C259.23 11.0667 259.144 11.1682 259.101 11.259C259.057 11.3495 258.928 11.5296 258.814 11.6587C258.573 11.931 258.469 12.1188 258.385 12.4297C258.352 12.5522 258.255 12.7329 258.168 12.8314C257.815 13.2336 257.797 13.486 257.761 18.5092C257.725 23.5028 257.776 23.0388 257.23 23.3208C256.952 23.4645 256.93 23.4673 256.215 23.4502C255.297 23.4284 255.007 23.2968 254.887 22.8471C254.783 22.4595 254.841 6.86477 254.947 6.63057C255.089 6.31526 255.277 6.26229 256.267 6.2576C257.574 6.25153 257.692 6.34588 257.755 7.45539C257.809 8.38367 257.867 8.46091 258.254 8.12077C258.663 7.7616 259.159 7.42119 259.412 7.32519C259.55 7.27277 259.785 7.14698 259.936 7.04574C260.124 6.91912 260.336 6.8347 260.614 6.77567C260.837 6.7285 261.16 6.62119 261.333 6.53705C261.817 6.30091 262.085 6.27112 264.1 6.22863C266.091 6.1867 266.202 6.17457 266.241 5.99939C266.255 5.93815 266.273 4.67801 266.283 3.19884C266.302 0.052364 266.271 0.207673 266.92 0.0440869C267.108 -0.00336142 268.483 0.0581562 268.662 0.12188ZM277.669 0.118018C277.998 0.279399 277.989 0.17788 278.017 3.83057C278.038 6.38808 278.059 7.16988 278.109 7.23057C278.207 7.34863 278.426 7.28491 278.696 7.05981C278.905 6.88601 279.321 6.6976 279.495 6.6976C279.53 6.6976 279.672 6.61705 279.811 6.51829C280.687 5.89567 284.595 5.93181 285.329 6.56932C285.372 6.60684 285.548 6.68932 285.72 6.7525C286.004 6.8565 286.24 6.99801 286.435 7.17981C286.473 7.21622 286.589 7.28877 286.692 7.34119C286.908 7.45125 287.94 8.44739 287.94 8.54615C287.94 8.58257 288.028 8.68326 288.135 8.76988C288.262 8.87167 288.364 9.0176 288.424 9.18339C288.475 9.32408 288.596 9.51746 288.694 9.61319C288.828 9.74367 288.908 9.89926 289.012 10.2397C289.089 10.4888 289.193 10.7395 289.243 10.7972C289.597 11.2038 289.713 12.4474 289.714 15.8708L289.715 18.4904L289.872 18.8215C289.958 19.0035 290.028 19.2079 290.028 19.2755C290.029 19.79 291.324 20.6165 292.181 20.649C293.132 20.6852 293.242 20.8262 293.225 21.9881C293.205 23.4002 292.765 23.6888 291.204 23.3117C290.945 23.249 290.562 23.1726 290.353 23.1417C290.062 23.0984 289.916 23.0446 289.727 22.91C289.591 22.8135 289.355 22.6708 289.202 22.5933C289.049 22.5158 288.861 22.3732 288.784 22.2766C288.707 22.1801 288.562 22.0463 288.462 21.9793C288.361 21.9125 288.245 21.7897 288.203 21.7062C288.162 21.6228 288.039 21.4606 287.931 21.3456C287.798 21.2038 287.683 20.995 287.575 20.6951C287.487 20.4526 287.365 20.2002 287.303 20.1343C287.066 19.8819 287.043 19.5721 286.999 16.1238C286.957 12.7503 286.939 12.4929 286.718 12.1566C286.674 12.089 286.609 11.9202 286.575 11.7812C286.486 11.4278 286.351 11.1362 286.168 10.9062C286.082 10.798 285.998 10.6653 285.98 10.6115C285.935 10.4675 285.262 9.80712 285.087 9.73457C285.004 9.70008 284.884 9.59443 284.819 9.49953C284.716 9.35001 284.649 9.31581 284.315 9.24326C284.102 9.19691 283.825 9.11195 283.697 9.05401C282.886 8.68463 282.27 8.68326 281.386 9.04905C281.227 9.1147 280.782 9.24463 280.576 9.28519C280.467 9.30698 280.295 9.41291 280.148 9.55001C280.012 9.67581 279.86 9.77953 279.808 9.78036C279.678 9.78284 279.563 9.88077 279.463 10.0739C279.416 10.1646 279.295 10.2896 279.194 10.3519C279.086 10.4193 278.971 10.5539 278.913 10.6833C278.859 10.8033 278.745 10.9886 278.659 11.0951C278.572 11.2019 278.473 11.4016 278.438 11.5393C278.247 12.2772 278.158 12.5856 278.104 12.7031C278.06 12.7977 278.036 14.2057 278.017 17.8209C277.985 23.9997 278.12 23.4609 276.607 23.4609C275.702 23.4609 275.606 23.4308 275.431 23.0921C275.35 22.9348 275.305 0.515261 275.386 0.305606C275.494 0.0242253 277.193 -0.115637 277.669 0.118018ZM245.823 6.14615C246.773 6.24243 247.227 6.34063 247.415 6.4907C247.587 6.62725 247.696 6.67581 248.049 6.77291C248.211 6.81732 248.457 6.93622 248.597 7.03746C248.737 7.13843 248.951 7.2667 249.072 7.32243C249.193 7.37815 249.393 7.51608 249.516 7.62919C249.639 7.74201 249.871 7.9056 250.033 7.99277L250.326 8.15084L250.358 7.80298C250.377 7.61153 250.391 7.29539 250.392 7.10063C250.393 6.33622 250.497 6.26974 251.706 6.26036C253.243 6.24877 253.078 5.23195 253.095 14.8375L253.109 22.6377L252.976 22.9191C252.743 23.4129 252.591 23.4744 251.662 23.4518C250.563 23.425 250.392 23.3012 250.392 22.5335C250.392 21.8634 250.348 21.6813 250.193 21.7202C250.028 21.7616 249.668 21.9969 249.31 22.2976C249.16 22.4231 248.925 22.5638 248.788 22.6096C248.65 22.6557 248.443 22.7804 248.326 22.8866C248.152 23.0446 248.047 23.0918 247.751 23.1448C247.524 23.1856 247.282 23.2742 247.102 23.382C246.623 23.6695 246.53 23.6827 244.785 23.7084C242.872 23.7368 242.485 23.6979 241.992 23.4289C241.809 23.3293 241.505 23.2121 241.316 23.1682C240.865 23.0637 240.682 22.9828 240.516 22.8157C240.442 22.7401 240.283 22.6441 240.165 22.6022C240.046 22.5602 239.81 22.4132 239.64 22.2755C239.47 22.1376 239.24 21.9597 239.129 21.8799C238.799 21.6435 237.685 20.4604 237.584 20.2397C237.434 19.9117 237.075 20.0079 236.78 20.4543C236.648 20.6548 236.315 21.027 236.006 21.3197C235.93 21.3917 235.754 21.5602 235.614 21.6948C235.473 21.8292 235.305 21.9682 235.238 22.0035C235.172 22.0388 235.011 22.1564 234.882 22.2648C234.753 22.3732 234.534 22.5103 234.395 22.5696C234.256 22.6289 234.045 22.7558 233.925 22.8515C233.68 23.0477 233.52 23.1155 233.11 23.198C232.951 23.23 232.706 23.3343 232.556 23.4339C232.183 23.6816 231.718 23.7324 229.869 23.7285C228.135 23.7246 227.505 23.6278 227.255 23.3271C227.223 23.2888 227.017 23.2179 226.797 23.1699C226.385 23.0802 226.147 22.9679 225.982 22.7856C225.93 22.7282 225.802 22.6537 225.698 22.6201C225.489 22.5522 224.908 22.1663 224.908 22.0957C224.908 22.0711 224.872 22.051 224.829 22.051C224.638 22.051 223.338 20.6915 223.122 20.2656C223.054 20.1313 222.938 19.9732 222.863 19.915C222.789 19.8565 222.699 19.7318 222.663 19.6375C222.529 19.2849 222.436 19.1037 222.337 18.9991C222.179 18.8314 222.104 18.6582 221.984 18.1828C221.922 17.9406 221.816 17.6565 221.747 17.5511C221.309 16.8799 221.316 12.8391 221.757 12.2008C221.814 12.118 221.929 11.8154 222.013 11.5282C222.117 11.1679 222.206 10.9655 222.299 10.8755C222.374 10.8035 222.492 10.5953 222.561 10.4124C222.631 10.2292 222.773 9.98257 222.876 9.86395C222.98 9.74532 223.104 9.57181 223.152 9.47829C223.289 9.21181 224.536 7.8987 224.652 7.8987C224.675 7.8987 224.806 7.80105 224.943 7.6816C225.082 7.56215 225.303 7.41401 225.436 7.3525C225.569 7.2907 225.757 7.17346 225.854 7.09125C226.073 6.9067 226.375 6.77208 226.683 6.72243C226.839 6.6976 226.982 6.62753 227.107 6.51525C227.764 5.92381 232.11 5.95719 232.7 6.55829C232.766 6.62532 232.913 6.70753 233.028 6.74063C233.403 6.8485 234.24 7.52767 234.453 7.8965C234.528 8.02698 234.667 8.2267 234.763 8.34008C234.931 8.53953 235.089 8.9685 235.169 9.43939C235.188 9.55415 235.246 9.69512 235.298 9.75277C235.492 9.96932 235.535 10.2366 235.535 11.241C235.535 12.2424 235.51 12.393 235.289 12.7142C235.235 12.7919 235.145 13.035 235.087 13.2543C234.979 13.6653 234.871 13.8816 234.717 13.9964C234.668 14.0325 234.575 14.1677 234.511 14.2965C234.446 14.4256 234.275 14.6479 234.129 14.7906C233.983 14.9335 233.837 15.0802 233.805 15.1169C233.773 15.1536 233.701 15.219 233.646 15.262C233.051 15.7285 232.858 15.8595 232.599 15.9735C232.433 16.0463 232.238 16.1616 232.167 16.2292C232.095 16.297 231.836 16.4151 231.592 16.4918C231.348 16.5682 231.007 16.6984 230.835 16.7809C230.61 16.8885 230.352 16.9533 229.921 17.0113C229.591 17.0554 228.991 17.1489 228.59 17.2184C227.523 17.4035 226.765 17.4317 225.753 17.3241C225.289 17.275 224.871 17.2493 224.824 17.2675C224.724 17.3059 224.756 17.5765 224.877 17.713C224.917 17.758 224.981 17.8888 225.02 18.0038C225.14 18.3572 225.971 19.3586 226.371 19.6308C226.504 19.7216 226.651 19.854 226.698 19.9255C226.746 19.9983 226.889 20.091 227.025 20.1376C227.159 20.1831 227.413 20.3108 227.589 20.4212C227.907 20.6198 228.998 20.8628 229.93 20.9428C230.464 20.9886 232.148 20.6493 232.41 20.4433C232.52 20.3564 232.74 20.2311 232.898 20.1655C233.056 20.0998 233.324 19.9213 233.494 19.769C233.664 19.6168 233.818 19.4921 233.836 19.4921C233.9 19.4921 234.656 18.5743 234.804 18.3169C234.886 18.1735 235.02 17.979 235.1 17.8852C235.18 17.7914 235.261 17.6504 235.279 17.5718C235.428 16.9188 235.593 16.4325 235.722 16.2653C235.835 16.1191 235.862 15.8587 235.926 14.2656C235.979 12.9699 236.047 12.5779 236.279 12.251C236.337 12.1693 236.4 11.9969 236.421 11.8675C236.456 11.6416 236.516 11.4154 236.614 11.1351C236.64 11.0626 236.731 10.9216 236.817 10.8217C236.902 10.7222 236.996 10.5544 237.025 10.4493C237.071 10.2788 237.398 9.74146 237.496 9.67443C237.517 9.65981 237.585 9.55084 237.647 9.43167C237.896 8.95195 239.437 7.54146 239.974 7.30119C240.118 7.23719 240.269 7.14367 240.31 7.09374C240.412 6.97043 240.824 6.76657 241.062 6.72215C241.168 6.70201 241.355 6.6176 241.476 6.53457C241.781 6.32629 242.11 6.24105 242.872 6.17374C243.231 6.14174 243.654 6.09567 243.812 6.07084C244.168 6.01539 244.741 6.03663 245.823 6.14615ZM243.786 8.86422C243.527 8.93098 243.228 9.02367 243.119 9.07001C243.011 9.11636 242.744 9.18836 242.526 9.23001C242.214 9.2896 242.081 9.3456 241.904 9.49015C241.781 9.59139 241.567 9.72243 241.431 9.78091C241.294 9.83967 241.119 9.95332 241.043 10.0336C240.966 10.1139 240.813 10.2479 240.704 10.3315C240.428 10.542 240.233 10.7426 240.057 10.9994C239.974 11.1197 239.837 11.2879 239.753 11.3732C239.669 11.4584 239.568 11.6104 239.53 11.7108C239.491 11.8115 239.36 12.0604 239.238 12.2642C239.052 12.5759 238.999 12.729 238.908 13.2303C238.848 13.558 238.762 14.014 238.717 14.2438C238.622 14.7249 238.645 15.3696 238.775 15.8626C238.82 16.035 238.892 16.4104 238.935 16.697C238.994 17.0882 239.045 17.2598 239.141 17.3856C239.211 17.4775 239.269 17.5751 239.269 17.6022C239.269 17.6292 239.304 17.681 239.348 17.7169C239.391 17.7528 239.462 17.9026 239.504 18.0496C239.559 18.2391 239.635 18.3594 239.765 18.4628C239.866 18.5431 239.995 18.7004 240.052 18.8121C240.109 18.9238 240.224 19.0562 240.308 19.1059C240.393 19.1555 240.49 19.2493 240.525 19.3139C240.559 19.3787 240.696 19.5075 240.829 19.6005C240.962 19.6935 241.141 19.8353 241.227 19.9158C241.314 19.9961 241.49 20.099 241.619 20.1439C241.748 20.1892 241.978 20.3108 242.129 20.4146C242.42 20.6137 242.474 20.6289 243.485 20.7964C244.575 20.9768 246.251 20.7972 246.743 20.4471C246.876 20.3528 246.998 20.2753 247.015 20.2753C247.101 20.2753 247.656 19.9917 247.692 19.929C247.715 19.8893 247.907 19.7406 248.118 19.5983C248.328 19.4562 248.551 19.2587 248.612 19.1599C248.673 19.0609 248.816 18.8959 248.929 18.7936C249.043 18.691 249.206 18.4686 249.291 18.299C249.377 18.1296 249.516 17.9219 249.6 17.8377C249.7 17.7373 249.766 17.6055 249.791 17.4526C249.837 17.1702 250.082 16.4609 250.231 16.1779C250.331 15.9873 250.34 15.8849 250.34 14.8648V13.7586L250.152 13.3484C249.88 12.7547 249.881 12.7583 249.814 12.4168C249.767 12.1782 249.705 12.0499 249.55 11.8733C249.438 11.7462 249.305 11.5274 249.255 11.387C249.204 11.2427 249.108 11.0946 249.035 11.0466C248.879 10.9445 248.746 10.7942 248.641 10.6035C248.599 10.526 248.481 10.4228 248.379 10.3743C248.276 10.326 248.131 10.2057 248.056 10.1073C247.971 9.99498 247.792 9.87057 247.576 9.77263C247.387 9.68712 247.162 9.54808 247.075 9.46395C246.949 9.34201 246.827 9.29401 246.475 9.22725C246.233 9.18119 245.952 9.10946 245.852 9.06781C245.102 8.75415 244.457 8.6907 243.786 8.86422ZM229.216 8.97594C229.044 9.01953 228.586 9.11774 228.198 9.19415C227.568 9.31829 227.479 9.34919 227.365 9.48436C227.295 9.56767 227.095 9.70312 226.921 9.78533C226.339 10.0604 225.012 11.4714 225.012 11.8146C225.012 11.8639 224.947 11.9958 224.866 12.1078C224.372 12.7972 224.255 14.0375 224.659 14.3042C225.131 14.6154 228.162 14.5895 228.905 14.2678C229.047 14.2063 229.446 14.1012 229.791 14.0342C230.496 13.8973 230.684 13.8361 230.836 13.6943C230.894 13.6402 231.035 13.5569 231.149 13.5095C231.372 13.417 232.062 12.8802 232.062 12.7994C232.062 12.7726 232.169 12.6364 232.3 12.4962C232.764 12.0005 232.804 10.3464 232.363 9.94201C232.28 9.8667 232.102 9.69594 231.968 9.56243C231.743 9.33981 231.679 9.30891 231.174 9.18119C230.873 9.1045 230.546 9.02146 230.449 8.99636C230.089 8.90394 229.537 8.89484 229.216 8.97594Z" fill="black" fillOpacity="0.4" />
                            </g>
                            <g clipPath="url(#clip2_619_19123)">
                                <path fillRule="evenodd" clipRule="evenodd" d="M385.71 0.416087C385.862 0.623391 386.028 0.884261 386.079 0.995913C386.129 1.10722 386.231 1.26409 386.304 1.34374C386.862 1.94965 386.922 2.27209 386.54 2.60774C386.268 2.8467 386.169 2.87939 385.512 2.94409C385.075 2.98722 384.543 2.73052 384.452 2.43313C384.336 2.0533 383.835 1.99174 382.732 2.2213C381.817 2.41191 381.411 2.26235 381.039 1.598C380.6 0.812609 380.867 0.514174 382.119 0.38687C382.575 0.340609 383.13 0.251913 383.353 0.19C383.906 0.0362605 384.009 0.0251304 384.769 0.0324347L385.432 0.0393913L385.71 0.416087ZM411.672 0.0672181C412.022 0.164609 412.154 0.537826 412.126 1.35487C412.086 2.52391 412.133 2.50304 409.535 2.50304C407.032 2.50304 407.274 2.33643 407.323 4.0248C407.33 4.27384 407.499 4.2999 409.107 4.30337C411.278 4.3079 411.295 4.31767 411.295 5.57541C411.295 6.79871 411.305 6.7928 409.167 6.7928C407.946 6.7928 407.574 6.81054 407.452 6.87384L407.295 6.95489L407.307 7.66859C407.317 8.2665 407.337 8.40598 407.429 8.52946L407.539 8.67697L409.565 8.70584C411.727 8.7368 411.604 8.72077 411.991 9.02546C412.096 9.10859 412.107 9.18581 412.107 9.89085C412.107 11.1649 412.368 11.0829 408.308 11.0829C404.893 11.0829 404.959 11.0885 404.788 10.7768C404.661 10.5434 404.628 0.729478 404.753 0.468261C404.79 0.391739 404.836 0.282869 404.854 0.226174C404.872 0.169826 404.946 0.0995652 405.018 0.0706956C405.199 -0.00199986 411.412 -0.00478189 411.672 0.0672181ZM415.553 0.111739C415.958 0.316609 415.957 0.300957 415.959 4.5785C415.961 7.85506 415.974 8.38689 416.05 8.53506L416.139 8.70584L418.007 8.70619C420.589 8.70689 420.616 8.71837 420.645 9.8255C420.665 10.5855 420.586 10.8154 420.248 10.9806C420.005 11.0999 413.923 11.142 413.619 11.0269C413.281 10.8982 413.288 11.0189 413.292 5.5841C413.295 0.235218 413.295 0.239739 413.593 0.0835649C413.821 -0.0357395 415.304 -0.0141738 415.553 0.111739ZM428.507 0.0661739C428.764 0.163913 428.854 0.472087 428.854 1.25678C428.854 2.55174 428.952 2.50304 426.348 2.50304C423.852 2.50304 424.061 2.42026 424.087 3.39939C424.114 4.3848 423.948 4.30028 425.859 4.30028C428.029 4.30028 428.198 4.39037 428.189 5.54063C428.179 6.74167 428.086 6.7928 425.908 6.7928C424.484 6.7928 424.277 6.80428 424.183 6.8888C424.044 7.01506 424.028 8.18581 424.161 8.50477L424.246 8.70584L426.292 8.70685C428.934 8.7079 428.86 8.67384 428.86 9.88428C428.86 10.6582 428.797 10.8783 428.541 11.0077C428.309 11.1253 422.023 11.1145 421.74 10.9963C421.406 10.8568 421.411 10.9451 421.414 5.54654C421.417 0.118696 421.415 0.158 421.759 0.0619996C421.988 -0.00165256 428.339 0.00217388 428.507 0.0661739ZM435.534 0.303043C436.589 0.881826 437.128 1.37852 437.398 2.0213C437.476 2.2067 437.595 2.43452 437.661 2.52809C437.806 2.73296 437.86 3.2693 437.764 3.5608C437.668 3.85054 437.518 3.89437 436.623 3.89437C435.663 3.89437 435.464 3.82028 435.241 3.37991C434.597 2.10861 432.803 2.12809 432.541 3.40913C432.339 4.39628 432.31 4.67694 432.31 5.64424C432.309 6.3705 432.336 6.79311 432.403 7.09329C432.454 7.32668 432.528 7.68254 432.568 7.88463C432.792 9.01471 434.698 9.08077 435.121 7.97329C435.32 7.45259 435.791 7.2808 436.884 7.3288C437.517 7.35697 437.556 7.36598 437.683 7.51346C437.859 7.71833 437.871 8.28532 437.707 8.59002C437.646 8.70167 437.505 8.97541 437.393 9.19871C436.954 10.0707 435.928 10.8411 434.918 11.0578C433.013 11.4665 431.202 10.7563 430.255 9.22824C429.757 8.42442 429.436 5.38619 429.697 3.95245C429.724 3.8088 429.788 3.43939 429.839 3.13157C430.003 2.16357 430.629 1.20809 431.411 0.731913C431.507 0.673826 431.63 0.588609 431.684 0.543043C431.739 0.49713 432 0.357652 432.264 0.233478L432.744 0.00704409L433.904 0.0258257L435.063 0.0449562L435.534 0.303043ZM445.707 0.107217C445.873 0.245304 445.946 0.679739 445.92 1.38617C445.881 2.48287 445.859 2.50026 444.46 2.50896C443.947 2.51209 443.462 2.53261 443.382 2.55487L443.237 2.59522L443.208 6.67002L443.179 10.7445L442.99 10.9135L442.8 11.0829H441.944C440.501 11.0829 440.6 11.4213 440.603 6.50341L440.604 2.70687L440.414 2.60496C440.257 2.52043 440.071 2.50304 439.325 2.50235C438.008 2.50096 437.961 2.45852 437.963 1.28565C437.965 0.507217 438.053 0.143044 438.26 0.0599137C438.448 -0.0159123 445.613 0.0296522 445.707 0.107217ZM452.135 0.148956C452.936 0.437304 453.124 0.527391 453.453 0.780609C453.947 1.16043 454.329 1.63626 454.523 2.11243C454.615 2.33922 454.712 2.55278 454.74 2.58652C454.96 2.86061 454.968 4.0415 454.751 4.50306C454.677 4.66236 454.554 4.92323 454.479 5.08289C454.305 5.45054 453.679 6.14584 453.426 6.25158C453.143 6.37019 453.074 6.56181 453.229 6.80355C453.297 6.90929 453.392 7.08111 453.441 7.18546C453.49 7.28981 453.605 7.4985 453.698 7.64911C453.79 7.80007 453.924 8.07976 453.993 8.27106C454.064 8.46237 454.166 8.67106 454.221 8.73506C454.276 8.79871 454.405 9.02028 454.508 9.22758C454.611 9.43489 454.772 9.74793 454.867 9.92323C455.296 10.7198 455.051 11.0686 454.048 11.0839C452.433 11.1082 452.386 11.0849 451.922 10.0223C451.869 9.90129 451.759 9.67315 451.677 9.51523C451.215 8.62828 450.911 8.00289 450.806 7.72045C450.556 7.04602 450.091 6.7632 449.563 6.9639L449.419 7.01923L449.399 8.83346C449.378 10.751 449.378 10.75 449.125 10.95C448.897 11.1305 447.446 11.1615 447.159 10.9921C446.821 10.7921 446.831 10.9646 446.831 5.60463C446.831 0.134 446.826 0.212609 447.2 0.0752177C447.571 -0.0604344 451.726 0.00147787 452.135 0.148956ZM458.391 0.0859996C458.748 0.211565 458.742 0.121131 458.743 5.57541C458.744 10.8738 458.745 10.8401 458.437 10.9865C458.181 11.1079 456.905 11.1315 456.548 11.022C456.113 10.8884 456.136 11.1872 456.132 5.57576C456.128 0.00634832 456.116 0.186522 456.51 0.0720876C456.774 -0.00478189 458.161 0.00530406 458.391 0.0859996ZM467.788 0.0633916C467.868 0.0654786 468.365 0.0519134 468.894 0.0338266C470.188 -0.0106952 470.403 0.0901746 470.654 0.862C470.707 1.02757 470.799 1.22443 470.858 1.29922C470.917 1.37365 471.033 1.60148 471.116 1.80496C471.198 2.00843 471.305 2.21852 471.353 2.27139C471.401 2.32426 471.481 2.50896 471.532 2.68183C471.605 2.93296 471.897 3.54581 471.996 3.65607C472.078 3.74685 472.657 2.72739 472.74 2.34757C472.763 2.24635 472.813 2.13609 472.853 2.10304C472.893 2.07 472.986 1.90513 473.06 1.73678C473.562 0.591043 473.845 0.0974786 474.02 0.060609C474.355 -0.00999963 476.049 0.00565265 476.124 0.0797395C476.294 0.250522 476.211 1.118 475.991 1.45957C475.879 1.63278 475.788 1.80461 475.788 1.84113C475.788 1.87765 475.735 1.97435 475.671 2.05609C475.607 2.13748 475.474 2.39522 475.375 2.62896C475.276 2.8627 475.165 3.09296 475.126 3.14061C475.088 3.18861 474.994 3.37122 474.917 3.54654C474.839 3.72184 474.717 3.94619 474.644 4.04463C474.572 4.14341 474.512 4.24254 474.512 4.2655C474.512 4.3521 474.263 4.85645 474.165 4.96671C474.109 5.03071 474.017 5.22619 473.961 5.4015C473.904 5.5768 473.809 5.79071 473.749 5.87663C473.445 6.31002 473.442 6.33854 473.411 8.56115C473.374 11.2015 473.439 11.0829 472.033 11.0825C470.716 11.0825 470.755 11.1622 470.749 8.48459C470.744 6.51311 470.736 6.43732 470.51 6.1841C470.453 6.12045 470.339 5.90063 470.257 5.6961C470.174 5.49124 470.071 5.28254 470.027 5.23245C469.983 5.18202 469.911 5.03628 469.868 4.90897C469.825 4.78132 469.744 4.59871 469.688 4.50306C469.632 4.40741 469.485 4.11763 469.361 3.85885C469.237 3.60042 469.109 3.37191 469.076 3.35139C469.042 3.33087 468.944 3.12496 468.857 2.894C468.771 2.66304 468.655 2.422 468.6 2.358C468.545 2.29435 468.455 2.12496 468.4 1.9813C468.27 1.64391 468.006 1.22791 467.936 1.24809C467.906 1.25713 467.85 1.44496 467.812 1.66617C467.658 2.55174 467.806 2.50304 465.281 2.50304C463.469 2.50304 463.235 2.51348 463.14 2.59904C463.017 2.71035 462.985 3.86097 463.094 4.25437L463.154 4.46932L464.906 4.48602C467.172 4.50793 467.16 4.50167 467.162 5.66897C467.164 6.82271 467.108 6.85089 464.817 6.85089C463.853 6.85089 463.215 6.87381 463.146 6.91103C463.039 6.96807 463.034 7.04981 463.034 8.69363C463.033 11.1333 463.077 11.045 461.854 11.0721C460.211 11.1083 460.368 11.6902 460.367 5.56289C460.367 0.39487 460.364 0.479391 460.58 0.134C460.64 0.0376521 464.9 -0.0040868 467.788 0.0633916ZM449.672 2.54096C449.576 2.55591 449.471 2.60252 449.439 2.64426C449.347 2.76252 449.384 4.47937 449.48 4.5399C449.595 4.61329 451.307 4.59976 451.56 4.52393C452.364 4.28324 452.447 3.03696 451.686 2.62791C451.539 2.54861 450.038 2.48391 449.672 2.54096ZM387.254 2.99104C387.473 3.10617 387.86 3.52497 388.044 3.84602C388.129 3.99454 388.236 4.14793 388.282 4.18619C388.329 4.22445 388.447 4.38967 388.545 4.5535C388.854 5.06654 389.083 5.3935 389.555 5.99489C389.839 6.35628 389.876 6.53711 389.737 6.87207C389.626 7.13642 389.381 7.19903 387.993 7.31624C387.351 7.37085 386.492 7.51903 385.976 7.66442C385.719 7.73711 385.68 7.9319 385.88 8.14303C385.946 8.21363 386.061 8.38863 386.134 8.53193C386.208 8.67558 386.326 8.84497 386.396 8.90897C386.467 8.97263 386.587 9.14685 386.662 9.29607C386.738 9.44529 386.826 9.58376 386.859 9.60393C387.123 9.76706 386.742 10.134 386.135 10.3009C385.387 10.5065 385.173 10.5493 384.706 10.5862C383.609 10.6731 382.469 10.8091 382.251 10.8794C382.018 10.9545 381.69 11.0005 380.135 11.1747C378.992 11.3031 378.794 11.4693 379.208 11.9525C379.304 12.0638 379.42 12.2349 379.466 12.3323C379.512 12.4297 379.628 12.5907 379.723 12.6902C379.91 12.885 380.095 13.4001 380.037 13.5629C379.934 13.8536 379.755 13.9159 378.657 14.0415C378.338 14.0776 377.933 14.1555 377.757 14.2143C377.581 14.2735 377.099 14.35 376.685 14.3851C375.754 14.4638 375.254 14.5382 374.661 14.686C374.408 14.749 373.713 14.8509 373.115 14.9125C372.518 14.974 371.754 15.0769 371.419 15.1416C371.084 15.2063 370.421 15.2968 369.946 15.3424C368.892 15.4436 368.399 15.5197 368.085 15.6307C367.461 15.8509 365.872 15.8836 365.669 15.6805C365.51 15.5211 365.663 15.229 365.937 15.1688C366.031 15.1483 366.265 15.0262 366.457 14.8975C366.683 14.7472 366.966 14.6231 367.251 14.55C367.495 14.4878 367.802 14.3733 367.934 14.2961C368.066 14.2189 368.319 14.1058 368.497 14.0446C368.674 13.9834 368.881 13.894 368.956 13.846C369.031 13.7977 369.248 13.7038 369.44 13.6377C369.631 13.5712 369.853 13.469 369.932 13.4105C370.012 13.3521 370.312 13.2321 370.599 13.1434C370.886 13.0551 371.162 12.9465 371.212 12.902C371.263 12.8578 371.496 12.7566 371.73 12.677C371.963 12.5973 372.196 12.4975 372.247 12.4551C372.297 12.4126 372.469 12.3312 372.628 12.2742C372.787 12.2171 373.051 12.0971 373.215 12.0074C373.378 11.9176 373.665 11.8001 373.852 11.7462C374.417 11.5844 374.497 11.3754 374.143 10.9813C374.036 10.8617 373.892 10.653 373.823 10.5177C373.754 10.382 373.678 10.2711 373.652 10.2711C373.627 10.2711 373.566 10.1865 373.516 10.0829C373.467 9.97923 373.338 9.7848 373.23 9.65089C373.122 9.51697 372.961 9.29541 372.871 9.15837C372.781 9.02097 372.644 8.82024 372.567 8.71172C372.396 8.4745 372.387 8.25367 372.537 7.9608C372.71 7.62132 372.752 7.60602 373.767 7.51523C374.832 7.42028 376.066 7.27068 376.133 7.22894C376.227 7.17085 377.239 7.02515 377.961 6.96567C379.489 6.83941 380.072 6.60915 379.781 6.24671C378.445 4.58376 378.427 4.25819 379.655 4.04219C379.909 3.99767 380.258 3.92042 380.43 3.87103C380.603 3.82129 381.175 3.74028 381.7 3.69089C382.807 3.58689 383.34 3.5048 383.585 3.40043C383.68 3.35974 383.954 3.3093 384.193 3.28809C384.433 3.26722 384.759 3.21365 384.918 3.16948C385.078 3.1253 385.485 3.07765 385.824 3.06339C386.163 3.04948 386.49 3.00983 386.549 2.97504C386.703 2.886 387.07 2.89435 387.254 2.99104ZM373.981 4.23245C374.142 4.32428 374.336 4.72358 374.336 4.96671C374.337 5.19802 374.048 5.38689 373.616 5.43767C373.195 5.48741 373.131 5.56668 373.268 5.87103C373.327 6.00007 373.42 6.13819 373.477 6.1775C373.582 6.25124 373.817 6.73819 373.817 6.88254C373.817 7.04776 373.466 7.36807 373.247 7.4025C373.13 7.42094 372.872 7.46376 372.673 7.4975C372.001 7.61228 371.823 7.52598 371.328 6.84946C370.797 6.12181 370.576 5.92323 370.299 5.92323C369.325 5.92323 368.393 4.45437 369.208 4.20323C369.549 4.09819 373.791 4.12393 373.981 4.23245ZM366.483 8.18511C366.706 8.24598 367.133 8.3479 367.431 8.41224C367.729 8.47659 368.055 8.57993 368.155 8.64184C368.256 8.7041 368.506 8.81263 368.711 8.88323C368.915 8.95384 369.202 9.09958 369.348 9.20706C371.165 10.5445 371.539 11.0376 371.328 11.8192C371.257 12.0829 370.719 12.7058 370.562 12.7058C370.513 12.7058 370.387 12.7479 370.284 12.7994C369.932 12.975 369.363 12.758 368.768 12.2213C367.514 11.0909 365.746 10.5785 364.32 10.9319C364.011 11.0085 363.663 11.0874 363.547 11.1072C363.431 11.1274 363.24 11.2088 363.123 11.2881C363.006 11.3674 362.815 11.4721 362.697 11.5211C362.579 11.5702 362.405 11.6822 362.309 11.7702C362.214 11.8582 362.032 12.0063 361.905 12.0992C361.778 12.1921 361.605 12.3472 361.521 12.4436C361.222 12.7848 360.889 13.2251 360.889 13.2794C360.889 13.31 360.826 13.4091 360.75 13.4999C360.617 13.6585 360.529 13.893 360.246 14.8509C359.962 15.8088 360.196 17.7079 360.684 18.4161C360.751 18.5118 360.839 18.6582 360.881 18.7416C360.923 18.8248 361.015 18.9552 361.085 19.0314C361.154 19.1075 361.3 19.2937 361.408 19.445C361.516 19.5966 361.626 19.7205 361.654 19.7205C361.681 19.7205 361.787 19.806 361.89 19.911C361.993 20.0157 362.2 20.1722 362.349 20.2589C362.498 20.3455 362.656 20.4519 362.699 20.4957C362.743 20.5392 362.96 20.6328 363.182 20.703C363.403 20.7733 363.715 20.8926 363.874 20.9681C364.5 21.2648 366.004 21.2815 366.57 20.998C366.681 20.9416 366.956 20.8366 367.179 20.7639C367.81 20.5591 368.813 19.8606 369.104 19.4238C369.155 19.3479 369.267 19.2074 369.354 19.1118C369.441 19.0161 369.584 18.8074 369.67 18.6481C369.757 18.4885 369.865 18.317 369.91 18.2662C370.01 18.1531 370.136 17.7315 370.225 17.214C370.262 16.9994 370.342 16.7264 370.402 16.6078C370.463 16.4888 370.512 16.3448 370.512 16.2877C370.512 16.1629 370.902 15.7618 371.146 15.6355C371.559 15.4216 372.334 15.5076 372.605 15.7977C373.132 16.3615 373.279 16.8759 373.075 17.446C373.009 17.6289 372.898 18.0001 372.827 18.2711C372.756 18.542 372.638 18.8811 372.565 19.0248C372.492 19.1681 372.365 19.429 372.283 19.6046C372.045 20.1107 371.728 20.5949 371.353 21.0238C371.161 21.2425 370.953 21.486 370.889 21.565C370.651 21.8592 370.069 22.3465 369.781 22.4926C369.65 22.5591 369.467 22.6755 369.375 22.751C369.283 22.8269 369.078 22.9497 368.918 23.0245C368.759 23.0989 368.563 23.205 368.483 23.2603C368.403 23.3156 368.22 23.3921 368.077 23.4304C367.934 23.4686 367.66 23.5691 367.469 23.6533L367.121 23.8067L365.266 23.8057C363.6 23.8046 363.384 23.7935 363.15 23.6978C363.006 23.6394 362.708 23.5284 362.487 23.4519C362.265 23.375 362.043 23.2777 361.994 23.2356C361.944 23.1931 361.783 23.1017 361.636 23.0325C361.489 22.9629 361.254 22.8328 361.114 22.7427C360.975 22.653 360.743 22.5114 360.599 22.4279C359.869 22.0029 358.78 20.6978 358.245 19.6063C358.129 19.3684 357.986 19.1075 357.929 19.0265C357.872 18.9458 357.795 18.7281 357.758 18.543C357.721 18.3576 357.634 18.0835 357.565 17.9343C357.386 17.5455 357.371 14.4495 357.547 14.0683C357.606 13.9406 357.703 13.662 357.763 13.4488C357.824 13.2359 357.937 12.9674 358.015 12.8522C358.093 12.7371 358.199 12.5159 358.251 12.3601C358.302 12.2046 358.382 12.046 358.428 12.0081C358.474 11.9698 358.588 11.8042 358.682 11.6397C358.776 11.4755 358.92 11.2784 359.002 11.2018C359.083 11.1253 359.151 11.0345 359.151 11.0001C359.153 10.8891 360.093 10.0109 360.599 9.64706C360.87 9.45228 361.175 9.22511 361.275 9.14268C361.376 9.06024 361.598 8.9441 361.768 8.88428C361.938 8.82445 362.221 8.70967 362.396 8.62897C362.571 8.54793 362.924 8.44007 363.179 8.38929C363.434 8.33816 363.734 8.26616 363.846 8.22894C364.537 8.00042 365.729 7.98059 366.483 8.18511ZM395.087 8.15137C395.228 8.2025 395.607 8.2975 395.928 8.36254C396.249 8.42793 396.617 8.54132 396.744 8.61471C396.872 8.6881 397.152 8.80564 397.367 8.87659C397.582 8.9472 397.78 9.04358 397.806 9.09019C397.832 9.13715 397.986 9.25923 398.148 9.36115C399.299 10.0871 400.49 11.4098 400.857 12.3712C400.915 12.5222 401.024 12.7295 401.1 12.8321C401.175 12.9344 401.238 13.0589 401.238 13.1086C401.24 13.1938 401.402 13.6919 401.616 14.2711C401.815 14.8071 401.776 17.502 401.565 17.8345C401.492 17.9486 401.341 18.4081 401.259 18.7639C401.223 18.9191 401.051 19.2523 400.45 20.3323C400.113 20.9368 398.814 22.2707 398.367 22.4707C398.208 22.542 398.039 22.6471 397.992 22.7041C397.945 22.7608 397.7 22.9086 397.448 23.0317C397.195 23.1549 396.96 23.2794 396.925 23.3079C396.889 23.3368 396.691 23.4067 396.483 23.4634C396.276 23.5205 396.051 23.6022 395.984 23.6453C395.569 23.9103 392.101 23.9009 391.693 23.6342C391.618 23.5848 391.393 23.5038 391.194 23.4544C390.994 23.405 390.763 23.3159 390.68 23.2568C390.596 23.1977 390.362 23.0686 390.158 22.9702C389.554 22.6787 388.655 22.0321 388.3 21.6335C388.172 21.4898 387.996 21.2944 387.909 21.1987C387.641 20.9034 387.266 20.431 387.266 20.3889C387.266 20.3667 387.177 20.214 387.067 20.0491C386.958 19.8843 386.803 19.5743 386.723 19.3604C386.643 19.1465 386.525 18.8989 386.462 18.8098C386.399 18.7208 386.281 18.3479 386.2 17.9813C386.12 17.6147 386.014 17.2004 385.964 17.0609C385.823 16.6613 385.839 15.2443 385.99 14.8078C386.053 14.6241 386.158 14.2133 386.224 13.8944C386.289 13.5754 386.39 13.2495 386.448 13.1698C386.57 13.0001 386.766 12.5695 386.821 12.349C386.923 11.9396 387.923 10.6526 388.566 10.1017C389.376 9.4081 389.901 9.04633 390.37 8.85781C390.56 8.78164 390.833 8.66584 390.976 8.6001C391.12 8.53471 391.478 8.42894 391.771 8.36459C392.065 8.30059 392.359 8.21955 392.424 8.18511C392.776 7.99659 394.596 7.97363 395.087 8.15137ZM393.116 10.8168C393.099 10.8349 392.789 10.927 392.428 11.0216C392.055 11.1194 391.681 11.2571 391.559 11.3409C391.442 11.4223 391.318 11.4885 391.282 11.4885C390.995 11.4885 389.571 12.9138 389.443 13.3295C389.421 13.4015 389.341 13.5337 389.266 13.6231C388.862 14.1027 388.563 15.8307 388.742 16.6481C388.794 16.8871 388.862 17.2314 388.892 17.4129C388.956 17.7907 389.147 18.2711 389.233 18.2711C389.264 18.2711 389.318 18.3715 389.351 18.4943C389.384 18.6175 389.469 18.7817 389.541 18.8599C389.613 18.9378 389.741 19.0937 389.826 19.206C390.087 19.5504 390.993 20.358 391.119 20.358C391.137 20.358 391.25 20.422 391.369 20.4999C391.487 20.5778 391.793 20.709 392.048 20.7911C392.304 20.8731 392.604 20.9855 392.715 21.0408C393.023 21.1924 394.685 21.1872 394.976 21.0335C395.088 20.9747 395.409 20.8533 395.69 20.7636C395.971 20.6742 396.246 20.5601 396.302 20.5104C396.357 20.4603 396.524 20.3542 396.674 20.2749C397.11 20.0429 397.531 19.6474 397.904 19.1187C398.031 18.9378 398.232 18.6554 398.351 18.4912C398.491 18.2968 398.588 18.0798 398.629 17.8697C398.663 17.6919 398.741 17.4098 398.803 17.2429C399.08 16.4856 399.08 15.4798 398.803 14.7107C398.745 14.5486 398.665 14.2725 398.626 14.0971C398.548 13.7483 398.496 13.6258 398.375 13.5048C398.331 13.4609 398.255 13.3479 398.207 13.254C397.721 12.318 396.444 11.3489 395.258 11.0171C394.63 10.8415 393.223 10.71 393.116 10.8168ZM445.515 12.9017C445.601 12.9455 445.918 13.0387 446.218 13.1086C446.718 13.2251 447.672 13.7187 447.672 13.861C447.672 13.8798 447.813 14.0575 447.986 14.2558C448.159 14.4544 448.319 14.6759 448.342 14.7483C448.365 14.8206 448.454 14.9841 448.54 15.1118C448.868 15.5994 448.908 16.2522 448.63 16.5764L448.493 16.7351H447.6C446.565 16.7351 446.412 16.6714 446.138 16.1309C445.613 15.0954 444.189 14.9438 443.637 15.8651C443.291 16.4411 443.158 18.8279 443.4 20.0971C443.584 21.0624 443.617 21.1392 443.901 21.2846C444.03 21.3504 444.135 21.4286 444.135 21.4585C444.135 21.5563 444.62 21.6471 444.985 21.6182C445.454 21.581 445.884 21.2721 446.104 20.8151C446.359 20.2881 446.607 20.1879 447.663 20.1855C448.39 20.1841 448.641 20.2568 448.776 20.5079C448.964 20.8592 448.563 21.9848 448.055 22.5295C447.48 23.1458 447.349 23.2707 447.188 23.3528C447.087 23.4043 446.891 23.5278 446.752 23.6269L446.5 23.8074L445.071 23.8275C443.408 23.8509 443.041 23.806 442.773 23.5462C442.675 23.4509 442.554 23.3726 442.506 23.3726C442.364 23.3726 441.552 22.5601 441.348 22.2133C441.244 22.0377 441.128 21.8554 441.09 21.8074C440.647 21.2568 440.564 16.1528 440.984 15.2857C441.581 14.054 442.358 13.3792 443.556 13.0537C443.921 12.9545 444.231 12.8616 444.245 12.8477C444.31 12.7823 445.369 12.8276 445.515 12.9017ZM454.385 12.9013C454.471 12.9451 454.781 13.0359 455.075 13.1027C455.629 13.2289 455.784 13.3166 456.454 13.8784C457.023 14.3549 457.229 14.6749 457.546 15.5754L457.73 16.0971V18.445V20.7928L457.469 21.5107C457.09 22.5538 455.995 23.6325 455.158 23.7872C454.494 23.91 452.083 23.8255 451.789 23.6693C451.039 23.2696 450.187 22.4398 449.95 21.8791C449.229 20.1688 449.356 15.462 450.145 14.6891C450.22 14.6161 450.28 14.5337 450.28 14.5058C450.28 14.4321 450.913 13.8015 451.15 13.6384C451.262 13.5615 451.392 13.4515 451.44 13.3938C451.492 13.3309 451.781 13.223 452.167 13.1232C452.518 13.0321 452.857 12.9277 452.92 12.8915C453.086 12.7949 454.19 12.8025 454.385 12.9013ZM410.483 13.149C411.532 13.4053 412.323 14.3423 412.604 15.6589C412.741 16.3013 412.415 17.4144 411.929 17.9601C411.683 18.2373 411.682 18.2763 411.926 18.5465C412.127 18.7688 412.399 19.1841 412.582 19.5465C412.731 19.8425 412.732 21.5646 412.584 21.8655C412.044 22.9573 411.296 23.6422 410.492 23.7802C409.825 23.8947 404.915 23.829 404.79 23.7038C404.692 23.6067 404.685 23.3152 404.668 18.7765C404.647 13.4161 404.646 13.4449 404.892 13.1754L405.064 12.9879L407.542 13.0115C409.754 13.0328 410.069 13.0474 410.483 13.149ZM416.394 13.1848C416.557 13.3472 416.588 13.4258 416.617 13.75C416.662 14.2342 416.661 22.6849 416.616 23.2484C416.572 23.8147 416.519 23.8387 415.34 23.8307C414.336 23.8238 414.22 23.8001 414.113 23.5771C414.019 23.3827 414.01 13.6839 414.103 13.4387C414.245 13.0669 414.447 12.9959 415.363 12.9959H416.205L416.394 13.1848ZM420.636 13.2029L420.831 13.4098L420.832 14.9855C420.833 17.1107 420.799 17.0338 421.411 16.2958C421.65 16.0074 421.969 15.6251 422.121 15.447C422.272 15.2686 422.396 15.1017 422.396 15.0759C422.396 15.0498 422.585 14.8091 422.817 14.541C423.048 14.2728 423.341 13.9281 423.469 13.7757C423.596 13.623 423.771 13.4158 423.857 13.3149C423.943 13.2144 424.116 13.1013 424.241 13.0638C424.478 12.9928 426.368 12.9663 426.539 13.0317C426.747 13.1114 426.871 13.5542 426.728 13.7017C426.687 13.7441 426.59 13.8697 426.513 13.9813C426.436 14.093 426.288 14.2756 426.185 14.3872C425.897 14.6989 425.465 15.215 425.208 15.5535C425.08 15.7215 424.911 15.9316 424.831 16.0199C424.751 16.1079 424.543 16.3549 424.367 16.5685C424.192 16.7817 423.977 17.0342 423.889 17.1295C423.702 17.3326 423.69 17.4505 423.836 17.6401C423.895 17.7162 424.014 17.9344 424.1 18.1246C424.186 18.3152 424.294 18.5121 424.34 18.5622C424.385 18.6122 424.49 18.7827 424.574 18.9406C424.657 19.0985 424.775 19.2815 424.836 19.3472C424.897 19.4133 424.947 19.4916 424.948 19.5211C424.948 19.5511 425.065 19.7573 425.208 19.9796C425.352 20.2018 425.469 20.4241 425.469 20.4735C425.469 20.5232 425.543 20.6543 425.635 20.7653C425.726 20.8759 425.886 21.1365 425.99 21.3438C426.094 21.5511 426.204 21.7298 426.235 21.7416C426.266 21.7531 426.361 21.9096 426.447 22.0895C426.532 22.2689 426.681 22.5333 426.779 22.677C426.954 22.9354 427.173 23.5778 427.117 23.6689C427.025 23.8175 425.071 23.9051 424.514 23.7858C424.328 23.7458 424.13 23.4599 423.785 22.7351C423.686 22.5278 423.566 22.3149 423.518 22.2617C423.47 22.2081 423.357 22.0091 423.267 21.8192C423.177 21.6289 423.072 21.4544 423.034 21.4307C422.996 21.4071 422.891 21.2321 422.801 21.0422C422.711 20.8519 422.599 20.653 422.552 20.5998C422.505 20.5465 422.408 20.3594 422.337 20.1841C422.212 19.8763 421.99 19.6046 421.866 19.6046C421.788 19.6046 421.199 20.2387 420.991 20.5462L420.831 20.7813L420.83 22.1205C420.829 23.9765 420.921 23.8645 419.435 23.8265C418.362 23.7991 418.311 23.7789 418.26 23.3604C418.188 22.7562 418.222 13.6171 418.297 13.4463C418.464 13.0703 418.679 12.9959 419.604 12.9959H420.441L420.636 13.2029ZM434.91 13.1427C435.151 13.3458 435.213 13.5806 435.191 14.2165C435.151 15.3497 435.218 15.3211 432.577 15.3337C430.758 15.342 430.442 15.3563 430.393 15.4307C430.319 15.5424 430.348 17.029 430.425 17.1058C430.46 17.1399 431.187 17.1733 432.225 17.1879C434.545 17.2206 434.536 17.2161 434.519 18.3458C434.499 19.6512 434.643 19.5688 432.327 19.6046C430.746 19.629 430.441 19.6471 430.392 19.7205C430.323 19.8231 430.345 21.4272 430.416 21.4989C430.443 21.5249 431.425 21.5594 432.6 21.5754C435.329 21.6126 435.282 21.5858 435.172 23.0182L435.121 23.6916L434.892 23.766C434.515 23.8895 428.057 23.8411 427.931 23.7142C427.748 23.5316 427.733 23.1166 427.731 18.4102C427.729 13.2283 427.72 13.3751 428.069 13.1385L428.278 12.9959H431.507H434.735L434.91 13.1427ZM407.518 15.3688C407.317 15.4557 407.258 15.8937 407.321 16.8363C407.346 17.2154 409.203 17.2387 409.707 16.8665C410.113 16.5653 410.034 15.8022 409.564 15.5034C409.305 15.3385 407.815 15.2404 407.518 15.3688ZM452.946 15.4342C452.773 15.5104 452.659 15.6074 452.609 15.7194C452.568 15.8126 452.47 15.9837 452.391 16.0995C452.154 16.4491 452.125 16.7497 452.148 18.6321C452.17 20.4829 452.164 20.4394 452.472 20.9358C453.112 21.965 454.414 21.8189 455.035 20.6481C455.255 20.2328 455.16 16.3097 454.923 16.0185C454.854 15.9344 454.753 15.7931 454.699 15.7051C454.46 15.3201 453.53 15.1761 452.946 15.4342ZM407.425 19.7351C407.285 19.8693 407.264 21.3611 407.401 21.4982C407.477 21.5747 409.076 21.5921 409.345 21.5194C409.481 21.4829 409.687 21.3573 409.823 21.2286L410.061 21.0018L410.038 20.5497C409.996 19.6888 409.873 19.6168 408.443 19.6091C407.606 19.6046 407.556 19.6109 407.425 19.7351ZM461.149 21.3062C461.488 21.4084 461.525 21.526 461.526 22.5104C461.527 23.8954 461.59 23.8356 460.13 23.8359C458.969 23.8366 458.887 23.8098 458.839 23.4129C458.71 22.3333 458.824 21.4349 459.11 21.2971C459.286 21.2119 460.86 21.2192 461.149 21.3062Z" fill="black" fillOpacity="0.4" />
                            </g>
                            <g clipPath="url(#clip3_619_19123)">
                                <path d="M564.865 25C564.047 25 563.388 24.5896 562.901 23.7673L560.114 19.2297H546.72L543.926 23.7673C543.523 24.4447 543.032 24.7876 542.491 24.7876C541.993 24.7806 541.512 24.5999 541.132 24.2768C540.631 23.9022 540.379 23.4243 540.379 22.879C540.378 22.6743 540.432 22.4732 540.535 22.2964L550.982 4.39271C551.503 3.49724 552.389 3.04663 553.61 3.04663C554.577 3.04663 555.243 3.381 555.586 4.04112C555.622 4.09845 555.652 4.15956 555.675 4.22337C555.699 4.27999 555.726 4.33469 555.758 4.38697L566.83 21.9563C566.935 22.1937 566.981 22.4534 566.963 22.7126C566.981 23.3067 566.772 23.8852 566.379 24.3313C566.191 24.546 565.957 24.7171 565.696 24.8326C565.434 24.9481 565.151 25.0052 564.865 25ZM557.587 15.1986L553.438 8.33048L549.248 15.1986H557.587Z" fill="black" fillOpacity="0.4" />
                                <path d="M568.994 24.5896C567.946 24.5896 567.346 23.9266 567.346 22.78V5.07005C567.346 3.93206 567.946 3.28198 568.994 3.28198H582.77C584.695 3.28198 586.358 3.58765 587.721 4.19037C589.818 5.06575 590.878 6.44483 590.878 8.29031V11.4474C590.878 13.6789 589.874 15.3077 587.898 16.2921C586.441 16.9795 584.666 17.3254 582.618 17.3254H571.627V22.7786C571.627 23.9008 570.977 24.2968 570.592 24.4432C570.492 24.5035 570.195 24.5896 568.994 24.5896ZM582.812 13.2958C585.378 13.2958 586.626 12.65 586.626 11.324V8.55292C586.626 7.49529 584.544 7.27716 582.799 7.27716H571.627V13.2958H582.812Z" fill="black" fillOpacity="0.4" />
                                <path d="M599.387 24.5896C597.675 24.6069 595.98 24.238 594.43 23.5104C592.487 22.5159 591.504 21.012 591.504 19.0202V8.93895C591.495 7.884 591.835 6.8556 592.471 6.01431C593.832 4.20041 596.253 3.28772 599.665 3.28772H602.904C603.514 3.28772 604.536 3.57473 604.536 5.47617C604.536 7.10639 603.395 7.2829 602.904 7.2829H601.966C601.869 7.28786 601.773 7.27965 601.679 7.2585L600.693 7.2298C598.434 7.2298 595.746 7.52686 595.746 8.94469V12.0157H611.227C611.741 12.0157 612.932 12.2037 612.932 13.9372C612.932 15.7712 611.857 16.0439 611.21 16.0439H595.781V18.8939C595.781 20.0003 597.043 20.5643 599.538 20.5643H611.209C612.259 20.5643 612.858 21.2215 612.858 22.3681C612.858 24.304 611.829 24.5953 611.209 24.5953L599.387 24.5896Z" fill="black" fillOpacity="0.4" />
                                <path d="M622.177 24.5896C620.607 24.5896 619.502 24.515 618.806 24.3772C617.96 24.1831 617.148 23.8618 616.398 23.4243C615.429 22.8503 614.736 22.249 614.351 21.619C613.876 20.9015 613.634 19.9673 613.634 18.8379V8.72512C613.634 7.30586 614.219 6.07889 615.364 5.08727C616.342 4.26444 617.516 3.70961 618.773 3.47715C619.177 3.40758 619.586 3.35967 619.995 3.33364C620.462 3.30351 621.019 3.28772 621.656 3.28772H633.485C634.105 3.28772 635.138 3.57473 635.138 5.47617C635.138 6.62421 634.534 7.2829 633.485 7.2829H621.717C619.982 7.2829 617.917 7.52686 617.917 8.71795V18.7834C617.917 19.9659 619.352 20.5686 622.181 20.5686H633.426C633.931 20.5686 635.118 20.7609 635.118 22.5777C635.118 24.3413 634.056 24.6054 633.426 24.6054L622.177 24.5896Z" fill="black" fillOpacity="0.4" />
                                <path d="M668.071 24.5896C666.947 24.5896 666.138 24.0156 665.676 22.8862L660.396 10.2391L654.933 22.9178C654.494 23.9223 653.682 24.4361 652.557 24.4361C651.34 24.4361 650.507 23.9022 650.067 22.8389L642.925 5.80768C642.822 5.5691 642.766 5.3127 642.761 5.05285C642.756 4.75643 642.83 4.46402 642.976 4.20624C643.123 3.94847 643.336 3.73481 643.593 3.58766C644.017 3.31544 644.512 3.1728 645.015 3.17724C646.224 3.17724 646.713 3.88472 646.898 4.31093L652.547 17.7774L657.917 4.8792C658.393 3.70103 659.243 3.07678 660.356 3.07678C660.787 3.07678 661.232 3.25042 661.735 3.60201C662.155 3.88536 662.49 4.27713 662.705 4.7357L668.159 17.7717L673.729 4.32671C673.943 3.81009 674.457 3.19015 675.731 3.19015C676.208 3.18697 676.677 3.31666 677.085 3.5647C677.338 3.70361 677.549 3.90797 677.695 4.15639C677.842 4.40481 677.92 4.68817 677.92 4.97679C677.918 5.26062 677.86 5.54125 677.748 5.80194L670.572 22.78C670.063 23.9654 669.2 24.5896 668.071 24.5896Z" fill="black" fillOpacity="0.4" />
                                <path d="M696.634 25C695.826 25 695.15 24.5896 694.672 23.7673L691.887 19.2297H678.481L675.695 23.7702C675.285 24.4475 674.797 24.7905 674.25 24.7905C673.754 24.7842 673.276 24.6033 672.9 24.2796C672.398 23.9051 672.145 23.4272 672.145 22.8819C672.147 22.6801 672.202 22.4824 672.303 22.3079L682.751 4.39271C683.268 3.49724 684.156 3.04663 685.375 3.04663C686.346 3.04663 687.009 3.381 687.354 4.05117C687.388 4.10858 687.418 4.16801 687.446 4.22911C687.473 4.28795 687.5 4.34248 687.524 4.40419L698.596 21.9563C698.7 22.1941 698.745 22.4535 698.728 22.7126C698.743 23.306 698.535 23.8835 698.145 24.3313C697.959 24.5479 697.726 24.7203 697.465 24.836C697.204 24.9516 696.92 25.0077 696.634 25ZM689.353 15.1986L685.191 8.33048L681.014 15.1986H689.353Z" fill="black" fillOpacity="0.4" />
                                <path d="M702.396 24.5896C701.297 24.5896 700.961 24.525 700.793 24.4633C700.409 24.3313 699.758 23.9424 699.758 22.78V7.28143H692.953C691.893 7.28143 691.299 6.62131 691.299 5.4747C691.299 4.78444 691.365 4.31662 691.536 4.00952C691.706 3.70242 692.081 3.29199 692.953 3.29199H710.883C711.504 3.29199 712.54 3.579 712.54 5.48044C712.54 6.62848 711.931 7.28717 710.883 7.28717H704.032V22.7857C704.032 24.4087 702.893 24.5896 702.396 24.5896Z" fill="black" fillOpacity="0.4" />
                                <path d="M720.63 24.5896C718.918 24.6065 717.224 24.2377 715.675 23.5104C713.723 22.5059 712.744 20.9948 712.744 19.0202V8.93895C712.737 7.88256 713.082 6.85382 713.723 6.01431C715.079 4.20041 717.503 3.28772 720.911 3.28772H724.146C724.758 3.28772 725.779 3.57473 725.779 5.47617C725.779 7.10639 724.631 7.2829 724.146 7.2829H723.219C723.122 7.28708 723.026 7.27888 722.932 7.2585L722.373 7.23554H721.943C719.688 7.23554 717.011 7.5326 717.011 8.95043V12.0214H732.483C732.988 12.0214 734.181 12.2094 734.181 13.943C734.181 15.777 733.106 16.0496 732.469 16.0496H717.034V18.8996C717.034 20.006 718.292 20.57 720.786 20.57H732.466C733.517 20.57 734.111 21.2273 734.111 22.3739C734.111 24.3098 733.08 24.6011 732.466 24.6011L720.63 24.5896Z" fill="black" fillOpacity="0.4" />
                                <path d="M755.187 24.6025C754.732 24.6166 754.277 24.5684 753.835 24.459L739.383 17.5277V22.7829C739.383 23.918 738.757 24.5925 737.74 24.5925C736.467 24.5925 736.213 24.5006 736.039 24.4016C735.788 24.3184 735.099 23.9711 735.099 22.7829V5.07005C735.099 3.93206 735.696 3.28198 736.742 3.28198H750.055C752.175 3.28198 753.953 3.59626 755.346 4.22625C757.424 5.16477 758.488 6.73902 758.488 8.90738V11.3599C758.488 13.3948 757.52 14.8973 755.617 15.8272C754.2 16.4773 752.529 16.8073 750.671 16.8073H747.37L756.48 21.1397C757.236 21.5143 757.628 22.1098 757.628 22.8618C757.627 23.5162 757.308 24.6025 755.187 24.6025ZM750.639 12.8078C752.269 12.8078 754.205 12.5639 754.205 11.3943V8.82127C754.205 7.54551 751.938 7.27716 750.044 7.27716H739.383V12.8078H750.639Z" fill="black" fillOpacity="0.4" />
                                <path d="M764.186 0C764.789 0.00520749 765.381 0.161619 765.908 0.454911C766.464 0.749645 766.92 1.2013 767.221 1.75363C767.527 2.2879 767.688 2.89294 767.688 3.5087C767.688 4.12445 767.527 4.7295 767.221 5.26376C766.922 5.81373 766.471 6.26568 765.921 6.56535C765.388 6.8691 764.786 7.02884 764.172 7.02884C763.559 7.02884 762.957 6.8691 762.424 6.56535C761.874 6.26494 761.422 5.81325 761.121 5.26376C760.814 4.72978 760.652 4.12462 760.652 3.5087C760.652 2.89277 760.814 2.28762 761.121 1.75363C761.425 1.20471 761.882 0.756015 762.437 0.462086C762.971 0.161906 763.573 0.00287204 764.186 0ZM764.186 0.58263C763.684 0.586754 763.19 0.717023 762.751 0.961483C762.289 1.21044 761.908 1.58767 761.655 2.04782C761.396 2.49164 761.26 2.9957 761.259 3.50917C761.257 4.02264 761.391 4.52736 761.648 4.97245C761.9 5.43019 762.277 5.80654 762.735 6.05734C763.179 6.31216 763.682 6.44625 764.193 6.44625C764.705 6.44625 765.208 6.31216 765.651 6.05734C766.109 5.80643 766.485 5.43003 766.736 4.97245C766.991 4.52738 767.126 4.02322 767.126 3.51013C767.126 2.99704 766.991 2.49289 766.736 2.04782C766.483 1.58732 766.103 1.20998 765.64 0.961483C765.195 0.71451 764.695 0.584176 764.186 0.58263ZM762.643 5.4618V1.67757H763.944C764.269 1.66281 764.594 1.69815 764.908 1.78233C765.102 1.84814 765.269 1.97629 765.383 2.14683C765.497 2.30966 765.559 2.50342 765.559 2.7022C765.56 2.83543 765.534 2.96748 765.484 3.09066C765.433 3.21385 765.358 3.3257 765.264 3.41972C765.055 3.6301 764.775 3.75324 764.479 3.76414C764.597 3.81077 764.706 3.87888 764.8 3.96504C765.013 4.19374 765.201 4.44491 765.36 4.71414L765.825 5.45319H765.08L764.744 4.85764C764.48 4.38838 764.268 4.09563 764.106 3.97652C763.961 3.88042 763.789 3.83452 763.616 3.84593H763.259V5.45319L762.643 5.4618ZM763.255 3.33362H763.995C764.348 3.33362 764.587 3.281 764.713 3.17576C764.815 3.08939 764.881 2.9685 764.9 2.83616C764.918 2.70382 764.888 2.56929 764.813 2.45824C764.749 2.36754 764.659 2.29846 764.555 2.2602C764.355 2.20613 764.149 2.18432 763.942 2.19563H763.249L763.255 3.33362Z" fill="black" fillOpacity="0.4" />
                            </g>
                            <defs>
                                <clipPath id="clip0_619_19123">
                                    <rect width="39.36" height="24" fill="white" transform="translate(0.302246)" />
                                </clipPath>
                                <clipPath id="clip1_619_19123">
                                    <rect width="72" height="24" fill="white" transform="translate(221.422)" />
                                </clipPath>
                                <clipPath id="clip2_619_19123">
                                    <rect width="118.957" height="24" fill="white" transform="translate(357.422)" />
                                </clipPath>
                                <clipPath id="clip3_619_19123">
                                    <rect width="227.319" height="25" fill="white" transform="translate(540.379)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </span>
                </BlockStack>
            </div>
        </Card>

        //这里有四个弹窗
        const upgradeModalTextByDisposable = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used {{v1}} for {{v2}} days, it still has $ {{v3}} left.", this.state.modalData.now_plan, this.state.modalData.after_days, this.state.modalData.balance)}
                <br /> <br />
                {t("Now you want to upgrade to Premium Plan, we will change this $")}{this.state.modalData.balance} {t("to premium plan(half year), at the price of the premium plan(half year), you will be able to use the premium plan(half year) for")} {this.state.modalData.change_days} {t("days.")}
                <br /> <br />
                {t("Are you sure to change ?")}
                <br /> <br />
                <span style={{ color: "red" }}>{t("Notice:This process is irreversible!")}</span>
            </p>
        )
        const degradeModalTextByDisposable = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used {{v1}} for {{v2}} days, it still has $ {{v3}} left.", this.state.modalData.now_plan, this.state.modalData.after_days, this.state.modalData.balance)}
                <br /> <br />
                {t("Now you want to degrade to Pro Plan, we will change this $")}{this.state.modalData.balance} {t("to Pro Plan(half year), at the price of the Pro Plan(half year), you will be able to use the Pro Plan(half year) for")} {this.state.modalData.change_days} {t("days.")}
                <br /> <br />
                {t("Are you sure to change ?")}
                <br /> <br />
                <span style={{ color: "red" }}>{t("Notice:This process is irreversible!")}</span>
            </p>
        )
        const upgradeModalTextBySubscription = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used Pro Plan(per month) for")}&nbsp;{this.state.modalData.charge_days} {t("days, If you switch to the premium plan(per month), the old recurring bill will be closed and charged for")} {this.state.modalData.charge_days} {t("days, then the new recurring bill will start charging.")}
                <br /><br />
                {t("Are you sure to change ?")}
            </p>
        )
        const degradeModalTextBySubscription = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used premium plan(per month) for")}&nbsp;{this.state.modalData.charge_days} {t("days, If you switch to the Pro Plan(per month), the old recurring bill will be closed and charged for")} {this.state.modalData.charge_days} {t("days, then the new recurring bill will start charging.")}
                <br /><br />
                {t("Are you sure to change ?")}
            </p>
        )

        //首字母大写
        const pageModalTitle = (str) => { return str.replace(str[0], str[0].toUpperCase()); };
        //升降级弹窗
        const pageModal = modalData.length === 0 ? null : (
            <div>
                <Modal
                    open={openModalChange}
                    onClose={() => { this.setState({ openModalChange: !openModalChange }) }}
                    title={modalData.change_type !== undefined ? pageModalTitle(modalData.change_type) : null}
                    primaryAction={{
                        content: t("YES"),
                        onAction: () => { this.updatePlanConversion(selectId, modalData.pay_type) },
                        loading: openModalLoading
                    }}
                    secondaryActions={[
                        {
                            content: t("NO"),
                            onAction: () => { this.setState({ openModalChange: !openModalChange }) },
                        },
                    ]}
                >
                    <Modal.Section>
                        <BlockStack>
                            {modalData.pay_type === 1 ? modalData.change_type === 'upgrade' ? upgradeModalTextByDisposable : degradeModalTextByDisposable : null}
                            {modalData.pay_type === 2 ? modalData.change_type === 'upgrade' ? upgradeModalTextBySubscription : degradeModalTextBySubscription : null}
                        </BlockStack>
                    </Modal.Section>
                </Modal>
            </div>)

        // 降级优惠弹窗
        const degradeDiscountModal = <Modal
            open={isShowFiveModal}
            title={<div>
                <span>{t("Special offer")} 👇</span>
            </div>}
            secondaryActions={{
                content: t("Stay"),
                onAction: () => this.openFeedbackModal(true),
            }}
            primaryAction={[
                {
                    content: t("Continue degrade"),
                    onAction: () => this.handleDowngrade(true, true),
                    loading: this.state.paidLoading
                },
            ]}
            onClose={this.openFeedbackModal}
        >
            <div className='degrade_discount modal_padding'>
                <Text variant="headingMd" as="h2">🎁 {t("Discount code")}:【STAY50】</Text>
                <p>
                    {t("We're sorry to hear that you're considering downgrading. We sincerely hope you reconsider, so we've provided you with a special discount code to express our gratitude and sincerity. you can enjoy a")}&nbsp;<span style={{ color: 'var(--color-primary)' }}>{t("50%")}</span>&nbsp;{t("discount on all packages. This is our way of expressing apology and hoping you'll continue to choose us.")}
                </p>
            </div>
        </Modal>

        //切换套餐提示弹窗（年费扣费后使用时长 < 30 天）
        const { currentPlan: srCurrentPlan, selectedPlan: srSelectedPlan, nextChargeTime: srNextChargeTime } = this.state.switchReviewData || {};
        const srNextChargeDate = srNextChargeTime ? formatUSATime(srNextChargeTime) : "-";
        const switchReviewModal = (
            <Modal
                open={openSwitchReviewModal}
                title={t("Review before switching plan")}
                onClose={this.closeSwitchReviewModal}
                primaryAction={{
                    content: t("Switch Plan"),
                    onAction: this.confirmSwitchReview,
                }}
                secondaryActions={[
                    {
                        content: t("Contact support"),
                        onAction: this.handleSwitchReviewContact,
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap="200">
                        <Text as="p" variant="bodyMd">
                            {t("Your")} <Text as="span" fontWeight="semibold">{t("{{v1}} subscription", srCurrentPlan)}</Text> {t("is active until {{v1}}.", srNextChargeDate)}
                        </Text>
                        <Text as="p" variant="bodyMd">
                            {t("If you switch to {{v1}} now,", srSelectedPlan)} <Text as="span" fontWeight="semibold">{t("the unused portion of your annual subscription won't be refunded automatically.")}</Text>
                        </Text>
                        <Text as="p" variant="bodyMd">
                            {t("You can switch plans now and contact support afterward. We'll review your annual plan usage and time remaining to determine any eligible refund.")}
                        </Text>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )

        //月费降级到免费弹窗
        const freePlanDegrade = (
            <Modal
                open={openFreePlanDegrade}
                title={t("Degrade warning")}
                onClose={() => { this.setState({ openFreePlanDegrade: !this.state.openFreePlanDegrade }) }}
                secondaryActions={{
                    content: t("Let me think"),
                    onAction: () => { this.setState({ openFreePlanDegrade: !this.state.openFreePlanDegrade }) },
                    disabled: this.state.paidLoading
                }}
                primaryAction={[
                    {
                        content: t("Yes"),
                        onAction: () => { handleDowngrade(true) },
                        loading: this.state.paidLoading
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack>
                        <div className='freePlanDegradeContent'>
                            {/* <Icon source={FreeDegradeWarningIcon} /> */}
                            {
                                userInfo.level === 3 ? <p>{t("If you downgrade, you won't be able to continue using competitor keyword research and AMP functions. Are you sure you want to downgrade?")}</p> : <p>{t("If you downgrade, you'll lose access to features like automatic broken link fixing and image compression. Are you sure you want to downgrade?")}</p>
                            }
                        </div>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )

        // 旧用户一次性付费提示
        const oldPayUserModal = (
            <Modal
                open={oldPayModalStatus}
                title={t("Approve subscription")}
                onClose={() => this.closePayTipModal()}
                primaryAction={{
                    content: t("OK"),
                    onAction: () => this.closePayTipModal(),
                }}
            >
                <Modal.Section>
                    <BlockStack>
                        <p>{t("You are currently subscribed to a paid plan and cannot select a new subscription package for payment. Please first downgrade to a free plan and then select again.")}</p>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )

        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />

        // 折扣模块
        // const giftDis = <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M7.9361 1.45423C8.36004 1.0291 9.14023 0.486413 9.80286 0.5541L14.3676 1.0291C15.0302 1.09798 15.624 1.69173 15.624 2.28785L15.9304 6.66974C15.9981 7.33236 15.5741 8.11374 15.0991 8.58993L8.0216 15.6758C7.59648 16.0997 7.00273 16.0997 6.52654 15.6069L0.893029 9.96624C0.418028 9.49124 0.347966 8.94618 0.824154 8.46999L7.90167 1.38535L7.9361 1.45423ZM18.8077 4.89679C19.2197 5.3338 19.5 6.25886 19.5 6.87042L19.3848 17.1209C19.3848 17.7313 18.8564 18.2906 18.2804 18.2906L12.2752 18.3607H11.1044C10.5272 18.3607 9.9988 17.8014 9.9988 17.191L10.0641 15.7755L15.9042 9.59455C16.9599 8.47711 17.1903 7.25517 17.125 6.57236L16.9445 2.92317L18.8077 4.89679ZM11.5687 4.92054C12.0247 5.37773 12.774 5.44305 13.2454 4.98586C13.7014 4.52748 13.6527 3.77461 13.1813 3.30079C12.7253 2.8436 11.976 2.77829 11.5045 3.23548C11.0485 3.71048 11.0972 4.46217 11.5687 4.92054Z" fill="var(--color-primary)" />
        // </svg>
        // const ExclusiveDiscount = <div className='discount_block'>
        //     <Card>
        //         <div className='dis_main'>
        //             <BlockStack gap={200}>
        //                 <div className='dis_top'>
        //                     <span>{giftDis}</span>
        //                     <Text variant="headingLg" as="h2">{t("Exclusive discount")}</Text>
        //                 </div>
        //                 <p>{t("Discount codes can be obtained from partners.")}</p>
        //             </BlockStack>
        //             <BlockStack gap={400}>
        //                 <div className='dis_input'>
        //                     <TextField
        //                         label=""
        //                         value={discountVal}
        //                         onChange={this.handleDiscountChange}
        //                         autoComplete="off"
        //                         disabled={iscacheLoading}
        //                         connectedRight={
        //                             <Button variant='primary' loading={disBtnLoading || iscacheLoading} onClick={this.verifyDisCode}>{t("Apply code")}</Button>
        //                         }
        //                         focused={codeFocus}
        //                         error={discountValError}
        //                     />
        //                 </div>
        //                 {
        //                     isShowDisTicket && <div className='dis_detail'>
        //                         <div className='dd_left'>
        //                             <div></div>
        //                             <div></div>
        //                             <div></div>
        //                             <div></div>
        //                         </div>
        //                         <div className='dd_main'>
        //                             <div className='dd_dis'>{`${discountRate === 0 ? '100% OFF' : (discountRate > 0 && discountRate < 1) ? (discountRate * 100).toFixed(0) + '% OFF' : '$ ' + discountRate}`}</div>
        //                             <div className='dd_plan'>{discountPlan}</div>
        //                             <div className='dd_icon'>
        //                                 <img src='/imgs/Image/discount_img.png' alt='discount_img.png' />
        //                             </div>
        //                         </div>
        //                         <div className='dd_Right'>
        //                             <div></div>
        //                             <div></div>
        //                             <div></div>
        //                             <div></div>
        //                         </div>
        //                     </div>
        //                 }
        //             </BlockStack>
        //         </div>
        //     </Card>
        // </div>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 额外福利弹窗
        const ExtraGiftBox = <Modal
            open={isShowExtraGift}
            title={<div className='flex_layout'>
                {extraIcon} <span style={{ color: '#FC0A0A' }}>{t("Over $100")}</span>&nbsp;{t("extra benefits")}
            </div>}
            primaryAction={userInfo.level !== 3 ? {
                content: t("Upgrade"),
                onAction: () => this.handleUpdatePricingMeal(prePlanId, prePlanPrice, preVersionLevel, { preDiscount, preDiscountPrice, preMonthCountDown, preMonthCountDown_mills, preYearCountDown, preYearCountDown_mills }),
                loading: paidBtnLoading === preVersionLevel,
            } : null}
            onClose={() => {
                this.setState({ isShowExtraGift: false })
            }}
        >
            <Modal.Section>
                <Text variant="headingMd" as="h6">{t("By subscribing to the Pre plan, you can also enjoy a one-month free trial of all the following applications.")}</Text>
                <div id='extra_app_gift'>
                    <BlockStack gap={300}>
                        {
                            Object.keys(appGiftList).map(item => {
                                return <div key={appGiftList[item].title} className='gapp_item'>
                                    <div className='gitem_img'><img src={appGiftList[item].img} alt={appGiftList[item].title} /></div>
                                    <div className='gitem_text'>
                                        <Text variant="headingMd" as="h2">{appGiftList[item].title}</Text>
                                        <p>{appGiftList[item].desc}</p>
                                        <div className='gitem_price'>
                                            <span>$0</span>
                                            <span>${appGiftList[item].price}</span>
                                        </div>
                                    </div>
                                    {
                                        userInfo.level === 3 && <div className='gitem_btn'>
                                            <Tooltip content={t(appGiftList[item].tip)}>
                                                <Button onClick={() => {
                                                    window.open(appGiftList[item].url)
                                                }}>{t("Activate")}</Button>
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                            })
                        }
                    </BlockStack>
                </div>
            </Modal.Section>
        </Modal>

        // cw组合套餐提示弹窗
        const CWComboModal = <Modal
            open={isShowCwComboModal}
            title={t("Plan reminder")}
            primaryAction={{
                content: t("Go to view"),
                onAction: this.goSolutionExpert,
            }}
            secondaryActions={[
                {
                    content: t("Close"),
                    onAction: () => {
                        this.setState({ isShowCwComboModal: false })
                    }
                }
            ]}
            onClose={() => {
                this.setState({ isShowCwComboModal: false })
            }}
        >
            <Modal.Section>
                <p>{t("You are currently using CWILL's package, please update your plan on the package page")}</p>
            </Modal.Section>
        </Modal>

        // 降级保留提示弹窗
        const DowngradeRetainModal = <DowngradeRetain
            level={userInfo.level}
            openState={retainOpenState}
            disBtnLoading={disBtnLoading}
            paidLoading={paidLoading}
            downgradeType={downgradeType}
            downgradeLevel={downgradeLevel || userInfo.level}
            isShowFeedback={isShowFeedback}
            downDataCompare={downDataCompare}
            coupon_claimed={coupon_claimed}
            closeSeeyouModal={this.closeSeeyouModal}
            applyDiscountCode={this.applyDiscountCode}
            downgradeAnyway={this.downgradeAnyway}
            closeInfoViewModal={this.closeInfoViewModal}
            sendSuggestionAction={this.sendSuggestionAction}
        />

        // 是否内嵌
        const isShopify = this.props.public.isShowTopMenu || 1;

        // 最终内容
        let pageContentLast = (this.state.loadingPage || diyBannerState === -1 || isActLoading) ? <SkeltonLoading /> :
            <Page
                title={Boolean(isShopify) ? <div className='flex_layout'>
                    <span>{t("Choose the plan that fits your needs.")}</span>
                    {/* 旧版价格 */}
                    {Boolean(old_button) ? <div className='pricing-box oldversion-pricing' onClick={() => {
                        utils.routeJump(this, "/oldversion/pricing")
                    }}>
                        <Button>{t("Switch to the old version")}</Button>
                    </div> : null}
                </div> : null}
            >
                <title>SEOWILL - Pricing</title>

                {/* 折扣横幅banner */}
                {DiscountBanner}
                <div className='pricing_row_opera'>
                    {/* 年月费Tab */}
                    {TabPlansBlock}

                    {/* 优惠券验证 */}
                    {CouponVerification}
                    {CouponVerificationModal}
                </div>

                {/* {
                    false && (Boolean(planName && planName.includes('新用户首次')) && !isShowCouponDis && diyBannerState) ? (
                        <div className='pricing_top_banner'>
                            <img src={'/imgs/user_guide/time_banner.png?v=12306'} alt='discount-banner' />
                            <div className='dis_banner_time'>
                                <div className='time_items'>
                                    <p className='time_val'>{cDays}</p>
                                    <span className='time_unit'>DAYS</span>
                                </div>
                                <div className='time_items'>
                                    <p className='time_val'>{cHours}</p>
                                    <span className='time_unit'>HOURS</span>
                                </div>
                                <div className='time_items'>
                                    <p className='time_val'>{cMins}</p>
                                    <span className='time_unit'>MINS</span>
                                </div>
                                <div className='time_items'>
                                    <p className='time_val'>{cSecs}</p>
                                    <span className='time_unit'>SECS</span>
                                </div>
                            </div>
                            <div className='close-time-banner' onClick={this.closeTimeBanner}><Icon source={CancelMajor} /></div>
                        </div>
                    ) : null
                } */}
                <div className={`pricing_main newLayoutPricing`}>
                    {/* {pricingTab} */}
                    <div style={{ marginTop: this.state.level === 1 ? '1.5rem' : (![8, 9].includes(userInfo.ppid) ? '1.5rem' : '3rem') }}></div>
                    <BlockStack gap={400}>
                        {pricingMealContent}
                        {/* {ExpertServiceBlock} */}
                        {chargeTipBanner}
                        {pricingDetailBtn}
                        {trustBrand}
                        {/* {questionBlock} */}
                        {FrequentlyItems}
                        {/* {ExclusiveDiscount} */}
                    </BlockStack>
                </div>
                {/* 升降级弹窗 */}
                {pageModal}
                {/* 切换套餐提示弹窗（年费扣费后使用时长 < 30 天） */}
                {switchReviewModal}
                {/* 降级弹窗 */}
                {freePlanDegrade}
                {degradeDiscountModal}
                {/* 一次性付费提示 */}
                {oldPayUserModal}
                {/* 降级保留提示弹窗 */}
                {DowngradeRetainModal}
                {/* 底部 */}
                {FooterHelpBox}
                {/* 福利弹窗 */}
                {ExtraGiftBox}
                {/* cw支付提示 */}
                {CWComboModal}
                {/* 成功应用挽留折扣弹窗 */}
                {SuccessApplyDiscountModal}
            </Page>

        return (
            <div className='Pricing' style={{ position: 'relative' }}>
                {pageContentLast}
            </div>
        );
    }

}

function getCookie(cookieName) {
    //获取所有的cookie "psw=1234we; rememberme=true; user=Annie"
    var totalCookie = document.cookie;
    //获取参数所在的位置
    var cookieStartAt = totalCookie.indexOf(cookieName + "=");
    //判断参数是否存在 不存在直接返回
    if (cookieStartAt === -1) {
        return;
    }
    //获取参数值的开始位置
    var valueStartAt = totalCookie.indexOf("=", cookieStartAt) + 1;
    //以;来获取参数值的结束位置
    var valueEndAt = totalCookie.indexOf(";", cookieStartAt);
    //如果没有;则是最后一位
    if (valueEndAt === -1) {
        valueEndAt = totalCookie.length;
    }
    //截取参数值的字符串
    var cookieValue = unescape(totalCookie.substring(valueStartAt, valueEndAt));
    return cookieValue;
}

// 格式化时间戳
function formatUSATime(time) {
    // 创建一个新的 Date 对象，传入时间戳（秒为单位）
    var date = new Date(time * 1000);

    // 定义月份名称
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // 提取年、月、日、小时、分钟、上午/下午
    var year = date.getFullYear();
    var month = monthNames[date.getMonth()];
    var day = date.getDate();
    // var hours = date.getHours();
    // var minutes = date.getMinutes();
    // var ampm = hours >= 12 ? 'pm' : 'am';

    // 将小时调整为 12 小时制
    // hours = hours % 12;
    // hours = hours ? hours : 12; // 如果 hours 为 0，则设为 12

    // 格式化分钟数为两位数
    // minutes = minutes < 10 ? '0' + minutes : minutes;

    // 组合成指定格式的字符串
    var formattedDate = t(month) + ' ' + (day < 10 ? '0' + day : day) + ', ' + year;
    return formattedDate;
}

// 获取剩余小时
function getRemainingHours(targetTimestamp) {
    const now = Date.now();
    const diff = targetTimestamp - now;

    if (diff <= 0) return 0;

    return Math.floor(diff / (1000 * 60 * 60)) + 1;
}

// 计算折扣后的价格
function multiplyPrice(price, factor) {
    // 把元转换为分并四舍五入为整数
    const cents = Math.round(price * 100);
    // 在分单位上计算并四舍五入到最接近的分
    const resultCents = Math.round(cents * factor);
    // 返回保留两位的字符串
    return (resultCents / 100).toFixed(2);
}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['pricingPlan', data]));
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 调用派遣 异步请求公共数据
    getPublicDataRedux(res) {
        // dispatch(fetchPublicData());
        dispatch(setPublicData(res));
    },
})

Pricing = connect(
    mapStateToProps,
    mapDispatchToProps
)(Pricing);

export default withWindowWidth(withRouter(Pricing));